/* One confirmed Shopify snapshot for all cart displays. */
(function () {
  if (window.toaCartState) return;
  const nativeFetch = window.fetch.bind(window);
  let revision = 0, pending = 0, snapshot = null, fetchedAt = 0, flight = null, timer;
  const waiters = [];
  const isMutation = (url, method) => method !== 'GET' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:[?#]|$)/.test(url);
  const replay = () => {
    if (snapshot && fetchedAt && !pending) document.dispatchEvent(new CustomEvent('toa:cart-confirmed', {detail:{cart:snapshot, revision}}));
  };
  const read = async () => {
    if (pending) { await new Promise(resolve => waiters.push(resolve)); return read(); }
    if (Date.now() < Number(window.__toaCartBlockedUntil || 0)) throw new Error('Warenkorb vorübergehend ausgelastet. Bitte kurz warten.');
    if (snapshot && Date.now() - fetchedAt < 1000) return snapshot;
    if (flight) return flight;
    const started = revision;
    const request = nativeFetch('/cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}})
      .then(async response => {
        if (response.status === 429) window.__toaCartBlockedUntil = Date.now() + Math.max(30, Number(response.headers.get('retry-after')) || 60) * 1000;
        if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden (' + response.status + ').');
        return response.json();
      });
    flight = request.then(cart => {
      flight = null;
      // A response that started before a write must never repaint newer values.
      if (started !== revision || pending) return read();
      if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error('Unvollständige Warenkorbdaten');
      snapshot = cart; fetchedAt = Date.now(); replay();
      return cart;
    }, error => { flight = null; throw error; });
    return flight;
  };
  const begin = () => { pending++; revision++; fetchedAt = 0; };
  const end = () => {
    pending--; fetchedAt = 0;
    if (!pending) {
      waiters.splice(0).forEach(resolve => resolve());
      clearTimeout(timer); timer = setTimeout(() => read().catch(() => {}), 120);
    }
  };
  window.toaCartState = {read, replay, get current(){return snapshot;}, get fresh(){return !!fetchedAt && !pending;}, get revision(){return revision;}, get pending(){return pending;}};
  window.fetch = function (input, options) {
    const url = String(input && input.url || input);
    const method = String(options?.method || input?.method || 'GET').toUpperCase();
    if (!isMutation(url, method)) return nativeFetch(input, options);
    begin();
    return nativeFetch(input, options).finally(end);
  };
  const open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__toaStateMutation = isMutation(String(url), String(method).toUpperCase());
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    if (!this.__toaStateMutation) return send.apply(this, arguments);
    begin(); let ended = false;
    const finish = () => { if (!ended) {ended = true; end();} };
    this.addEventListener('loadend', finish, {once:true});
    try { return send.apply(this, arguments); } catch(error) { finish(); throw error; }
  };
  window.addEventListener('pageshow', () => { fetchedAt = 0; read().catch(() => {}); });
})();

(function () {
  if (window.toaCartEnhancementsLoaded) return;
  window.toaCartEnhancementsLoaded = true;
  window.toaCartEnhancementsVersion = "20260724-shipping-estimate";

  var thresholdFallback = 6900;
  var discountThresholdFallback = 4900;
  var standardShippingEstimateCents = 649;
  var discountShippingEstimateCents = 349;
  var countdownKey = "toaCartCountdownUntil";
  var countdownDuration = 30 * 60 * 1000;
  var updateTimer = null;
  var trailingUpdateTimer = null;
  var finalUpdateTimer = null;
  var cartFetchSequence = 0;
  var cartAppliedSequence = 0;
  var storefrontQuantitySyncTimer = null;
  var mutationTimer = null;
  var cartMutationQueue = Promise.resolve();
  var keepDrawerOpenUntil = 0;
  var cartCloseGuardUntil = 0;
  var userClosedDrawer = false;
  var pendingCartHighlightVariant = "";
  var pendingCartHighlightUntil = 0;

  function estimatedDomesticShippingCents(shippingBasis) {
    if (shippingBasis >= thresholdFallback) return 0;
    if (shippingBasis >= discountThresholdFallback) return discountShippingEstimateCents;
    return standardShippingEstimateCents;
  }
  var lastFreeShippingProgress = null;
  var lastFreeShippingPackageLeft = null;

  function injectStyle() {
    if (document.getElementById("toa-cart-enhancement-style")) return;
    var style = document.createElement("style");
    style.id = "toa-cart-enhancement-style";
    style.textContent = [
      "@media (min-width: 900px) {",
      "  .cart-summary { width: min(575px, 42vw) !important; max-width: calc(100vw - 24px) !important; right: calc(-1 * min(575px, 42vw)) !important; }",
      "  .cart-summary .cart-summary-item__image { width: 104px !important; }",
      "  .cart-summary .cart-summary-item__image img, .cart-summary .cart-summary-item__image .rimage__image { width: 104px !important; max-width: 104px !important; }",
      "}",
      ".cart-summary.toa-cart-drawer-upgraded { --toa-drawer-green: #123f2a; --toa-drawer-red: #e30613; --toa-drawer-cream: #fff7eb; --toa-drawer-border: #ead9bf; background: linear-gradient(180deg,#fffaf2 0%,#fff7eb 56%,#fffdf8 100%) !important; color: var(--toa-drawer-green) !important; }",
      "body.toa-cart-close-guard .cart-summary, html.toa-cart-close-guard body .cart-summary { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; transform: translate3d(110%,0,0) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__header { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__close { display: none !important; }",
      ".toa-cart-drawer-topbar { position: sticky !important; top: 0 !important; z-index: 2147483647 !important; display: flex; align-items: center; justify-content: space-between; gap: 14px; padding: 14px 22px 6px; color: var(--toa-drawer-green); pointer-events: auto !important; background: linear-gradient(180deg,#fffaf2 0%,rgba(255,250,242,.96) 78%,rgba(255,250,242,0) 100%); isolation: isolate; }",
      ".toa-cart-drawer-back, .toa-cart-drawer-close { position: relative; z-index: 2147483647; appearance: none; border: 0; background: transparent; color: var(--toa-drawer-green); display: inline-flex; align-items: center; justify-content: center; cursor: pointer; pointer-events: auto !important; touch-action: manipulation; -webkit-tap-highlight-color: transparent; }",
      ".toa-cart-drawer-back > *, .toa-cart-drawer-close > * { pointer-events: none !important; }",
      ".toa-cart-drawer-back { gap: 10px; min-height: 52px; padding: 0 12px 0 0; font-size: 20px; font-weight: 750; letter-spacing: 0; }",
      ".toa-cart-drawer-close { width: 44px; height: 44px; padding: 0; border-radius: 999px; }",
      ".toa-cart-drawer-back svg, .toa-cart-drawer-close svg, .toa-cart-products-heading svg, .toa-cart-trust-line svg { width: 25px; height: 25px; stroke: currentColor; stroke-width: 2.25; fill: none; stroke-linecap: round; stroke-linejoin: round; }",
      ".toa-cart-drawer-close:hover, .toa-cart-drawer-close:focus-visible, .toa-cart-drawer-back:hover, .toa-cart-drawer-back:focus-visible { color: #0b2f20; outline: none; }",
      ".toa-cart-drawer-brand { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 11px; padding: 2px 20px 16px; text-align: center; color: var(--toa-drawer-green); }",
      ".toa-cart-drawer-brand img { width: clamp(112px, 26vw, 152px); height: clamp(112px, 26vw, 152px); border-radius: 999px; object-fit: contain; display: block; filter: drop-shadow(0 12px 22px rgba(18,63,42,.13)); }",
      ".toa-cart-drawer-brand span { font-size: clamp(16px, 2.6vw, 20px); line-height: 1.25; font-weight: 650; letter-spacing: 0; }",
      ".toa-cart-products-heading { width: calc(100% - 32px); margin: 18px 16px 12px; padding: 0; min-height: 52px; border: 0; background: transparent; color: #102f22; display: flex; align-items: center; justify-content: space-between; gap: 14px; cursor: pointer; font-size: clamp(18px, 2.7vw, 22px); font-weight: 760; text-align: left; }",
      ".toa-cart-products-heading svg { width: 24px; height: 24px; transition: transform .18s ease; }",
      ".cart-summary.toa-products-collapsed .toa-cart-products-heading svg { transform: rotate(180deg); }",
      ".cart-summary.toa-products-collapsed .toa-cart-products-list { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list { display: grid !important; gap: 14px !important; padding: 0 16px 18px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item { background: rgba(255,255,255,.92) !important; border: 1px solid rgba(234,217,191,.95) !important; border-radius: 22px !important; box-shadow: 0 14px 34px rgba(70,46,19,.08) !important; padding: 16px !important; color: #122f23 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: clamp(92px, 24vw, 120px) !important; min-width: clamp(92px, 24vw, 120px) !important; align-self: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image img, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image .rimage__image { width: 100% !important; max-width: 120px !important; height: auto !important; object-fit: contain !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__title, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item a[href*='/products'] { color: #122f23 !important; font-size: clamp(16px, 2.7vw, 20px) !important; line-height: 1.23 !important; font-weight: 750 !important; text-decoration: none !important; letter-spacing: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__price, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item .amount, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__final-price { color: #122f23 !important; font-size: clamp(17px, 2.7vw, 20px) !important; font-weight: 850 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 44px !important; height: 44px !important; min-width: 44px !important; border-radius: 999px !important; border: 1px solid rgba(227,6,19,.28) !important; background: rgba(255,250,250,.95) !important; color: var(--toa-drawer-red) !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; padding: 0 !important; text-decoration: none !important; box-shadow: 0 8px 18px rgba(227,6,19,.08) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button svg { width: 20px; height: 20px; stroke: currentColor; stroke-width: 2.15; fill: none; stroke-linecap: round; stroke-linejoin: round; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button:hover, .cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button:focus-visible { background: rgba(227,6,19,.08) !important; border-color: rgba(227,6,19,.48) !important; outline: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-height: 46px !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; border: 1px solid rgba(234,217,191,.95) !important; border-radius: 999px !important; background: #fffdf8 !important; overflow: hidden !important; box-shadow: inset 0 1px 0 rgba(255,255,255,.9) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill button, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster button, .cart-summary.toa-cart-drawer-upgraded .quantity button, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity button { width: 46px !important; height: 46px !important; border: 0 !important; background: #f2f5ed !important; color: var(--toa-drawer-green) !important; font-size: 24px !important; font-weight: 800 !important; display: inline-flex !important; align-items: center !important; justify-content: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill input, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster input, .cart-summary.toa-cart-drawer-upgraded .quantity input, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity input { min-width: 54px !important; height: 46px !important; border: 0 !important; background: transparent !important; color: #102f22 !important; font-size: 18px !important; font-weight: 750 !important; text-align: center !important; box-shadow: none !important; }",
      ".toa-native-products-heading, .cart-summary.toa-cart-drawer-upgraded .toa-native-products-heading, .cart-summary.toa-cart-drawer-upgraded .toa-native-products-heading * { display: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-heading { margin: 22px 18px 16px !important; min-height: 58px !important; font-size: clamp(24px, 5vw, 34px) !important; font-weight: 950 !important; letter-spacing: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-heading svg { width: 31px !important; height: 31px !important; stroke-width: 2.55 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list { gap: 18px !important; padding: 0 18px 20px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container { background: linear-gradient(135deg,#fffefa 0%,#fff8ed 100%) !important; border: 1px solid rgba(234,217,191,.98) !important; border-radius: 26px !important; box-shadow: 0 18px 44px rgba(70,46,19,.11), inset 0 1px 0 rgba(255,255,255,.92) !important; padding: 18px !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item-container > .cart-summary-item { background: transparent !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; padding: 0 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list > .cart-summary-item { background: linear-gradient(135deg,#fffefa 0%,#fff8ed 100%) !important; border: 1px solid rgba(234,217,191,.98) !important; border-radius: 26px !important; box-shadow: 0 18px 44px rgba(70,46,19,.11), inset 0 1px 0 rgba(255,255,255,.92) !important; padding: 18px !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item { display: grid !important; grid-template-columns: minmax(104px,132px) minmax(0,1fr) auto !important; gap: 18px !important; align-items: center !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: clamp(104px, 25vw, 132px) !important; min-width: clamp(104px, 25vw, 132px) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image img, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image .rimage__image { max-width: 132px !important; max-height: 132px !important; object-fit: contain !important; filter: drop-shadow(0 12px 16px rgba(18,63,42,.1)); }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__title, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item a[href*='/products'] { font-size: clamp(18px,3.4vw,25px) !important; line-height: 1.16 !important; font-weight: 900 !important; color: #102f22 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item__price, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item .amount, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__final-price { font-size: clamp(24px,5vw,34px) !important; line-height: 1 !important; font-weight: 950 !important; color: #242424 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary-item [class*='unit'], .cart-summary.toa-cart-drawer-upgraded .cart-summary-item [class*='base'], .cart-summary.toa-cart-drawer-upgraded .cart-summary-item small { color: rgba(18,47,35,.66) !important; font-size: clamp(14px,2.8vw,18px) !important; font-weight: 520 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 52px !important; height: 52px !important; min-width: 52px !important; border: 2px solid rgba(227,6,19,.36) !important; background: radial-gradient(circle at 50% 35%,#fff 0%,#fff8f3 100%) !important; box-shadow: 0 12px 24px rgba(227,6,19,.12) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button svg { width: 25px !important; height: 25px !important; stroke-width: 2.45 !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-width: 172px !important; min-height: 54px !important; border: 2px solid rgba(234,217,191,1) !important; background: linear-gradient(180deg,#fffefa,#fff8ee) !important; box-shadow: 0 10px 20px rgba(70,46,19,.08), inset 0 1px 0 rgba(255,255,255,.95) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill button, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster button, .cart-summary.toa-cart-drawer-upgraded .quantity button, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity button { width: 56px !important; height: 54px !important; background: rgba(242,245,237,.96) !important; font-size: 28px !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill input, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster input, .cart-summary.toa-cart-drawer-upgraded .quantity input, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity input { height: 54px !important; min-width: 60px !important; font-size: 23px !important; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded .cart-summary-item { grid-template-columns: 112px minmax(0,1fr) !important; gap: 14px !important; } .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__image { width: 112px !important; min-width: 112px !important; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-remove-button { width: 48px !important; height: 48px !important; min-width: 48px !important; justify-self: end !important; } .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill, .cart-summary.toa-cart-drawer-upgraded .qty-adjuster, .cart-summary.toa-cart-drawer-upgraded .quantity, .cart-summary.toa-cart-drawer-upgraded .cart-summary-item__quantity { min-width: 156px !important; } }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button), .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill:has(.toa-cart-remove-button) { min-width: 0 !important; width: auto !important; border: 0 !important; border-radius: 0 !important; background: transparent !important; box-shadow: none !important; overflow: visible !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__down { border: 0 !important; border-radius: 0 !important; background: #f2f5ed !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__value { border: 0 !important; background: #fff !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .qty-adjuster__up { border: 0 !important; border-radius: 0 !important; background: #fff !important; box-shadow: none !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .toa-cart-remove-button { margin-left: 12px !important; width: 52px !important; height: 52px !important; min-width: 52px !important; border-radius: 12px !important; border: 2px solid rgba(227,6,19,.32) !important; background: #fffaf7 !important; color: var(--toa-drawer-red) !important; box-shadow: none !important; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button), .cart-summary.toa-cart-drawer-upgraded .toa-cart-qty-pill:has(.toa-cart-remove-button) { min-width: 0 !important; } .cart-summary.toa-cart-drawer-upgraded .qty-adjuster:has(.toa-cart-remove-button) .toa-cart-remove-button { width: 48px !important; height: 48px !important; min-width: 48px !important; margin-left: 10px !important; } }",
      ".cart-summary.toa-cart-drawer-upgraded .cart-summary__button-row, .cart-summary.toa-cart-drawer-upgraded .cart-summary__buttons { position: sticky !important; bottom: 0 !important; z-index: 20 !important; padding: 12px 16px 10px !important; background: linear-gradient(180deg,rgba(255,247,235,0),#fff7eb 22%,#fff7eb 100%) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized { width: 100% !important; min-height: 58px !important; border-radius: 13px !important; background: linear-gradient(135deg,#123f2a,#225f35) !important; color: #fff !important; border: 0 !important; box-shadow: 0 13px 26px rgba(18,63,42,.22) !important; font-size: clamp(18px, 3vw, 22px) !important; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized::before { content: ''; width: 22px; height: 22px; flex: 0 0 22px; background: currentColor; opacity: .92; -webkit-mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E\") center/contain no-repeat; mask: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='11' width='18' height='11' rx='2'/%3E%3Cpath d='M7 11V7a5 5 0 0 1 10 0v4'/%3E%3C/svg%3E\") center/contain no-repeat; }",
      ".cart-summary.toa-cart-drawer-upgraded .toa-checkout-totalized::after { content: '\\2192'; margin-left: auto; padding-right: 4px; font-size: 28px; font-weight: 500; }",
      ".cart-summary.toa-cart-is-empty .toa-checkout-totalized, .cart-summary.toa-cart-is-empty [data-toa-cart-trust-line], .cart-summary [data-toa-empty-checkout-hidden='true'], #cartform [data-toa-empty-checkout-hidden='true'] { display: none !important; }",
      ".toa-cart-trust-line { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 0 16px 16px; color: #315c3b; font-size: 14px; font-weight: 650; }",
      ".toa-cart-trust-line svg { width: 21px; height: 21px; }",
      "@media (max-width: 749px) { .cart-summary.toa-cart-drawer-upgraded { width: min(94vw, 560px) !important; max-width: calc(100vw - 10px) !important; border-radius: 28px 0 0 28px !important; } .toa-cart-drawer-topbar { min-height: 68px; padding: max(10px, env(safe-area-inset-top)) 14px 8px 18px !important; } .toa-cart-drawer-back { min-width: 210px; min-height: 56px; font-size: 19px; justify-content: flex-start; } .toa-cart-drawer-close { width: 54px; height: 54px; margin-right: -4px; } }",
      "@media (max-width: 749px) {",
      "  body.show-cart-summary .toa-mobile-shop-shell, html.show-cart-summary body .toa-mobile-shop-shell, body.show-cart-summary .toa-mobile-quick-actions, html.show-cart-summary body .toa-mobile-quick-actions { display: none !important; visibility: hidden !important; pointer-events: none !important; }",
      "  .cart-summary.toa-cart-drawer-upgraded { overflow-y: auto !important; overflow-x: hidden !important; overscroll-behavior: contain !important; -webkit-overflow-scrolling: touch !important; padding-bottom: max(28px, env(safe-area-inset-bottom)) !important; }",
      "  .cart-summary.toa-cart-drawer-upgraded .cart-summary__inner { min-height: auto !important; overflow: visible !important; padding-bottom: 24px !important; }",
      "  .cart-summary.toa-cart-drawer-upgraded .cart-summary__button-row, .cart-summary.toa-cart-drawer-upgraded .cart-summary__buttons { position: static !important; inset: auto !important; margin: 10px 16px 12px !important; padding: 12px !important; border: 1px solid rgba(18,63,42,.14) !important; border-radius: 18px !important; background: rgba(255,255,255,.92) !important; box-shadow: 0 12px 30px rgba(18,63,42,.08) !important; }",
      "  .cart-summary.toa-cart-drawer-upgraded .toa-cart-products-heading { scroll-margin-top: 78px !important; }",
      "  .cart-summary.toa-cart-drawer-upgraded .toa-cart-products-list { padding-bottom: 10px !important; }",
      "}",
      "body.show-cart-summary .cart-summary, html.show-cart-summary body .cart-summary, body.product-added-to-cart .cart-summary.active { display: block !important; position: fixed !important; top: 0 !important; left: auto !important; right: 0 !important; bottom: 0 !important; height: 100vh !important; transform: translate3d(0,0,0) !important; opacity: 1 !important; visibility: visible !important; pointer-events: auto !important; z-index: 2147483646 !important; }",
      "body.show-cart-summary #page-overlay, body.show-cart-summary .page-overlay { z-index: 2147483640 !important; }",
      ".toa-cart-limit-toast { position: fixed; top: 88px; right: 24px; z-index: 999999; max-width: min(360px, calc(100vw - 32px)); padding: 13px 16px; border-radius: 10px; background: #fff4e0; color: #173b28; border: 1px solid #f1b45d; box-shadow: 0 14px 36px rgba(23,59,40,0.18); font-weight: 800; line-height: 1.28; opacity: 0; transform: translateY(-8px); pointer-events: none; transition: opacity .18s ease, transform .18s ease; }",
      ".toa-cart-limit-toast.is-visible { opacity: 1; transform: translateY(0); }",
      ".cart-summary.toa-cart-limit-flash { animation: toaCartLimitFlash .9s ease; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse, .cart-summary .cart-summary-item.toa-cart-item-pulse { position: relative; overflow: hidden; isolation: isolate; animation: toaCartItemPulse 1.9s cubic-bezier(.18,.82,.22,1) both; border-radius: 16px; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse::before, .cart-summary .cart-summary-item.toa-cart-item-pulse::before { content: ''; position: absolute; inset: 4px; z-index: 0; pointer-events: none; border-radius: 14px; background: radial-gradient(circle at 16% 18%, rgba(255,255,255,.86), rgba(255,255,255,0) 34%), linear-gradient(105deg, rgba(255,250,238,.95), rgba(245,252,240,.98) 52%, rgba(255,244,210,.93)); box-shadow: inset 0 0 0 1px rgba(204,165,70,.42); opacity: 0; animation: toaCartItemWash 1.85s ease both; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse::after, .cart-summary .cart-summary-item.toa-cart-item-pulse::after { content: ''; position: absolute; top: 0; bottom: 0; left: -42%; width: 42%; z-index: 1; pointer-events: none; background: linear-gradient(105deg, rgba(255,255,255,0), rgba(255,255,255,.68), rgba(255,225,150,.34), rgba(255,255,255,0)); filter: blur(.3px); transform: skewX(-12deg) translateX(-115%); animation: toaCartItemSweep 1.22s ease .16s both; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse > *, .cart-summary .cart-summary-item.toa-cart-item-pulse > * { position: relative; z-index: 2; }",
      ".cart-summary .cart-summary-item-container.toa-cart-item-pulse .cart-summary-item__image, .cart-summary .cart-summary-item.toa-cart-item-pulse .cart-summary-item__image { animation: toaCartImagePop 1.15s cubic-bezier(.18,.82,.22,1) both; }",
      ".toa-cart-confirm-badge { position: absolute; top: 10px; right: 12px; z-index: 4; display: inline-flex; align-items: center; gap: 6px; padding: 6px 10px; border-radius: 999px; background: linear-gradient(135deg,#173b28,#285f3b); color: #fff; border: 1px solid rgba(226,184,79,.7); box-shadow: 0 10px 22px rgba(23,59,40,.22); font-size: 12px; font-weight: 900; letter-spacing: 0; white-space: nowrap; pointer-events: none; animation: toaCartBadgeIn 1.9s ease both; }",
      ".toa-cart-confirm-badge::before { content: '+'; width: 18px; height: 18px; border-radius: 999px; display: inline-flex; align-items: center; justify-content: center; background: #f4c95d; color: #173b28; font-weight: 1000; box-shadow: inset 0 -1px 0 rgba(0,0,0,.12); }",
      ".cart-summary .cart-summary__subtotal > .cart-summary__subtotal-label, .cart-summary .cart-summary__subtotal > .amount { display: none !important; }",
      ".cart-summary .cart-summary__subtotal:not(:has(.cart-discount-list)) { display: none !important; }",
      ".cart-subtotal { display: none !important; }",
      ".toa-checkout-totalized { display: inline-flex !important; align-items: center !important; justify-content: center !important; gap: 8px !important; white-space: nowrap !important; }",
      ".toa-checkout-totalized .toa-checkout-button-label { font-weight: 900; }",
      ".toa-checkout-totalized .toa-checkout-button-separator { opacity: .72; font-weight: 900; }",
      ".toa-checkout-totalized .toa-checkout-button-total { font-weight: 1000; }",
      ".toa-shipping-estimate { display: grid; gap: 7px; width: 100%; margin: 0 0 12px; padding: 12px 14px; border: 1px solid rgba(18,63,42,.16); border-radius: 10px; background: rgba(255,255,255,.88); color: #173b28; box-sizing: border-box; }",
      ".toa-shipping-estimate__row { display: flex; align-items: baseline; justify-content: space-between; gap: 14px; font-size: 14px; line-height: 1.28; }",
      ".toa-shipping-estimate__row span { min-width: 0; }",
      ".toa-shipping-estimate__row strong { flex: 0 0 auto; color: #102f22; font-weight: 850; white-space: nowrap; }",
      ".toa-shipping-estimate__row--total { margin-top: 2px; padding-top: 8px; border-top: 1px solid rgba(18,63,42,.14); font-size: 16px; }",
      ".toa-shipping-estimate__row--total strong { font-size: 18px; }",
      ".toa-shipping-estimate__note { color: rgba(18,47,35,.72); font-size: 12px; line-height: 1.32; }",
      ".toa-shipping-estimate.is-free [data-toa-estimated-shipping] { color: #16723a; }",
      ".cart-summary.toa-cart-is-empty [data-toa-shipping-estimate], #cartform [data-toa-shipping-estimate][data-toa-empty-checkout-hidden='true'] { display: none !important; }",
      "@media (max-width: 520px) { .toa-cart-confirm-badge { top: 8px; right: 8px; font-size: 11px; padding: 5px 8px; } }",
      "@media (max-width: 520px) { .toa-checkout-totalized { gap: 6px !important; } .toa-shipping-estimate { padding: 11px 12px; } .toa-shipping-estimate__row { font-size: 13px; } .toa-shipping-estimate__row--total { font-size: 15px; } .toa-shipping-estimate__row--total strong { font-size: 17px; } }",
      "@keyframes toaCartLimitFlash { 0%,100% { box-shadow: none; } 20%,70% { box-shadow: 0 0 0 4px rgba(218,42,42,.18), 0 0 0 9999px rgba(23,59,40,.05); } }",
      "@keyframes toaCartItemPulse { 0% { box-shadow: none; transform: translateX(0) scale(1); } 16% { box-shadow: 0 18px 42px rgba(23,59,40,.17), 0 0 0 1px rgba(212,169,70,.48); transform: translateX(-2px) scale(1.012); } 58% { box-shadow: 0 12px 26px rgba(23,59,40,.10), 0 0 0 1px rgba(31,112,68,.18); transform: translateX(0) scale(1); } 100% { box-shadow: none; transform: translateX(0) scale(1); } }",
      "@keyframes toaCartItemWash { 0% { opacity: 0; transform: scale(.985); } 12% { opacity: 1; transform: scale(1); } 72% { opacity: .94; } 100% { opacity: 0; transform: scale(1.006); } }",
      "@keyframes toaCartItemSweep { 0% { transform: skewX(-12deg) translateX(-115%); opacity: 0; } 18% { opacity: 1; } 100% { transform: skewX(-12deg) translateX(360%); opacity: 0; } }",
      "@keyframes toaCartImagePop { 0% { transform: scale(.96); filter: saturate(1); } 22% { transform: scale(1.055); filter: saturate(1.08) drop-shadow(0 8px 12px rgba(23,59,40,.16)); } 100% { transform: scale(1); filter: saturate(1); } }",
      "@keyframes toaCartBadgeIn { 0% { opacity: 0; transform: translateY(-6px) scale(.92); } 12%,64% { opacity: 1; transform: translateY(0) scale(1); } 100% { opacity: 0; transform: translateY(-3px) scale(.97); } }"
    ].join("\n");
    document.head.appendChild(style);
  }

  function getCountdownEnd() {
    var end = 0;
    try {
      end = Number(window.localStorage && window.localStorage.getItem(countdownKey));
    } catch (error) {}
    if (!end) {
      end = Date.now() + countdownDuration;
      try {
        window.localStorage.setItem(countdownKey, String(end));
      } catch (error) {}
    }
    return end;
  }

  function restartCountdown() {
    try {
      window.localStorage.setItem(countdownKey, String(Date.now() + countdownDuration));
    } catch (error) {}
    renderCountdown();
  }

  function renderCountdown() {
    var lines = document.querySelectorAll("[data-toa-cart-countdown-line]");
    var nodes = document.querySelectorAll("[data-toa-cart-countdown]");
    if (!nodes.length && !lines.length) return;
    var rawLeft = getCountdownEnd() - Date.now();
    var left = Math.max(0, rawLeft);
    var expired = rawLeft <= 0;
    var minutes = Math.floor(left / 60000);
    var seconds = Math.floor((left % 60000) / 1000);
    var text = String(minutes).padStart(2, "0") + ":" + String(seconds).padStart(2, "0") + " Minuten";
    lines.forEach(function (line) {
      if (expired) {
        line.textContent = "Dein Warenkorb ist weiterhin für dich bereit.";
        return;
      }
      if (!line.querySelector("[data-toa-cart-countdown]")) {
        line.innerHTML = "Dein Warenkorb liegt noch <strong data-toa-cart-countdown></strong> für dich bereit.";
      }
      var node = line.querySelector("[data-toa-cart-countdown]");
      if (node) node.textContent = text;
    });
    if (!lines.length) {
      nodes.forEach(function (node) {
        node.textContent = expired ? "weiterhin verfügbar" : text;
      });
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR"
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2).replace(".", ",") + " €";
    }
  }

  function setCheckoutButtonTotal(button, totalText) {
    if (!button) return;
    var fullLabel = "Zur Kasse \u2013 " + totalText;
    if (button.tagName === "INPUT") {
      button.value = fullLabel;
      button.setAttribute("aria-label", fullLabel);
      return;
    }
    if (button.getAttribute("data-toa-checkout-total") === totalText) return;
    button.setAttribute("data-toa-checkout-total", totalText);
    button.setAttribute("aria-label", fullLabel);
    button.setAttribute("title", "Voraussichtlicher Gesamtpreis: " + totalText);
    button.classList.add("toa-checkout-totalized");
    button.textContent = "";
    var label = document.createElement("span");
    label.className = "toa-checkout-button-label";
    label.textContent = "Zur Kasse";
    var separator = document.createElement("span");
    separator.className = "toa-checkout-button-separator";
    separator.textContent = "\u2013";
    var total = document.createElement("span");
    total.className = "toa-checkout-button-total";
    total.textContent = totalText;
    button.appendChild(label);
    button.appendChild(separator);
    button.appendChild(total);
  }

  function ensureShippingEstimate(button, cart) {
    if (!button || !button.parentElement || !cart || typeof cart.total_price !== "number") return;
    var host = button.parentElement;
    var estimate = host.querySelector("[data-toa-shipping-estimate]");
    if (!estimate) {
      estimate = document.createElement("div");
      estimate.className = "toa-shipping-estimate";
      estimate.setAttribute("data-toa-shipping-estimate", "true");
      estimate.setAttribute("aria-label", "Voraussichtliche Bestellsumme");
      estimate.innerHTML = [
        "<div class='toa-shipping-estimate__row'><span>Warenwert</span><strong data-toa-estimated-subtotal></strong></div>",
        "<div class='toa-shipping-estimate__row'><span>Voraussichtlicher DHL-Versand (Deutschland)</span><strong data-toa-estimated-shipping></strong></div>",
        "<div class='toa-shipping-estimate__row toa-shipping-estimate__row--total'><span>Voraussichtlicher Gesamtpreis</span><strong data-toa-estimated-total></strong></div>",
        "<small class='toa-shipping-estimate__note'>Die endgültigen Versandkosten werden nach Eingabe der Lieferadresse im Checkout berechnet.</small>"
      ].join("");
      host.insertBefore(estimate, button);
    }
    var shippingBasis = cartFreeShippingBasis(cart);
    var shippingCents = estimatedDomesticShippingCents(shippingBasis);
    var subtotalNode = estimate.querySelector("[data-toa-estimated-subtotal]");
    var shippingNode = estimate.querySelector("[data-toa-estimated-shipping]");
    var totalNode = estimate.querySelector("[data-toa-estimated-total]");
    if (subtotalNode) subtotalNode.textContent = formatMoney(cart.total_price);
    if (shippingNode) shippingNode.textContent = shippingCents > 0 ? formatMoney(shippingCents) : "Kostenlos";
    if (totalNode) totalNode.textContent = formatMoney(cart.total_price + shippingCents);
    estimate.classList.toggle("is-free", shippingCents === 0);
  }

  function isPfandCartItem(item) {
    if (!item) return false;
    var text = [
      item.title,
      item.product_title,
      item.variant_title,
      item.product_type,
      item.handle,
      item.url
    ].join(" ").toLowerCase();
    var properties = item.properties || {};
    var productType = String(item.product_type || "").toLowerCase();
    var propertyText = "";
    try {
      propertyText = JSON.stringify(properties).toLowerCase();
    } catch (error) {
      propertyText = "";
    }
    return !!(
      properties._toa_pfand_auto ||
      propertyText.indexOf("_toa_pfand_auto") !== -1 ||
      text.indexOf("pfand-fuer-flaschen-dosen") !== -1 ||
      text.indexOf("0-25-pfand") !== -1 ||
      productType === "pfand" ||
      (text.indexOf("pfand") !== -1 && (text.indexOf("flaschen") !== -1 || text.indexOf("dosen") !== -1))
    );
  }

  function cartLinePrice(item) {
    if (!item) return 0;
    return Number(item.final_line_price || item.line_price || item.original_line_price || 0) || 0;
  }

  function cartPfandTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (!isPfandCartItem(item)) return total;
      return total + cartLinePrice(item);
    }, 0);
  }

  function cartNonPfandTotal(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (total, item) {
      if (isPfandCartItem(item)) return total;
      return total + cartLinePrice(item);
    }, 0);
  }

  function cartFreeShippingBasis(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return Math.max(0, cartNonPfandTotal(cart));
  }

  function cartHasOnlyPfand(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var activeItems = cart.items.filter(function (item) {
      return Number(item && item.quantity || 0) > 0;
    });
    return activeItems.length > 0 && activeItems.every(isPfandCartItem);
  }

  function cartForCustomerDisplay(cart) {
    if (!cartHasOnlyPfand(cart)) return cart;
    return Object.assign({}, cart, {
      items: [],
      item_count: 0,
      total_price: 0
    });
  }

  function cartIsEmpty(cart) {
    if (cart && Array.isArray(cart.items)) {
      if (cartHasOnlyPfand(cart)) return true;
      return !cart.items.some(function (item) {
        return Number(item && item.quantity) > 0;
      });
    }
    if (cart && typeof cart.item_count === "number") return cart.item_count <= 0;
    var drawer = getCartDrawer();
    if (!drawer) return false;
    return !drawer.querySelector(".cart-summary-item, .cart-summary-item-container, .ajaxcart__product");
  }

  function setEmptyHidden(node, hidden) {
    if (!node) return;
    if (hidden) {
      if (node.style && node.getAttribute("data-toa-empty-checkout-hidden") !== "true") {
        node.setAttribute("data-toa-empty-prev-display", node.style.getPropertyValue("display") || "");
        node.setAttribute("data-toa-empty-prev-display-priority", node.style.getPropertyPriority("display") || "");
      }
      if (node.style) node.style.setProperty("display", "none", "important");
      node.setAttribute("data-toa-empty-checkout-hidden", "true");
      node.setAttribute("aria-hidden", "true");
      if (node.matches && node.matches("button, input")) {
        if (!node.disabled) node.setAttribute("data-toa-empty-disabled-by-script", "true");
        node.disabled = true;
      }
      return;
    }
    if (node.getAttribute("data-toa-empty-checkout-hidden") === "true") {
      node.removeAttribute("data-toa-empty-checkout-hidden");
      node.removeAttribute("aria-hidden");
      if (node.style && node.hasAttribute("data-toa-empty-prev-display")) {
        var previousDisplay = node.getAttribute("data-toa-empty-prev-display") || "";
        var previousPriority = node.getAttribute("data-toa-empty-prev-display-priority") || "";
        if (previousDisplay) node.style.setProperty("display", previousDisplay, previousPriority);
        else node.style.removeProperty("display");
      }
      node.removeAttribute("data-toa-empty-prev-display");
      node.removeAttribute("data-toa-empty-prev-display-priority");
    }
    if (node.getAttribute("data-toa-empty-disabled-by-script") === "true") {
      node.disabled = false;
      node.removeAttribute("data-toa-empty-disabled-by-script");
    }
  }

  function setEmptyCartCheckoutState(cart) {
    var empty = cartIsEmpty(cart);
    var drawer = getCartDrawer();
    if (drawer) drawer.classList.toggle("toa-cart-is-empty", empty);
    var scopes = [];
    if (drawer) scopes.push(drawer);
    var cartForm = document.getElementById("cartform");
    if (cartForm) scopes.push(cartForm);
    var controlSelector = [
      "button[name='checkout']",
      "input[name='checkout']",
      "a[href*='/checkout']"
    ].join(",");
    var seenContainers = [];
    scopes.forEach(function (scope) {
      scope.querySelectorAll(controlSelector).forEach(function (control) {
        setEmptyHidden(control, empty);
        var container = control.closest(".cart-summary__button-row, .cart-summary__buttons");
        if (container && seenContainers.indexOf(container) === -1) {
          seenContainers.push(container);
          setEmptyHidden(container, empty);
        }
      });
      scope.querySelectorAll("[data-toa-cart-trust-line], [data-toa-shipping-estimate]").forEach(function (node) {
        setEmptyHidden(node, empty);
      });
    });
    document.querySelectorAll("[data-toa-cart-panel]").forEach(function (panel) {
      if (panel.closest(".toa-pfand-cart-line, [data-toa-pfand-line], [data-toa-pfand-fallback]")) return;
      setEmptyHidden(panel, empty);
    });
  }

  function updateCheckoutButtons(cart) {
    if (!cart || typeof cart.total_price !== "number") return;
    if (cartIsEmpty(cart)) {
      setEmptyCartCheckoutState(cart);
      return;
    }
    var shippingBasis = cartFreeShippingBasis(cart);
    var shippingCents = estimatedDomesticShippingCents(shippingBasis);
    var totalText = formatMoney(cart.total_price + shippingCents);
    var selector = [
      ".cart-summary button[name='checkout']",
      ".cart-summary input[name='checkout']",
      ".cart-summary a[href*='/checkout']",
      "#cartform button[name='checkout']",
      "#cartform input[name='checkout']",
      "#cartform a[href*='/checkout']",
      "form[action*='/cart'] button[name='checkout']",
      "form[action*='/cart'] input[name='checkout']",
      "button[name='checkout']",
      "input[name='checkout']",
      "a[href*='/checkout']"
    ].join(",");
    var seen = [];
    document.querySelectorAll(selector).forEach(function (button) {
      if (seen.indexOf(button) !== -1) return;
      seen.push(button);
      setCheckoutButtonTotal(button, totalText);
      ensureShippingEstimate(button, cart);
    });
    setEmptyCartCheckoutState(cart);
  }

  function toaCartIcon(name) {
    var paths = {
      back: "<path d='M15 18l-6-6 6-6'/>",
      close: "<path d='M18 6 6 18'/><path d='m6 6 12 12'/>",
      chevron: "<path d='m6 15 6-6 6 6'/>",
      trash: "<path d='M3 6h18'/><path d='M8 6V4h8v2'/><path d='M19 6l-1 14H6L5 6'/><path d='M10 11v5'/><path d='M14 11v5'/>",
      shield: "<path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'/><path d='m9 12 2 2 4-5'/>"
    };
    return "<svg viewBox='0 0 24 24' aria-hidden='true' focusable='false'>" + (paths[name] || "") + "</svg>";
  }

  function getCartDrawer() {
    return document.querySelector(".cart-summary");
  }

  function closeCartDrawerFromControl(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    }
    allowCartDrawerClose();
  }

  function inlineCartDrawerClose(event) {
    closeCartDrawerFromControl(event);
    return false;
  }

  window.toaCartDrawerInlineClose = inlineCartDrawerClose;

  function attachDrawerCloseControl(control) {
    if (!control || control.getAttribute("data-toa-drawer-close-ready") === "true") return;
    control.setAttribute("data-toa-drawer-close", "true");
    control.setAttribute("data-toa-drawer-close-ready", "true");
    ["click"].forEach(function (type) {
      try {
        control.addEventListener(type, closeCartDrawerFromControl, { capture: true, passive: false });
      } catch (error) {
        control.addEventListener(type, closeCartDrawerFromControl, true);
      }
    });
  }

  function isDrawerContinueControl(node) {
    if (!node || !node.closest) return false;
    var drawer = node.closest(".cart-summary");
    if (!drawer) return false;
    var control = node.closest("button, a, [role='button'], [data-toa-drawer-close]");
    if (!control || !drawer.contains(control)) return false;
    if (control.hasAttribute("data-toa-drawer-close")) return true;
    var text = (control.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    return text === "weitershoppen" ||
      text === "weiter shoppen" ||
      text === "weiter einkaufen" ||
      text.indexOf("weitershoppen") !== -1 ||
      text.indexOf("weiter shoppen") !== -1 ||
      text.indexOf("weiter einkaufen") !== -1;
  }

  function ensureDrawerTopbar(drawer) {
    if (!drawer) return;
    var topbar = drawer.querySelector("[data-toa-drawer-topbar]");
    if (topbar) {
      if (drawer.firstElementChild !== topbar) drawer.insertBefore(topbar, drawer.firstChild);
      return;
    }
    topbar = document.createElement("div");
    topbar.className = "toa-cart-drawer-topbar";
    topbar.setAttribute("data-toa-drawer-topbar", "true");
    var continueHref = String((window.location.pathname || "/") + (window.location.search || "") + (window.location.hash || "")).replace(/'/g, "%27");
    var inlineCloseAttrs = " onclick='return window.toaCartDrawerInlineClose ? window.toaCartDrawerInlineClose(event) : false'";
    topbar.innerHTML =
      "<button class='toa-cart-drawer-back' type='button' data-toa-continue-href='" + continueHref + "' data-toa-drawer-close" + inlineCloseAttrs + ">" +
        toaCartIcon("back") +
        "<span>Weiter einkaufen</span>" +
      "</button>" +
      "<button class='toa-cart-drawer-close' type='button' aria-label='Warenkorb schliessen' data-toa-drawer-close" + inlineCloseAttrs + ">" +
        toaCartIcon("close") +
      "</button>";
    drawer.insertBefore(topbar, drawer.firstChild);
    attachDrawerCloseControl(topbar);
    topbar.querySelectorAll("[data-toa-drawer-close]").forEach(function (button) {
      attachDrawerCloseControl(button);
    });
  }

  function enhanceDrawerCloseControls(drawer) {
    if (!drawer) return;
    var selector = [
      ".cart-summary__close",
      ".cart-close",
      ".drawer__close",
      ".js-close-cart",
      "[data-cart-close]",
      "[data-toa-drawer-close]"
    ].join(",");
    drawer.querySelectorAll(selector).forEach(function (control) {
      attachDrawerCloseControl(control);
    });
    drawer.querySelectorAll("button, a, [role='button']").forEach(function (control) {
      if (isDrawerContinueControl(control)) attachDrawerCloseControl(control);
    });
  }

  function closeDrawerIfControlEvent(event) {
    var target = event && event.target;
    if (!target || !target.closest) return false;
    var drawer = target.closest(".cart-summary");
    if (!drawer) return false;
    var closeTarget = target.closest("[data-toa-drawer-close], .cart-summary__close, .cart-close, .drawer__close, .js-close-cart, [data-cart-close]");
    if (closeTarget && drawer.contains(closeTarget)) {
      closeCartDrawerFromControl(event);
      return true;
    }
    if (isDrawerContinueControl(target)) {
      closeCartDrawerFromControl(event);
      return true;
    }
    return false;
  }

  function ensureDrawerBrandFallback(drawer) {
    if (!drawer) return;
    var brand = drawer.querySelector("[data-toa-drawer-brand]");
    if (!brand && drawer.querySelector(".toa-cart-conversion-panel__brand")) return;
    if (!brand) {
      var logo = document.querySelector(".site-header__logo img, .header-logo img, img[alt='Taste of Asia']");
      if (!logo || !logo.getAttribute("src")) return;
      brand = document.createElement("div");
      brand.className = "toa-cart-drawer-brand";
      brand.setAttribute("data-toa-drawer-brand", "true");
      brand.innerHTML =
        "<img src='" + logo.getAttribute("src") + "' alt='Taste of Asia'>" +
        "<span>Asiatische Lebensmittel online &amp; im Laden</span>";
    }
    var inner = drawer.querySelector(".cart-summary__inner");
    if (inner) {
      var emptyState = inner.querySelector(".cart-summary__empty");
      var anchor = emptyState || inner.firstElementChild;
      if (anchor) {
        if (brand.parentElement !== inner || brand.nextElementSibling !== anchor) inner.insertBefore(brand, anchor);
      } else if (brand.parentElement !== inner) {
        inner.appendChild(brand);
      }
      return;
    }
    var fallbackAnchor = drawer.querySelector("[data-toa-cart-panel]") || drawer.firstChild;
    drawer.insertBefore(brand, fallbackAnchor);
  }

  function getCartItemNodes(drawer) {
    if (!drawer) return [];
    var selectors = [
      ".cart-summary-item-container",
      ".cart-summary-item",
      "[data-cart-item]",
      ".ajaxcart__product"
    ].join(",");
    var nodes = Array.prototype.slice.call(drawer.querySelectorAll(selectors));
    return nodes.filter(function (node) {
      return !node.closest("[data-toa-cart-panel]") && !node.closest("[data-toa-products-heading]");
    });
  }

  function normalizeCartText(text) {
    return (text || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
  }

  function isNativeProductsHeading(node, ownHeading) {
    if (!node || node === ownHeading) return false;
    if (node.closest("[data-toa-products-heading]")) return false;
    if (node.hasAttribute("data-toa-products-heading") || node.classList.contains("toa-cart-products-heading")) return false;
    if (ownHeading && (node.contains(ownHeading) || ownHeading.contains(node))) return false;
    if (node.closest("[data-toa-cart-panel]")) return false;
    var text = normalizeCartText(node.textContent);
    if (!text || /deine\s+produkte/i.test(text)) return false;
    return /^produkte(?:\s*\(\s*\d+\s*\))?$/i.test(text);
  }

  function markNativeProductsHeading(node) {
    node.classList.add("toa-native-products-heading");
    node.setAttribute("aria-hidden", "true");
    node.setAttribute("tabindex", "-1");
    var parent = node.parentElement;
    if (!parent || parent.classList.contains("toa-cart-products-list")) return;
    if (parent.closest("[data-toa-products-heading]") || parent.closest("[data-toa-cart-panel]")) return;
    var parentText = normalizeCartText(parent.textContent);
    var nodeText = normalizeCartText(node.textContent);
    if (parentText === nodeText && parent.children.length <= 3) {
      parent.classList.add("toa-native-products-heading");
      parent.setAttribute("aria-hidden", "true");
      parent.setAttribute("tabindex", "-1");
    }
  }

  function hideNativeProductHeadings(drawer, ownHeading) {
    if (!drawer) return;
    var candidates = Array.prototype.slice.call(drawer.querySelectorAll(
      "button, summary, h1, h2, h3, h4, h5, h6, [role='button'], [class*='heading'], [class*='title'], [class*='accordion'], [class*='toggle']"
    ));
    Array.prototype.slice.call(drawer.children || []).forEach(function (node) {
      if (candidates.indexOf(node) === -1) candidates.push(node);
    });
    candidates.forEach(function (node) {
      if (isNativeProductsHeading(node, ownHeading)) markNativeProductsHeading(node);
    });
  }

  function ensureProductHeading(drawer, cart) {
    var items = getCartItemNodes(drawer);
    var firstItem = items[0];
    if (!firstItem) return;
    var list = firstItem.parentElement;
    if (!list) return;
    list.classList.add("toa-cart-products-list");
    var heading = drawer.querySelector("[data-toa-products-heading]");
    if (!heading) {
      heading = document.createElement("button");
      heading.type = "button";
      heading.className = "toa-cart-products-heading";
      heading.setAttribute("data-toa-products-heading", "true");
      heading.setAttribute("aria-expanded", "true");
      heading.innerHTML =
        "<span>Deine Produkte (<span data-toa-products-count>0</span>)</span>" +
        toaCartIcon("chevron");
      list.parentElement.insertBefore(heading, list);
      heading.addEventListener("click", function () {
        var collapsed = !drawer.classList.contains("toa-products-collapsed");
        drawer.classList.toggle("toa-products-collapsed", collapsed);
        heading.setAttribute("aria-expanded", collapsed ? "false" : "true");
      });
    }
    var count = heading.querySelector("[data-toa-products-count]");
    if (count) count.textContent = cart && typeof cart.item_count === "number" ? String(cart.item_count) : String(items.length);
    hideNativeProductHeadings(drawer, heading);
  }

  function arrangeMobileDrawerContent(drawer) {
    if (!drawer || !window.matchMedia || !window.matchMedia("(max-width: 749px)").matches) return;
    var heading = drawer.querySelector("[data-toa-products-heading]");
    var list = drawer.querySelector(".toa-cart-products-list");
    if (!heading || !list || heading.parentElement !== list.parentElement) return;
    var checkout = drawer.querySelector("button[name='checkout'], input[name='checkout'], a[href*='/checkout']");
    if (!checkout) return;
    var summary = checkout.closest(".cart-summary__button-row, .cart-summary__buttons, .cart-summary__section") || checkout;
    if (summary.parentElement !== list.parentElement) return;
    var parent = list.parentElement;
    parent.insertBefore(heading, summary);
    parent.insertBefore(list, summary);
    drawer.setAttribute("data-toa-mobile-order-ready", "true");
  }

  function enhanceRemoveButtons(drawer) {
    if (!drawer) return;
    var selectors = [
      ".cart-summary-item__remove",
      ".cart-remove-button",
      ".ajaxcart__product-remove",
      "button[name='remove']",
      "a[href*='/cart/change'][href*='quantity=0']"
    ].join(",");
    drawer.querySelectorAll(selectors).forEach(function (button) {
      if (button.closest("[data-toa-cart-panel]")) return;
      button.classList.add("toa-cart-remove-button");
      button.setAttribute("aria-label", "Produkt entfernen");
      button.setAttribute("title", "Produkt entfernen");
      if (button.getAttribute("data-toa-trash-ready") === "true") return;
      button.setAttribute("data-toa-trash-ready", "true");
      button.innerHTML = toaCartIcon("trash");
    });
  }

  function enhanceQuantityControls(drawer) {
    if (!drawer) return;
    var selectors = [
      ".cart-summary-item__quantity",
      ".qty-adjuster",
      ".quantity",
      ".ajaxcart__qty",
      "[data-quantity-wrapper]"
    ].join(",");
    drawer.querySelectorAll(selectors).forEach(function (control) {
      if (control.closest("[data-toa-cart-panel]")) return;
      control.classList.add("toa-cart-qty-pill");
    });
  }

  function ensureCheckoutTrustLine(drawer) {
    if (!drawer || drawer.querySelector("[data-toa-cart-trust-line]")) return;
    var checkout = drawer.querySelector("button[name='checkout'], input[name='checkout'], a[href*='/checkout']");
    if (!checkout) return;
    var trust = document.createElement("div");
    trust.className = "toa-cart-trust-line";
    trust.setAttribute("data-toa-cart-trust-line", "true");
    trust.innerHTML = toaCartIcon("shield") + "<span>Sichere Zahlung &amp; Datenschutz</span>";
    var anchor = checkout.closest(".cart-summary__button-row, .cart-summary__buttons, .cart-summary__section") || checkout;
    anchor.parentElement.insertBefore(trust, anchor.nextSibling);
  }

  function enhanceCartDrawer(cart) {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.add("toa-cart-drawer-upgraded");
    ensureDrawerTopbar(drawer);
    enhanceDrawerCloseControls(drawer);
    ensureDrawerBrandFallback(drawer);
    ensureProductHeading(drawer, cart);
    arrangeMobileDrawerContent(drawer);
    enhanceRemoveButtons(drawer);
    enhanceQuantityControls(drawer);
    if (!cartIsEmpty(cart)) ensureCheckoutTrustLine(drawer);
    setEmptyCartCheckoutState(cart);
  }

  function seedFreshFreeShippingPanels() {
    if (lastFreeShippingProgress === null || lastFreeShippingPackageLeft === null) return;
    document.querySelectorAll("[data-toa-cart-panel]:not([data-toa-free-shipping-position-ready])").forEach(function (panel) {
      panel.classList.add("is-package-seeding");
      panel.style.setProperty("--toa-free-shipping-progress", lastFreeShippingProgress + "%");
      panel.style.setProperty("--toa-free-shipping-package-left", lastFreeShippingPackageLeft + "%");
      panel.setAttribute("data-toa-free-shipping-position-ready", "seeded");
      panel.offsetHeight;
      panel.classList.remove("is-package-seeding");
    });
  }

  function updatePanels(cart) {
    if (!cart || typeof cart.total_price !== "number") return;
    cart = cartForCustomerDisplay(cart);
    updateCheckoutButtons(cart);
    enhanceCartDrawer(cart);
    var shippingBasis = cartFreeShippingBasis(cart);
    var pfandTotal = cartPfandTotal(cart);
    var panels = document.querySelectorAll("[data-toa-cart-panel]");
    panels.forEach(function (panel) {
      var threshold = Number(panel.getAttribute("data-threshold")) || thresholdFallback;
      var giftThreshold = Number(panel.getAttribute("data-gift-threshold")) || 10000;
      var remaining = Math.max(0, threshold - shippingBasis);
      var progress = Math.max(0, Math.min(100, Math.round(shippingBasis / threshold * 10000) / 100));
      var progressRatio = Math.max(0, Math.min(1, shippingBasis / threshold));
      var benefitProgress = Math.max(0, Math.min(100, Math.round(shippingBasis / giftThreshold * 10000) / 100));
      var route = panel.querySelector(".toa-cart-route");
      var routeStart = 4.5;
      var routeEnd = 58;
      if (route) {
        var routeStyle = window.getComputedStyle(route);
        var cssRouteStart = Number.parseFloat(routeStyle.getPropertyValue("--toa-package-route-start"));
        var cssRouteEnd = Number.parseFloat(routeStyle.getPropertyValue("--toa-package-route-end"));
        if (Number.isFinite(cssRouteStart)) routeStart = cssRouteStart;
        if (Number.isFinite(cssRouteEnd)) routeEnd = cssRouteEnd;
      }
      var packageLeft = routeStart + progressRatio * (routeEnd - routeStart);
      var message = panel.querySelector("[data-toa-free-shipping-message]");
      var submessage = panel.querySelector("[data-toa-free-shipping-submessage]");
      var goalBadge = panel.querySelector("[data-toa-free-shipping-goal-badge]");
      var previousBasis = panel.getAttribute("data-toa-last-shipping-basis");
      var previousRemaining = previousBasis === null ? null : Math.max(0, threshold - Number(previousBasis));
      var changed = previousBasis !== null && Number(previousBasis) !== shippingBasis;
      var unlocked = previousRemaining !== null && previousRemaining > 0 && remaining <= 0;
      var isFreshPanel = !panel.hasAttribute("data-toa-free-shipping-position-ready");

      if (isFreshPanel && lastFreeShippingProgress !== null && lastFreeShippingPackageLeft !== null) {
        panel.classList.add("is-package-seeding");
        panel.style.setProperty("--toa-free-shipping-progress", lastFreeShippingProgress + "%");
        panel.style.setProperty("--toa-free-shipping-package-left", lastFreeShippingPackageLeft + "%");
        panel.offsetHeight;
        panel.classList.remove("is-package-seeding");
      }

      panel.style.setProperty("--toa-free-shipping-progress", progress + "%");
      panel.style.setProperty("--toa-benefit-progress", benefitProgress + "%");
      panel.style.setProperty("--toa-free-shipping-ratio", String(progressRatio));
      panel.style.setProperty("--toa-free-shipping-package-left", Math.round(packageLeft * 1000) / 1000 + "%");
      panel.classList.toggle("is-complete", remaining <= 0);
      panel.setAttribute("data-toa-last-shipping-basis", String(shippingBasis));
      panel.setAttribute("data-toa-shipping-basis", String(shippingBasis));
      panel.setAttribute("data-toa-pfand-total", String(pfandTotal));
      panel.setAttribute("data-toa-free-shipping-position-ready", "true");
      lastFreeShippingProgress = progress;
      lastFreeShippingPackageLeft = Math.round(packageLeft * 1000) / 1000;

      if (changed) {
        panel.classList.add("is-progressing");
        window.clearTimeout(panel._toaProgressTimer);
        panel._toaProgressTimer = window.setTimeout(function () {
          panel.classList.remove("is-progressing");
        }, 850);
      }
      if (unlocked) {
        panel.classList.add("is-unlocked");
        window.clearTimeout(panel._toaUnlockedTimer);
        panel._toaUnlockedTimer = window.setTimeout(function () {
          panel.classList.remove("is-unlocked");
        }, 1200);
      }

      if (message) {
        if (shippingBasis < discountThresholdFallback) {
          message.innerHTML = "Noch <span data-toa-free-shipping-remaining>" + formatMoney(discountThresholdFallback - shippingBasis) + "</span> Warenwert bis DHL Versand für 3,49 €";
        } else if (remaining > 0) {
          message.innerHTML = "Noch <span data-toa-free-shipping-remaining>" + formatMoney(remaining) + "</span> Warenwert bis kostenloser Versand";
        } else {
          message.textContent = "Gratisversand erreicht";
        }
      }
      if (submessage) {
        if (remaining > 0) {
          if (pfandTotal > 0) {
            submessage.innerHTML = (shippingBasis < discountThresholdFallback ? "DHL Versand aktuell 6,49 €. " : "DHL Versand aktuell 3,49 €. ") + "Pfand <span class=\"toa-cart-conversion-panel__pfand-note\">nicht einberechnet</span>.";
          } else if (shippingBasis < discountThresholdFallback) {
            submessage.textContent = "DHL Versand aktuell 6,49 €. Ab 49 € Warenwert nur 3,49 €.";
          } else {
            submessage.textContent = "DHL Versand aktuell 3,49 €. Ab 69 € Warenwert kostenlos.";
          }
        } else {
          submessage.textContent = "Deine Bestellung erreicht den DHL Gratisversand innerhalb Deutschlands.";
        }
      }
      if (goalBadge) {
        goalBadge.textContent = remaining > 0 ? "Gratis Versand" : "Gratis erreicht";
      }
      var giftCopy = panel.querySelector("[data-toa-gift-progress-copy]");
      if (giftCopy) {
        if (shippingBasis < discountThresholdFallback) {
          giftCopy.textContent = "Noch " + formatMoney(discountThresholdFallback - shippingBasis) + " bis zu deinem ersten Gratisgeschenk.";
        } else if (shippingBasis < giftThreshold) {
          giftCopy.textContent = "1 Geschenk frei \u2013 noch " + formatMoney(giftThreshold - shippingBasis) + " bis zu 3 Gratisgeschenken.";
        } else {
          giftCopy.textContent = "3 Gratisgeschenke freigeschaltet! W\u00e4hle deine Geschenke gleich hier aus.";
        }
      }
      var giftJump = panel.querySelector('[data-toa-gift-jump]');
      if (shippingBasis >= discountThresholdFallback) {
        if (!giftJump) {
          giftJump = document.createElement('button');
          giftJump.type = 'button'; giftJump.setAttribute('data-toa-gift-jump', 'true');
          giftJump.className = 'toa-gift-jump';
          giftJump.addEventListener('click', function() {
            var target = document.querySelector('[data-toa-free-gift-selector="true"] .toa-free-gift__head');
            if (target) target.scrollIntoView({behavior:'smooth', block:'start'});
          });
          panel.appendChild(giftJump);
        }
        giftJump.textContent = shippingBasis >= giftThreshold ? '3 Gratisgeschenke auswählen →' : 'Gratisgeschenk auswählen →';
      } else if (giftJump) giftJump.remove();
    });
  }

  function fetchCartData() { return window.toaCartState.read(); }
  document.addEventListener('toa:cart-confirmed', function(event) {
    updatePanels(event.detail.cart);
  });

  function fetchCart() {
    if (!document.querySelector("[data-toa-cart-panel], .cart-summary, #cartform")) return;
    var sequence = ++cartFetchSequence;
    fetchCartData()
      .then(function (cart) {
        if (sequence < cartAppliedSequence) return;
        cartAppliedSequence = sequence;
        updatePanels(cart);
        document.dispatchEvent(new CustomEvent("toa:cart-state", {
          detail: { cart: cart }
        }));
      })
      .catch(function () {});
  }

  function scheduleCartUpdate(delay) {
    var wait = typeof delay === "number" ? delay : 180;
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(fetchCart, wait);
    window.clearTimeout(trailingUpdateTimer);
    trailingUpdateTimer = null;
    window.clearTimeout(finalUpdateTimer);
    finalUpdateTimer = null;
  }

  function forceCartDrawerVisible(drawer) {
    if (!drawer || !drawer.style) return;
    [
      ["display", "block"],
      ["position", "fixed"],
      ["top", window.matchMedia("(max-width:749px)").matches ? "var(--toa-cart-visible-top, 0px)" : "0"],
      ["left", "auto"],
      ["right", "0"],
      ["bottom", window.matchMedia("(max-width:749px)").matches ? "auto" : "0"],
      ["height", window.matchMedia("(max-width:749px)").matches ? "var(--toa-cart-visible-height, 100dvh)" : "100vh"],
      ["transform", "translate3d(0,0,0)"],
      ["opacity", "1"],
      ["visibility", "visible"],
      ["pointer-events", "auto"],
      ["z-index", "2147483646"]
    ].forEach(function (entry) {
      drawer.style.setProperty(entry[0], entry[1], "important");
    });
  }

  function clearForcedCartDrawerVisibility() {
    var drawer = document.querySelector(".cart-summary");
    if (!drawer || !drawer.style) return;
    [
      "display",
      "position",
      "top",
      "left",
      "right",
      "bottom",
      "height",
      "transform",
      "opacity",
      "visibility",
      "pointer-events",
      "z-index"
    ].forEach(function (property) {
      drawer.style.removeProperty(property);
    });
  }

  function openCartDrawer() {
    if (userClosedDrawer && Date.now() < cartCloseGuardUntil) return false;
    var drawer = document.querySelector(".cart-summary");
    if (!drawer) return false;
    document.documentElement.classList.remove("toa-cart-close-guard");
    document.body.classList.remove("toa-cart-close-guard");
    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("show-cart-summary");
    document.body.classList.remove("show-mobile-nav");
    document.body.classList.add("show-cart-summary", "product-added-to-cart");
    forceCartDrawerVisible(drawer);
    return true;
  }

  function keepCartDrawerOpen(duration) {
    userClosedDrawer = false;
    cartCloseGuardUntil = 0;
    document.documentElement.classList.remove("toa-cart-close-guard");
    document.body.classList.remove("toa-cart-close-guard");
    keepDrawerOpenUntil = Date.now() + (duration || 1400);
    openCartDrawer();
  }

  function allowCartDrawerClose() {
    userClosedDrawer = true;
    keepDrawerOpenUntil = 0;
    cartCloseGuardUntil = Date.now() + 1600;
    document.documentElement.classList.add("toa-cart-close-guard");
    document.body.classList.add("toa-cart-close-guard");
    document.documentElement.classList.remove("show-cart-summary");
    document.body.classList.remove("show-cart-summary", "product-added-to-cart", "updating-cart");
    var drawer = document.querySelector(".cart-summary");
    if (drawer) {
      drawer.classList.remove("active", "toa-cart-limit-flash");
      drawer.setAttribute("aria-hidden", "true");
    }
    clearForcedCartDrawerVisibility();
    [70, 180, 420, 900, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (!userClosedDrawer || Date.now() > cartCloseGuardUntil + 80) return;
        document.documentElement.classList.add("toa-cart-close-guard");
        document.body.classList.add("toa-cart-close-guard");
        document.documentElement.classList.remove("show-cart-summary");
        document.body.classList.remove("show-cart-summary", "product-added-to-cart", "updating-cart");
        var currentDrawer = document.querySelector(".cart-summary");
        if (currentDrawer) {
          currentDrawer.classList.remove("active", "toa-cart-limit-flash");
          currentDrawer.setAttribute("aria-hidden", "true");
        }
        clearForcedCartDrawerVisibility();
      }, delay);
    });
    window.setTimeout(function () {
      if (!userClosedDrawer || Date.now() < cartCloseGuardUntil) return;
      document.documentElement.classList.remove("toa-cart-close-guard");
      document.body.classList.remove("toa-cart-close-guard");
    }, 1700);
  }

  window.toaCartDrawerCancelPendingClose = function () {
    userClosedDrawer = false;
    cartCloseGuardUntil = 0;
    keepDrawerOpenUntil = 0;
    document.documentElement.classList.remove("toa-cart-close-guard");
    document.body.classList.remove("toa-cart-close-guard");
  };

  function cssEscapeValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(String(value));
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function findCartLineByVariant(variantId) {
    var drawer = document.querySelector(".cart-summary");
    if (!drawer || !variantId) return null;
    var byVariant = drawer.querySelector('.cart-summary-item-container[data-product-id="' + cssEscapeValue(variantId) + '"]');
    if (byVariant) return byVariant;
    var quantityControl = drawer.querySelector('.qty-adjuster[data-line-item-id="' + cssEscapeValue(variantId) + '"]');
    if (quantityControl) return quantityControl.closest(".cart-summary-item-container, .cart-summary-item");
    return null;
  }

  function scrollCartLineIntoView(line) {
    if (!line) return;
    var panel = line.closest(".cart-summary__inner");
    if (panel && panel.scrollHeight > panel.clientHeight) {
      var panelRect = panel.getBoundingClientRect();
      var lineRect = line.getBoundingClientRect();
      if (lineRect.top >= panelRect.top && lineRect.bottom <= panelRect.bottom) return;
      var target = panel.scrollTop + (lineRect.top + lineRect.height / 2) - (panelRect.top + panel.clientHeight / 2);
      try {
        panel.scrollTo({ top: Math.max(0, target), behavior: "auto" });
        return;
      } catch (error) {
        panel.scrollTop = Math.max(0, target);
        return;
      }
    }
    if (typeof line.scrollIntoView === "function") {
      try { line.scrollIntoView({ block: "nearest", behavior: "auto" }); } catch (error) {}
    }
  }

  function scheduleCartLineScroll(variantId) {
    window.setTimeout(function () {
      scrollCartLineIntoView(findCartLineByVariant(variantId));
    }, 180);
  }

  function rememberCartHighlight(variantId) {
    if (!variantId) return;
    pendingCartHighlightVariant = String(variantId);
    pendingCartHighlightUntil = Date.now() + 6500;
  }

  function flushPendingCartHighlight() {
    if (!pendingCartHighlightVariant || Date.now() > pendingCartHighlightUntil) return false;
    var variantId = pendingCartHighlightVariant;
    var line = findCartLineByVariant(variantId);
    if (!line) return false;
    pendingCartHighlightVariant = "";
    pendingCartHighlightUntil = 0;
    pulseCartLine(variantId);
    return true;
  }

  function pulseCartLine(variantId) {
    var line = findCartLineByVariant(variantId);
    if (!line) return false;
    if (line.classList.contains("toa-cart-item-pulse")) {
      return true;
    }
    var oldBadge = line.querySelector(".toa-cart-confirm-badge");
    if (oldBadge) oldBadge.remove();
    var badge = document.createElement("span");
    badge.className = "toa-cart-confirm-badge";
    badge.setAttribute("aria-hidden", "true");
    badge.textContent = "Hinzugefügt";
    line.appendChild(badge);
    line.classList.add("toa-cart-item-pulse");
    window.setTimeout(function () {
      line.classList.remove("toa-cart-item-pulse");
      var currentBadge = line.querySelector(".toa-cart-confirm-badge");
      if (currentBadge) currentBadge.remove();
    }, 2100);
    return true;
  }

  function highlightCartItemByVariant(variantId) {
    if (!variantId) return;
    window.setTimeout(function () {
      pulseCartLine(variantId);
    }, 260);
  }

  function showCartNotice(message) {
    injectStyle();
    var toast = document.querySelector(".toa-cart-limit-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toa-cart-limit-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    var drawer = document.querySelector(".cart-summary");
    if (drawer) {
      drawer.classList.remove("toa-cart-limit-flash");
      void drawer.offsetWidth;
      drawer.classList.add("toa-cart-limit-flash");
      window.setTimeout(function () { drawer.classList.remove("toa-cart-limit-flash"); }, 950);
    }
    window.clearTimeout(showCartNotice.timer);
    showCartNotice.timer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 4300);
  }

  function getProductForm(node) {
    return node && node.closest && node.closest("form.product-form, form[action*='/cart/add']");
  }

  function formCanUseSmartAdd(form) {
    return !!(form && form.querySelector("[name='id']") && form.querySelector(".product-add, [name='add']"));
  }

  function selectedVariantId(form) {
    var field = form && form.querySelector("[name='id']");
    return field ? String(field.value || "").trim() : "";
  }

  function findQuantityInput(form) {
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    var direct = form.querySelector(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])");
    if (direct && !direct.type.match(/hidden/i)) return direct;

    var areas = [
      form.closest(".product-detail"),
      form.closest(".product-block"),
      form.closest(".quickbuy-form"),
      form.closest(".product-form"),
      form.closest(".product-form__controls"),
      form.closest(".product-detail__form"),
      form.closest(".flex"),
      form.parentElement,
      form.parentElement && form.parentElement.parentElement
    ];
    for (var i = 0; i < areas.length; i += 1) {
      var area = areas[i];
      if (!area) continue;
      var visible = area.querySelector(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])");
      if (visible && !visible.closest(".cart-summary, .cart-form")) return visible;
    }

    var formRect = form.getBoundingClientRect && form.getBoundingClientRect();
    if (formRect) {
      var candidates = Array.prototype.slice.call(document.querySelectorAll(".qty-adjuster__value[name='quantity'], input[name='quantity']:not([type='hidden'])")).filter(function (input) {
        return !input.closest(".cart-summary, .cart-form");
      }).map(function (input) {
        var rect = input.getBoundingClientRect();
        return { input: input, distance: Math.abs(rect.top - formRect.top) + Math.abs(rect.left - formRect.left) };
      }).sort(function (a, b) {
        return a.distance - b.distance;
      });
      if (candidates[0] && candidates[0].distance < 700) return candidates[0].input;
    }

    return hidden || form.querySelector("input[name='quantity']");
  }

  function getWantedQuantity(form) {
    var input = findQuantityInput(form);
    var quantity = input ? parseInt(input.value, 10) : 1;
    return Math.max(1, isNaN(quantity) ? 1 : quantity);
  }

  function syncFormQuantityBeforeAdd(form, quantity) {
    var value = String(Math.max(1, Number(quantity) || 1));
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    if (hidden) hidden.value = value;
    var direct = form.querySelector("input[name='quantity']:not([type='hidden'])");
    if (direct && direct !== document.activeElement) direct.value = value;
  }

  function getStockLimit(form) {
    var input = findQuantityInput(form);
    var adjuster = input && input.closest(".qty-adjuster");
    var area = form.closest(".product-detail, .product-block, .quickbuy-form, .product-form, .flex") || form.parentElement;
    var fromAdjuster = adjuster && adjuster.getAttribute("data-limit");
    var fromArea = area && area.querySelector(".qty-adjuster[data-limit]") && area.querySelector(".qty-adjuster[data-limit]").getAttribute("data-limit");
    var limit = parseInt(fromAdjuster || fromArea || "", 10);
    return isNaN(limit) ? 0 : limit;
  }

  function getFormForQuantityInput(input) {
    var form = getProductForm(input);
    if (form) return form;
    var area = input && (input.closest(".product-detail, .product-block, .quickbuy-form, .flex, .product-form") || input.parentElement);
    return area && area.querySelector("form.product-form, form[action*='/cart/add']");
  }

  function scheduleStorefrontQuantitySync(input, delay) {
    if (!isStorefrontQuantityInput(input)) return;
    window.clearTimeout(storefrontQuantitySyncTimer);
    storefrontQuantitySyncTimer = window.setTimeout(function () {
      syncStorefrontQuantityToCart(input);
    }, delay || 160);
  }

  function syncStorefrontQuantityToCart(input) {
    var form = getFormForQuantityInput(input);
    if (!form || !formCanUseSmartAdd(form)) return;
    var variantId = selectedVariantId(form);
    if (!variantId) return;

    var desiredQuantity = parseInt(input.value, 10);
    if (isNaN(desiredQuantity) || desiredQuantity < 1) desiredQuantity = 1;

    var limit = getStockLimit(form);
    if (limit > 0 && desiredQuantity > limit) {
      desiredQuantity = limit;
      input.value = String(limit);
      showCartNotice("Nur " + limit + " Stück verfügbar.");
    }

    enqueueCartMutation(function () {
      return fetchCartData().then(function (cart) {
      var currentItem = (cart.items || []).find(function (item) {
        return String(item.id) === String(variantId);
      });
      var currentQuantity = currentItem ? Number(currentItem.quantity) || 0 : 0;
      if (currentQuantity <= 0 || desiredQuantity === currentQuantity) return null;
      return postCart("/cart/change.js", { id: variantId, quantity: desiredQuantity });
      });
    }).then(function (result) {
      normaliseProductAddButtons(document);
      if (!result) return;
      keepCartDrawerOpen();
      refreshThemeCart(true);
      highlightCartItemByVariant(variantId);
      showCartNotice("Menge im Warenkorb auf " + desiredQuantity + " aktualisiert.");
    }).catch(function () {
      showCartNotice("Die Warenkorbmenge konnte gerade nicht aktualisiert werden.");
      keepCartDrawerOpen();
    });
  }

  function setFormLoading(form, loading) {
    var buttons = form.querySelectorAll(".product-add, [name='add']");
    buttons.forEach(function (button) {
      button.classList.toggle("product-add--adding", !!loading);
      if (loading) {
        button.setAttribute("disabled", "disabled");
      } else {
        button.removeAttribute("disabled");
      }
    });
  }

  function resetProductQuantity(form, quantity) {
    var value = String(Math.max(1, Number(quantity) || 1));
    var input = findQuantityInput(form);
    if (input) input.value = value;
    var hidden = form.querySelector("input[type='hidden'][name='quantity']");
    if (hidden) hidden.value = value;
  }

  function normaliseProductAddButtons(root) {
    var scope = root || document;
    scope.querySelectorAll("form.product-form, form[action*='/cart/add']").forEach(function (form) {
      if (!formCanUseSmartAdd(form) || form.closest(".cart-summary")) return;
      form.classList.remove("product-form--added", "product-form--temp-could-remove");
      form.querySelectorAll(".product-add").forEach(function (button) {
        if (button.getAttribute("data-btn-type") === "in-cart") button.setAttribute("data-btn-type", "add-to-cart");
        var text = button.querySelector(".button-text");
        if (text && /Aus dem Warenkorb|Remove/i.test(text.textContent || "")) {
          text.textContent = "In den Warenkorb";
        }
      });
    });
  }

  function postCart(endpoint, payload) {
    return window.fetch(endpoint, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          var error = new Error(json && (json.description || json.message) || "cart error");
          error.payload = json;
          throw error;
        }
        return json;
      });
    });
  }

  function enqueueCartMutation(task) {
    cartMutationQueue = cartMutationQueue.catch(function () {}).then(function () {
      document.documentElement.classList.add("toa-cart-mutating");
      return task();
    }).finally(function () {
      document.documentElement.classList.remove("toa-cart-mutating");
    });
    return cartMutationQueue;
  }


  function resetCartDrawerToProducts() {
    var delays = [0, 90, 260, 520];
    delays.forEach(function (delay) {
      window.setTimeout(function () {
        var drawer = document.querySelector('.cart-summary');
        var scroller = drawer && (drawer.querySelector('.cart-summary__inner') || drawer);
        if (!scroller) return;
        try { scroller.scrollTo({ top: 0, behavior: 'auto' }); }
        catch (_) { scroller.scrollTop = 0; }
      }, delay);
    });
  }

  function refreshThemeCart(openDrawer) {
    var drawerBefore = document.querySelector(".cart-summary");
    var scrollerBefore = drawerBefore && (drawerBefore.querySelector(".cart-summary__inner") || drawerBefore);
    var previousScrollTop = scrollerBefore ? scrollerBefore.scrollTop : 0;
    renderCountdown();
    if (window.theme && typeof window.theme.updateCartSummaries === "function") {
      window.theme.updateCartSummaries(!!openDrawer, true, false);
    }
    if (openDrawer) keepCartDrawerOpen();
    scheduleCartUpdate(120);
    window.setTimeout(function () {
      normaliseProductAddButtons(document);
      var drawerAfter = document.querySelector(".cart-summary");
      var scrollerAfter = drawerAfter && (drawerAfter.querySelector(".cart-summary__inner") || drawerAfter);
      if (scrollerAfter && previousScrollTop > 0) scrollerAfter.scrollTop = previousScrollTop;
      flushPendingCartHighlight();
    }, 360);
  }

  function smartAddToCart(form, sourceEvent) {
    if (!formCanUseSmartAdd(form)) return false;
    var variantId = selectedVariantId(form);
    if (!variantId) return false;
    rememberCartHighlight(variantId);
    if (sourceEvent) {
      sourceEvent.preventDefault();
      sourceEvent.stopImmediatePropagation();
      sourceEvent.stopPropagation();
    }
    restartCountdown();
    keepCartDrawerOpen();
    var wantedQuantity = getWantedQuantity(form);
    syncFormQuantityBeforeAdd(form, wantedQuantity);
    var limit = getStockLimit(form);
    var cappedApplied = false;
    var alreadyMaxNoticeShown = false;
    var appliedQuantity = wantedQuantity;
    setFormLoading(form, true);

    enqueueCartMutation(function () {
      return fetchCartData().then(function (cart) {
        var currentItem = (cart.items || []).find(function (item) {
          return String(item.id) === String(variantId);
        });
        var currentQuantity = currentItem ? Number(currentItem.quantity) || 0 : 0;
        var finalQuantity = currentQuantity > 0
          ? (wantedQuantity === currentQuantity ? currentQuantity + 1 : wantedQuantity)
          : wantedQuantity;
        var capped = false;

        if (limit > 0 && finalQuantity > limit) {
          finalQuantity = limit;
          capped = true;
          cappedApplied = true;
        }

        if (limit > 0 && finalQuantity <= currentQuantity && wantedQuantity >= currentQuantity) {
          showCartNotice("Nur " + limit + " Stück verfügbar. Diese Menge liegt bereits im Warenkorb.");
          alreadyMaxNoticeShown = true;
          keepCartDrawerOpen();
          refreshThemeCart(true);
          return null;
        }

        appliedQuantity = finalQuantity;
        if (currentQuantity > 0) {
          return postCart("/cart/change.js", { id: variantId, quantity: finalQuantity });
        }
        return postCart("/cart/add.js", { id: Number(variantId) || variantId, quantity: finalQuantity });
      });
    }).then(function (result) {
      resetProductQuantity(form, appliedQuantity);
      normaliseProductAddButtons(document);
      keepCartDrawerOpen();
      refreshThemeCart(true);
      if (result) highlightCartItemByVariant(variantId);
      if (cappedApplied && !alreadyMaxNoticeShown) {
        showCartNotice("Nur " + limit + " Stück verfügbar. Ich habe die maximal mögliche Menge übernommen.");
      }
    }).catch(function (error) {
      var message = error && error.message ? error.message : "Der Warenkorb konnte gerade nicht aktualisiert werden.";
      showCartNotice(message);
      keepCartDrawerOpen();
    }).finally(function () {
      setFormLoading(form, false);
      window.setTimeout(function () { normaliseProductAddButtons(document); }, 100);
    });
    return true;
  }

  function isStorefrontQuantityInput(input) {
    if (!input || !input.matches || !input.matches(".qty-adjuster__value[name='quantity']")) return false;
    if (input.closest(".cart-summary, .cart-form")) return false;
    var area = input.closest(".product-detail, .product-block, .quickbuy-form, .flex, .product-form") || input.parentElement;
    return !!(area && area.querySelector("form.product-form, form[action*='/cart/add']"));
  }

  document.addEventListener("DOMContentLoaded", function () {
    injectStyle();
    normaliseProductAddButtons(document);
    renderCountdown();
    scheduleCartUpdate(60);
  });

  window.addEventListener("pageshow", function () {
    injectStyle();
    normaliseProductAddButtons(document);
    renderCountdown();
    scheduleCartUpdate(60);
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (formCanUseSmartAdd(form)) {
      rememberCartHighlight(selectedVariantId(form));
      smartAddToCart(form, event);
    }
  }, true);

  ["pointerdown", "touchstart", "mousedown"].forEach(function (type) {
    document.addEventListener(type, function (event) {
      closeDrawerIfControlEvent(event);
    }, { capture: true, passive: false });
  });

  document.addEventListener("click", function (event) {
    if (closeDrawerIfControlEvent(event)) return;
    var overlayTarget = event.target.closest("#page-overlay, .page-overlay");
    if (overlayTarget) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      allowCartDrawerClose();
      return;
    }
    var closeTarget = event.target.closest(".cart-summary__close, .cart-close, .drawer__close, .js-close-cart, [data-cart-close]");
    if (closeTarget) {
      allowCartDrawerClose();
      return;
    }
    var directAddButton = event.target.closest(".product-add, [name='add']");
    if (directAddButton) {
      var directAddForm = getProductForm(directAddButton);
      if (formCanUseSmartAdd(directAddForm)) {
        rememberCartHighlight(selectedVariantId(directAddForm));
        smartAddToCart(directAddForm, event);
        return;
      }
    }
    var inCartButton = event.target.closest(".btn[data-btn-type='in-cart'], .product-add[data-btn-type='in-cart']");
    if (inCartButton) {
      var inCartForm = getProductForm(inCartButton);
      rememberCartHighlight(selectedVariantId(inCartForm));
      smartAddToCart(inCartForm, event);
      return;
    }
    var toggle = event.target.closest(
      ".toggle-cart-summary, a[href='#warenkorb'][aria-label*='Warenkorb'], [data-toa-cart-toggle]"
    );
    if (toggle && !toggle.closest(".cart-summary")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      keepCartDrawerOpen();
      refreshThemeCart(true);
      resetCartDrawerToProducts();
      return;
    }
    if ((document.body.classList.contains("show-cart-summary") || document.documentElement.classList.contains("show-cart-summary")) && !event.target.closest(".cart-summary")) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      allowCartDrawerClose();
      return;
    }
  }, true);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      allowCartDrawerClose();
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (isStorefrontQuantityInput(event.target)) {
      event.stopImmediatePropagation();
      scheduleStorefrontQuantitySync(event.target, 120);
      normaliseProductAddButtons(document);
    }
  }, true);

  document.addEventListener("click", function (event) {
    var storefrontStep = event.target.closest(".qty-adjuster__up, .qty-adjuster__down");
    if (storefrontStep) {
      var storefrontAdjuster = storefrontStep.closest(".qty-adjuster");
      var storefrontInput = storefrontAdjuster && storefrontAdjuster.querySelector(".qty-adjuster__value[name='quantity']");
      if (isStorefrontQuantityInput(storefrontInput)) {
        window.setTimeout(function () {
          scheduleStorefrontQuantitySync(storefrontInput, 80);
        }, 70);
      }
    }
    if (event.target.closest(".qty-adjuster__up, .qty-adjuster__down, .qty-adjuster__remove, .product-add, [name='add']")) {
      var isRemove = event.target.closest(".qty-adjuster__remove, .toa-cart-remove-button, .cart-summary-item__remove, .cart-remove-button, a[href*='quantity=0']");
      scheduleCartUpdate(isRemove ? 120 : 320);
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (event.target.matches(".qty-adjuster__value, input[name^='updates']")) {
      scheduleCartUpdate(80);
    }
  }, true);

  ["cart:refresh", "cart:updated", "cart:change"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleCartUpdate(40);
    });
    window.addEventListener(eventName, function () {
      scheduleCartUpdate(40);
    });
  });

  document.addEventListener("toa:refresh-cart-view", function () {
    keepCartDrawerOpen();
    refreshThemeCart(true);
  });

  document.addEventListener("ajaxProduct:added", function () {
    keepCartDrawerOpen();
    refreshThemeCart(true);
  });

  // TOA new-arrivals controls fallback v1:
  // Keep quantity controls and carousel arrows operational even when the
  // inline carousel initialiser is skipped by a theme re-render.
  document.addEventListener("click", function (event) {
    var target = event.target && event.target.nodeType === 1
      ? event.target
      : event.target && event.target.parentElement;
    var section = target && target.closest && target.closest("#toa-new-arrivals");
    if (!section) return;

    var minus = target.closest("[data-toa-qty-minus]");
    var plus = target.closest("[data-toa-qty-plus]");
    if (minus || plus) {
      event.preventDefault();
      event.stopPropagation();
      var quantityWrap = target.closest("[data-toa-qty]");
      var quantityInput = quantityWrap && quantityWrap.querySelector("input[name='quantity']");
      if (!quantityInput) return;
      var quantity = parseInt(quantityInput.value || "1", 10);
      if (!isFinite(quantity) || quantity < 1) quantity = 1;
      quantity = Math.max(1, Math.min(99, quantity + (plus ? 1 : -1)));
      quantityInput.value = String(quantity);
      quantityInput.setAttribute("value", String(quantity));
      quantityInput.dispatchEvent(new Event("input", { bubbles: true }));
      return;
    }

    var previous = target.closest("[data-toa-arrival-prev]");
    var next = target.closest("[data-toa-arrival-next]");
    if (!previous && !next) return;

    event.preventDefault();
    event.stopPropagation();
    var rail = section.querySelector("[data-toa-arrival-rail]");
    if (!rail) return;
    var maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
    if (maximum <= 2) return;

    var card = rail.querySelector("[data-toa-arrival-card]:not([hidden])");
    var cardWidth = card ? card.getBoundingClientRect().width : 260;
    var railStyle = window.getComputedStyle(rail);
    var gap = parseFloat(railStyle.columnGap || railStyle.gap || "0") || 0;
    var unit = Math.max(1, cardWidth + gap);
    var visibleCount = Math.max(1, Math.floor((rail.clientWidth + gap) / unit));
    var step = unit * Math.max(1, visibleCount - 1);
    var current = Math.max(0, rail.scrollLeft || 0);
    var destination;

    if (next) {
      destination = current >= maximum - 4 ? 0 : Math.min(maximum, current + step);
    } else {
      destination = current <= 4 ? maximum : Math.max(0, current - step);
    }

    if (typeof rail.scrollTo === "function") {
      rail.scrollTo({ left: destination, behavior: "smooth" });
    } else {
      rail.scrollLeft = destination;
    }
  }, true);

  if (window.jQuery) {
    window.jQuery(window).on("cc-cart-updated.toaCartEnhancements", function () {
      renderCountdown();
      normaliseProductAddButtons(document);
      if (!userClosedDrawer && Date.now() < keepDrawerOpenUntil) {
        openCartDrawer();
      }
      window.setTimeout(flushPendingCartHighlight, 180);
      scheduleCartUpdate(120);
    });
    window.jQuery(document).ajaxComplete(function (_event, _xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : "";
      if (url.indexOf("/cart") !== -1 || url.indexOf("sections=cart") !== -1) {
        renderCountdown();
        scheduleCartUpdate(140);
        window.setTimeout(flushPendingCartHighlight, 220);
      }
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches("[data-toa-cart-panel], .cart-summary") ||
            node.querySelector && node.querySelector("[data-toa-cart-panel], .cart-summary")
          );
        });
      });
      if (!relevant) return;
      seedFreshFreeShippingPanels();
      window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(function () {
        injectStyle();
        normaliseProductAddButtons(document);
        renderCountdown();
        scheduleCartUpdate(140);
        flushPendingCartHighlight();
      }, 70);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  injectStyle();
  normaliseProductAddButtons(document);
  renderCountdown();
  window.setInterval(renderCountdown, 1000);
  scheduleCartUpdate(120);
})();

/* TOA mobile lunch link start */
(function () {
  "use strict";

  var lunchUrl = "/?toa_view=market#mittagstisch";

  function isLunchShortcut(link) {
    if (!link || !link.matches(".toa-mobile-quick-actions__item")) return false;
    var text = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
    var href = link.getAttribute("href") || "";
    return text === "mittag" || text.indexOf("mittagstisch") !== -1 || href === "#mittagstisch";
  }

  function repairLinks() {
    document.querySelectorAll(".toa-mobile-quick-actions__item").forEach(function (link) {
      if (!isLunchShortcut(link)) return;
      link.setAttribute("href", lunchUrl);
      link.setAttribute("aria-label", "Mittagstisch ansehen");
    });
  }

  function scrollToLunch() {
    if (window.location.hash !== "#mittagstisch") return;
    var params = new URLSearchParams(window.location.search);
    if (params.get("toa_view") !== "market") return;
    var target = document.getElementById("mittagstisch");
    if (!target || !target.getClientRects().length) return;
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function run() {
    repairLinks();
    scrollToLunch();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  window.addEventListener("load", function () { setTimeout(run, 120); });
  window.addEventListener("pageshow", run);
  setTimeout(run, 500);
  setTimeout(run, 1400);

  try {
    new MutationObserver(repairLinks).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  } catch (error) {}
})();

/* TOA mobile lunch link end */

/* TOA mobile product navigation start */
(function () {
  "use strict";

  var allProductsUrl = "/collections/all?toa_open=filter";
  var groupNames = ["grundsortiment", "snacks & getraenke", "snacks & getränke", "nach land", "weitere sortimente"];

  function normalizedText(node) {
    return (node && node.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function setLabel(item, label) {
    var candidates = item.querySelectorAll("span, strong, b, small");
    for (var i = candidates.length - 1; i >= 0; i -= 1) {
      var candidate = candidates[i];
      if (candidate.querySelector("svg, img")) continue;
      if (normalizedText(candidate)) {
        if (candidate.textContent !== label) candidate.textContent = label;
        return;
      }
    }
    for (var j = item.childNodes.length - 1; j >= 0; j -= 1) {
      if (item.childNodes[j].nodeType === 3 && item.childNodes[j].nodeValue.trim()) {
        if (item.childNodes[j].nodeValue !== label) item.childNodes[j].nodeValue = label;
        return;
      }
    }
    var text = document.createElement("span");
    text.className = "toa-mobile-quick-actions__label";
    text.textContent = label;
    item.appendChild(text);
  }

  function findOriginalProductButton() {
    var items = document.querySelectorAll(".toa-mobile-quick-actions__item");
    for (var i = 0; i < items.length; i += 1) {
      var text = normalizedText(items[i]);
      if (text === "produkte" || text === "sortiment") return items[i];
    }
    return null;
  }

  function expandProductGroups() {
    document.querySelectorAll("details").forEach(function (detail) {
      var summary = detail.querySelector("summary");
      if (groupNames.indexOf(normalizedText(summary)) !== -1) detail.open = true;
    });
    document.querySelectorAll("button, [role='button']").forEach(function (button) {
      if (groupNames.indexOf(normalizedText(button)) === -1) return;
      if (button.getAttribute("aria-expanded") === "false") button.click();
    });
  }

  function scheduleExpansion() {
    [40, 140, 360, 800].forEach(function (delay) {
      window.setTimeout(expandProductGroups, delay);
    });
  }

  function clearThemeActiveState(item) {
    if (!item) return;
    // TOA preserve mobile quick-action active state v3: `is-active` and aria-current belong to the
    // unified quick-action controller and must survive menu maintenance.
    ["active", "current", "selected", "toa-mobile-quick-actions__item--active"].forEach(function (name) {
      item.classList.remove(name);
    });
  }

  function closeAssortmentDrawer() {
    var drawer = document.getElementById("toa-assortment-drawer");
    if (drawer) drawer.remove();
    document.documentElement.classList.remove("toa-assortment-open");
    document.body.classList.remove("toa-assortment-open");
    var assortment = document.querySelector("[data-toa-assortment-expansion='1']");
    if (assortment) assortment.classList.remove("toa-mobile-product-selected");
  }

  function showAssortmentDrawer() {
    // TOA canonical Sortiment drawer v1: never clone the product menu outside #mobile-nav.
    // Returning false deliberately continues through openAssortment(), which
    // opens the theme navigation and its canonical, fully styled product panel.
    closeAssortmentDrawer();
    return false;
  }

  function nativeClick(element) {
    if (!element) return false;
    try {
      HTMLElement.prototype.click.call(element);
      return true;
    } catch (error) {}
    try {
      var clickEvent = document.createEvent("MouseEvents");
      clickEvent.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
      return Element.prototype.dispatchEvent.call(element, clickEvent);
    } catch (error) {}
    return false;
  }

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.left < window.innerWidth;
  }

  function findMobileProductTrigger() {
    var nav = document.querySelector("#mobile-nav");
    if (!nav) return null;
    var productRoot = nav.querySelector('[data-sub-nav="menu-1"]');
    if (productRoot) return productRoot;
    var items = nav.querySelectorAll(".nav-item");
    for (var i = 0; i < items.length; i += 1) {
      var directLink = items[i].querySelector(":scope > a, :scope > .nav-item-link");
      var trigger = items[i].querySelector(":scope > [data-sub-nav], :scope > * > [data-sub-nav]");
      if (directLink && trigger && (normalizedText(directLink) === "produkte" || normalizedText(directLink) === "sortiment")) return trigger;
    }
    var fallback = nav.querySelector(".toa-mobile-product-menu-ready [data-sub-nav]");
    return fallback || null;
  }

  function openAssortment(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    if (typeof window.toaCartDrawerCancelPendingClose === "function") {
      window.toaCartDrawerCancelPendingClose();
    }
    window.__toaMobileBottomCartOpen = false;
    document.documentElement.classList.remove("toa-cart-close-guard", "show-cart-summary");
    document.body.classList.remove("toa-cart-close-guard", "show-cart-summary", "product-added-to-cart", "updating-cart");
    document.querySelectorAll("[data-toa-mobile-cart]").forEach(function (button) {
      button.classList.remove("is-active", "is-cart-open");
      button.removeAttribute("aria-current");
    });
    var assortment = document.querySelector("[data-toa-assortment-expansion='1']");
    markSelected(assortment);

    // Das Theme-Untermenue wird auf einigen Seiten zwar befuellt, bleibt aber
    // durch dessen Slider-Zustand unsichtbar. Eine sichtbare Kopie ist hier
    // stabiler und verwendet weiterhin exakt dieselben Shopify-Navigationsdaten.
    if (showAssortmentDrawer()) return true;

    var mobileNav = document.querySelector("#mobile-nav");
    var trigger = findMobileProductTrigger();
    var menuToggle = document.querySelector(".toa-top-app-header__menu") || document.querySelector(".toggle-mob-nav");
    if (!mobileNav || !trigger || !menuToggle) {
      if (event && event.isTrusted) window.location.assign("/collections/all?toa_open_sortiment=1");
      return false;
    }

    document.querySelectorAll(".cart-summary").forEach(function (cart) { cart.classList.remove("active"); });
    document.body.classList.remove("show-cart-summary", "product-added-to-cart");

    function themeClick(element) {
      // TOA canonical native Sortiment click v2: the sticky header listens to native capture events.
      return nativeClick(element);
    }

    var navAlreadyOpen = document.body.classList.contains("toa-mobile-menu-open") ||
      document.body.classList.contains("show-mobile-nav") ||
      mobileNav.classList.contains("active") ||
      isVisible(mobileNav);
    if (!navAlreadyOpen) {
      themeClick(menuToggle);
    }

    var attempts = 0;
    function openProductPanelWhenReady() {
      attempts += 1;
      var currentNav = document.querySelector("#mobile-nav");
      var currentTrigger = findMobileProductTrigger();
      var navReady = currentNav && (
        currentNav.classList.contains("active") ||
        document.body.classList.contains("show-mobile-nav") ||
        isVisible(currentNav)
      );
      if (!navReady || !currentTrigger) {
        if (attempts < 20) window.setTimeout(openProductPanelWhenReady, 100);
        return;
      }
      if (currentTrigger.getAttribute("aria-expanded") === "true") {
        scheduleExpansion();
        return;
      }
      themeClick(currentTrigger);
      window.setTimeout(function () {
        var verifiedTrigger = findMobileProductTrigger();
        if (verifiedTrigger && verifiedTrigger.getAttribute("aria-expanded") === "true") {
          scheduleExpansion();
        } else if (attempts < 20) {
          window.setTimeout(openProductPanelWhenReady, 120);
        }
      }, 220);
    }
    window.setTimeout(openProductPanelWhenReady, 100);
    return true;
  }

  function markSelected(item) {
    document.querySelectorAll(".toa-mobile-quick-actions__item").forEach(function (entry) {
      entry.classList.remove("toa-mobile-product-selected");
    });
    if (item) item.classList.add("toa-mobile-product-selected");
  }

  function goToAllProducts() {
    try { window.sessionStorage.setItem("toa_open_product_filter", "1"); } catch (error) {}
    markSelected(document.querySelector("[data-toa-all-products='1']"));
    return true;
  }

  function installRecipesButton(assortment) {
    var bar = assortment && assortment.parentNode;
    if (!bar) return;
    var generatedRecipes = bar.querySelector("[data-toa-recipes='1']");
    var nativeRecipes = bar.querySelector(".toa-mobile-quick-actions__item--recipes");
    var recipes = nativeRecipes || generatedRecipes;
    if (nativeRecipes && generatedRecipes && nativeRecipes !== generatedRecipes) generatedRecipes.remove();
    if (nativeRecipes) nativeRecipes.dataset.toaRecipes = "1";
    if (!recipes) {
      recipes = assortment.cloneNode(true);
      Array.prototype.slice.call(recipes.attributes).forEach(function (attribute) {
        if (attribute.name.indexOf("data-") === 0 || attribute.name === "onclick" || attribute.name === "aria-controls" || attribute.name === "aria-expanded") {
          recipes.removeAttribute(attribute.name);
        }
      });
      recipes.dataset.toaRecipes = "1";
      recipes.removeAttribute("id");
      recipes.setAttribute("href", "/pages/rezeptideen");
      recipes.setAttribute("aria-label", "Rezepte ansehen");
      clearThemeActiveState(recipes);
      var icon = recipes.querySelector("svg");
      if (icon) {
        icon.setAttribute("viewBox", "0 0 24 24");
        icon.setAttribute("fill", "none");
        icon.setAttribute("stroke", "currentColor");
        icon.setAttribute("stroke-width", "2");
        icon.innerHTML = '<path d="M2 4.5A2.5 2.5 0 0 1 4.5 2H11v18H4.5A2.5 2.5 0 0 0 2 22z"></path><path d="M22 4.5A2.5 2.5 0 0 0 19.5 2H13v18h6.5A2.5 2.5 0 0 1 22 22z"></path>';
      }
      setLabel(recipes, "Rezepte");
    }
    recipes.setAttribute("href", "/pages/rezeptideen");
    clearThemeActiveState(recipes);
    setLabel(recipes, "Rezepte");
    // Immer die letzte Position, auch wenn das Theme die Leiste neu rendert.
    if (bar.lastElementChild !== recipes) bar.appendChild(recipes);
  }

  function install() {
    var assortment = findOriginalProductButton();
    if (!assortment) return;

    setLabel(assortment, "Sortiment");
    clearThemeActiveState(assortment);
    assortment.setAttribute("aria-label", "Sortiment öffnen");
    assortment.setAttribute("href", "#toa-sortiment");
    assortment.dataset.toaAssortmentExpansion = "1";
    assortment.onclick = function (event) {
      return openAssortment(event);
    };
    delete assortment.dataset.toaAssortmentBound;

    var existing = document.querySelector(".toa-mobile-quick-actions__item[data-toa-all-products='1']");
    if (existing) {
      clearThemeActiveState(existing);
      setLabel(existing, "Alle Produkte");
      existing.setAttribute("href", allProductsUrl);
      installRecipesButton(assortment);
      return;
    }

    var allProducts = assortment.cloneNode(true);
    Array.prototype.slice.call(allProducts.attributes).forEach(function (attribute) {
      if (attribute.name.indexOf("data-") === 0 || attribute.name === "onclick" || attribute.name === "aria-controls" || attribute.name === "aria-expanded") {
        allProducts.removeAttribute(attribute.name);
      }
    });
    allProducts.dataset.toaAllProducts = "1";
    delete allProducts.dataset.toaAssortmentExpansion;
    allProducts.removeAttribute("id");
    clearThemeActiveState(allProducts);
    allProducts.setAttribute("href", allProductsUrl);
    allProducts.setAttribute("aria-label", "Alle Produkte ansehen");
    setLabel(allProducts, "Alle Produkte");
    allProducts.onclick = goToAllProducts;
    allProducts.addEventListener("click", goToAllProducts, true);
    assortment.parentNode.insertBefore(allProducts, assortment);
    installRecipesButton(assortment);
  }

  function installDelegatedNavigation() {
    if (window.__toaMobileProductNavigationDelegated) return;
    window.__toaMobileProductNavigationDelegated = true;
    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest("[data-toa-assortment-expansion='1'],[data-toa-all-products='1']")
        : null;
      if (!target) return;
      if (target.matches("[data-toa-assortment-expansion='1']")) {
        // Der normale Link ist absichtlich die robuste Navigation. Auf der
        // Zielseite öffnet toa_open_sortiment das Originalmenü automatisch.
        return;
      }
      goToAllProducts(event);
    }, true);
  }

  function injectStyle() {
    if (document.getElementById("toa-mobile-product-navigation-style")) return;
    var style = document.createElement("style");
    style.id = "toa-mobile-product-navigation-style";
    style.textContent = "@media(max-width:767px){html.toa-assortment-open,body.toa-assortment-open{overflow:hidden!important}.toa-mobile-quick-actions__item{min-width:0!important}.toa-mobile-quick-actions__item .toa-mobile-quick-actions__label{white-space:normal!important;line-height:1.05!important}.toa-mobile-quick-actions__item[data-toa-all-products='1']{font-size:clamp(10px,2.7vw,12px)!important}.toa-mobile-quick-actions__item[data-toa-all-products='1'],.toa-mobile-quick-actions__item[data-toa-assortment-expansion='1']{background:#315f32!important;border-color:#315f32!important;color:#fff!important}.toa-mobile-quick-actions__item[data-toa-all-products='1']:active,.toa-mobile-quick-actions__item[data-toa-assortment-expansion='1']:active,.toa-mobile-quick-actions__item.toa-mobile-product-selected{background:#c7352c!important;border-color:#c7352c!important;color:#fff!important}#toa-assortment-drawer{position:fixed;inset:0;z-index:2147483000;display:block}.toa-assortment-backdrop{position:absolute;inset:0;width:100%;height:100%;border:0;background:rgba(12,43,25,.66)}.toa-assortment-sheet{position:absolute;inset:0 auto 0 0;width:min(88vw,430px);overflow-y:auto;overscroll-behavior:contain;background:#fffaf0;color:#173f27;padding:20px 18px 110px;box-shadow:12px 0 30px rgba(0,0,0,.22)}.toa-assortment-close{position:sticky;top:0;z-index:20;display:grid;place-items:center;margin:0 0 8px auto;width:44px;height:44px;border:1px solid #c9d6ca;border-radius:50%;background:#fff;color:#173f27;font-size:30px;line-height:1}.toa-assortment-content,.toa-assortment-content *{visibility:visible!important;opacity:1!important}.toa-assortment-content .toa-mobile-product-menu{display:block!important;transform:none!important;position:static!important;width:100%!important;height:auto!important;max-height:none!important;overflow:visible!important;color:#173f27!important}.toa-assortment-content details{display:block!important}.toa-assortment-content details>summary{cursor:pointer}.toa-assortment-content .toa-mobile-product-menu__group{display:block!important}.toa-assortment-content .toa-mobile-product-menu__quick,.toa-assortment-content .toa-mobile-product-menu__links{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:10px!important}.toa-assortment-content .toa-product-mega__tile{display:grid!important;grid-template-columns:46% 54%!important;align-items:center!important;min-height:104px!important;margin:0!important;border:1px solid #eadfc5!important;border-radius:10px!important;background:#fffdf7!important;overflow:hidden!important;text-decoration:none!important}.toa-assortment-content .toa-product-mega__tile img{display:block!important;width:100%!important;height:100%!important;min-height:102px!important;object-fit:contain!important}.toa-assortment-content .toa-product-mega__tile span{display:block!important;position:static!important;padding:8px 10px!important;color:#173f27!important;font-weight:700!important;line-height:1.15!important}.toa-mobile-quick-actions__item[data-toa-recipes='1']{order:99}}";
    document.head.appendChild(style);
  }

  function run() {
    injectStyle();
    installDelegatedNavigation();
    install();
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("toa_open_sortiment") === "1") {
        window.setTimeout(function () {
          if (!openAssortment()) return;
          params.delete("toa_open_sortiment");
          var query = params.toString();
          window.history.replaceState({}, "", window.location.pathname + (query ? "?" + query : "") + window.location.hash);
        }, 180);
      }
    } catch (error) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
  else run();
  window.addEventListener("load", function () { window.setTimeout(run, 100); });
  window.addEventListener("pageshow", run);
  [120, 350].forEach(function (delay) { window.setTimeout(run, delay); });
  try {
    new MutationObserver(function (mutations) {
      var quickActionsAdded = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches(".toa-mobile-quick-actions") ||
            node.querySelector && node.querySelector(".toa-mobile-quick-actions")
          );
        });
      });
      if (quickActionsAdded) run();
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (error) {}
})();
/* TOA mobile product navigation end */
/* TOA FREE GIFT SELECTOR START */
(() => {
  'use strict';
  if (window.__toaFreeGiftSelectorLoaded) return;
  window.__toaFreeGiftSelectorLoaded = true;
  const cfg = {"enabled":true,"firstGiftThresholdCents":4900,"premiumGiftThresholdCents":10000,"firstTierGiftCount":1,"premiumTierGiftCount":3,"maxGiftsPerOrder":3,"candidates":[{"variantId":"51155882377449","title":"Shine Muscat Ade CAFE REAL 230ml","sku":"18105","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/8808024030827.jpg?v=1780863102","inventoryQuantity":265},{"variantId":"43142659637481","title":"Black Pepper Ramen OBENTO 240g","sku":"12017","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/black-pepper-ramen-obento-240g-toa-1200.jpg?v=1779637456","inventoryQuantity":106},{"variantId":"43136983302377","title":"Tempura Original TAOKAENOI 40g","sku":"5775","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/tempura-original-taokaenoi-40g_toa-1200.jpg?v=1782241907","inventoryQuantity":369},{"variantId":"51605827617001","title":"Hi Tempura Spicy TAOKAENOI 40g","sku":"5776","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/8858702401272.jpg?v=1785530886","inventoryQuantity":372},{"variantId":"43142659670249","title":"Spicy Sesame Ramen OBENTO 240g","sku":"12018","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/spicy-sesame-ramen-obento-240g_toa-1200.jpg?v=1782241857","inventoryQuantity":104},{"variantId":"43142659703017","title":"Mongolian Ramen OBENTO 240g","sku":"12019","image":"https://cdn.shopify.com/s/files/1/0642/4897/1497/files/mongolian-ramen-obento-240g_toa-1200.jpg?v=1782241595","inventoryQuantity":105}]};
  const marker = 'true';
  const logicalControlsVersion = '20260808w';
  const logicalBoundControls = new WeakSet();
  let busy = false;
  let refreshTimer = null;
  let trailingRefreshTimer = null;
  let duplicateMergeTimer = null;
  let lastRenderedCartToken = '';
  let latestCart = null;
  let giftQuantityMutation = false;
  let duplicateMergeBusy = false;
  let suppressThemeQuantityUntil = 0;
  let reconcileRunning = false;
  let reconcileRequested = false;
  let cartControlBusy = false;
  let checkoutGiftBusy = false;
  const queuedPaidDeltas = new Map();
  const giftSelectionStorageKey = 'toa_free_gift_variants';
  const legacyGiftSelectionStorageKey = 'toa_free_gift_variant';
  const rememberedGiftVariants = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(giftSelectionStorageKey) || '[]');
      const legacy = String(window.localStorage.getItem(legacyGiftSelectionStorageKey) || '');
      const values = Array.isArray(stored) ? stored : [];
      if (!values.length && legacy) values.push(legacy);
      return Array.from(new Set(values.map(String).filter(Boolean))).slice(0, cfg.maxGiftsPerOrder);
    } catch (_) { return []; }
  };
  const rememberGiftVariants = variantIds => {
    try {
      const values = Array.from(new Set((variantIds || []).map(String).filter(Boolean))).slice(0, cfg.maxGiftsPerOrder);
      if (values.length) window.localStorage.setItem(giftSelectionStorageKey, JSON.stringify(values));
      else window.localStorage.removeItem(giftSelectionStorageKey);
      window.localStorage.removeItem(legacyGiftSelectionStorageKey);
    } catch (_) {}
  };

  const isGift = item => String(item?.properties?._toa_free_gift || '') === marker;
  const isPaidGiftExtra = item => String(item?.properties?._toa_paid_gift_extra || '') === marker;
  const isPfand = item => String(item?.properties?._toa_pfand || '') === marker ||
    String(item?.properties?._toa_pfand_auto || '') === marker || /pfand/i.test(String(item?.sku || ''));
  const eligibleSubtotal = cart => (cart?.items || []).reduce((sum, item) => {
    if (isGift(item) || isPfand(item)) return sum;
    // Shopify applies the automatic gift discount before this selector renders.
    // The 100 EUR threshold must therefore use the merchandise value before
    // discounts; otherwise the newly granted gift can hide its own selector.
    return sum + Number(item.original_line_price ?? item.line_price ?? item.final_line_price ?? 0);
  }, 0);
  const giftCountForSubtotal = subtotal => {
    if (subtotal >= cfg.premiumGiftThresholdCents) return cfg.premiumTierGiftCount;
    if (subtotal >= cfg.firstGiftThresholdCents) return cfg.firstTierGiftCount;
    return 0;
  };
  const money = cents => new Intl.NumberFormat('de-DE', {style:'currency', currency:'EUR'}).format(cents / 100);
  const showCartError = error => {
    const raw = String(error?.message || error || '');
    const status = Number(error?.status || 0);
    const phase = error?.phase ? ` (${error.phase})` : '';
    let message = status === 429 || /too many requests|cart\.js 429/i.test(raw)
      ? 'Zu viele Warenkorb-Anfragen. Bitte die Shop-Tabs schließen und nach einer Minute erneut öffnen.'
      : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte erneut versuchen.';
    if (status === 422) message = 'Ein Artikel oder Gratisgeschenk kann gerade nicht hinzugefügt werden. Bitte Verfügbarkeit und Menge prüfen.';
    message += (status ? ` [${status}]` : '') + phase;
    let notice = document.querySelector('[data-toa-cart-error]');
    if (!notice) {
      notice = document.createElement('div');
      notice.dataset.toaCartError = 'true';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'position:fixed;left:50%;bottom:24px;z-index:2147483647;transform:translateX(-50%);max-width:min(92vw,620px);padding:12px 16px;border-radius:8px;background:#8b1e1e;color:#fff;font:600 15px/1.35 system-ui;box-shadow:0 8px 24px rgba(0,0,0,.24)';
      document.body.appendChild(notice);
    }
    notice.textContent = message;
    clearTimeout(showCartError.timer);
    showCartError.timer = setTimeout(() => notice.remove(), 6000);
    console.error('[TOA Warenkorb]', error);
  };
  const giftLabel = count => count === 1 ? '1 Gratisgeschenk' : `${count} Gratisgeschenke`;
  const ensureDesktopCartCountStyle = () => {
    if (document.getElementById('toa-desktop-cart-count-style')) return;
    const style = document.createElement('style');
    style.id = 'toa-desktop-cart-count-style';
    style.textContent = `
      @media (min-width: 769px) {
        .current-cart .current-cart-count {
          align-items: center !important;
          background: #89c21e !important;
          border-radius: 999px !important;
          box-sizing: border-box !important;
          color: #ffffff !important;
          display: flex !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          height: 18px !important;
          justify-content: center !important;
          left: 16px !important;
          line-height: 1 !important;
          min-width: 18px !important;
          padding: 0 4px !important;
          top: -6px !important;
          width: auto !important;
          z-index: 2 !important;
        }

        .current-cart .current-cart-count::before {
          content: none !important;
          display: none !important;
        }

        .current-cart .current-cart-count[hidden] {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const updateCartCountDisplay = (rawCount, cart = null) => {
    ensureDesktopCartCountStyle();
    const count = Math.max(0, Math.floor(Number(rawCount) || 0));
    const selectors = [
      '[data-cart-count]', '[data-cart-item-count]', '[data-cart-count-bubble]',
      '.cart-count', '.cart-count-bubble', '.cart-link__count',
      '.header__cart-count', '.header-cart-count', '.site-header__cart-count',
      '.cart-item-count', '.cart-summary-count', '.current-cart-count',
      '[data-toa-mobile-cart-count]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(element => {
      element.setAttribute('data-cart-count', String(count));
      element.setAttribute('data-cart-item-count', String(count));
      const directCountTarget = element.matches('input, .current-cart-count, [data-toa-mobile-cart-count]');
      const valueTarget = directCountTarget
        ? element
        : element.querySelector('[data-cart-count-value], span') || element;
      const renderedCount = element.matches('[data-toa-mobile-cart-count]') && count > 99 ? '99+' : String(count);
      if (valueTarget.matches?.('input')) valueTarget.value = renderedCount;
      else if (valueTarget.textContent !== renderedCount) valueTarget.textContent = renderedCount;
      element.hidden = element.matches('.current-cart-count, [data-toa-mobile-cart-count]') && count === 0;
      element.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('a[href="/cart"], a[href^="/cart?"]').forEach(link => {
      const label = String(link.getAttribute('aria-label') || 'Warenkorb')
        .replace(/\s*\(?\d+\s*(?:Artikel)?\)?\s*$/i, '');
      link.setAttribute('aria-label', `${label} (${count} Artikel)`);
    });
    document.dispatchEvent(new CustomEvent('toa:cart-count-updated', {
      bubbles:true, detail:{count, cart}
    }));
  };
  const updateCartIndicators = cart => {
    if (cart !== window.toaCartState.current || window.toaCartState.pending) return;
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) return;
    const count = Number.isFinite(Number(cart.item_count))
      ? Number(cart.item_count)
      : cart.items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    updateCartCountDisplay(count, cart);
  };
  // Wait for the server response instead of replaying stale optimistic counts.
  const updateCartCountOptimistically = () => {};
  const displayedCartCount = () => {
    const node = document.querySelector('.current-cart-count, [data-toa-mobile-cart-count]');
    const parsed = Number.parseInt(String(node?.textContent || '').replace(/\D/g, ''), 10);
    return Number.isFinite(parsed) ? parsed : Number(latestCart?.item_count || 0);
  };
  // The native theme controls can be clicked briefly before the logical cart
  // controls finish binding after a drawer redraw. Mirror their intended count
  // immediately as well; the Ajax cart response confirms the authoritative
  // value a moment later.
  document.addEventListener('click', event => {
    const control = event.target?.closest?.([
      '.cart-summary .qty-adjuster__down', '.cart-summary .qty-adjuster__up',
      '.cart-summary .qty-adjuster__remove',
      '.cart-summary .cart-summary-item__remove', '.cart-summary .cart-item__remove',
      '.cart-summary [data-remove]', '.cart-summary [data-cart-remove]',
      '.cart-summary cart-remove-button a'
    ].join(','));
    if (!control || control.disabled || control.matches(
      '[data-toa-logical-minus="true"],[data-toa-logical-plus="true"],[data-toa-logical-remove="true"]'
    )) return;
    let delta = 0;
    if (control.matches('.qty-adjuster__down')) delta = -1;
    else if (control.matches('.qty-adjuster__up')) delta = 1;
    else {
      const row = control.closest('.cart-summary-item-container,.cart-summary-item,li.cart-item,[data-cart-item],.ajaxcart__product');
      const input = row?.querySelector?.(quantityInputSelector);
      delta = -Math.max(1, Number.parseInt(String(input?.value || '1'), 10) || 1);
    }
    updateCartCountOptimistically(displayedCartCount() + delta);
  }, true);
  const cartResponseError = async (response, endpoint) => {
    const error = new Error(`Warenkorb-Anfrage fehlgeschlagen: ${endpoint} (${response.status})`);
    error.status = response.status;
    error.phase = endpoint;
    return error;
  };
  const http = (url, options = {}) => {
    if (Date.now() < Number(window.__toaCartBlockedUntil || 0)) {
      const error = new Error('cart cooldown'); error.status = 429;
      return Promise.reject(error);
    }
    if (typeof window.fetch === 'function') return window.fetch(url, options).then(response => {
      if (response.status === 429) window.__toaCartBlockedUntil = Date.now() + 60000;
      return response;
    });
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open(options.method || 'GET', url, true);
      Object.entries(options.headers || {}).forEach(([name, value]) => request.setRequestHeader(name, value));
      request.onload = () => resolve({
        ok: request.status >= 200 && request.status < 300,
        status: request.status,
        text: async () => request.responseText,
        json: async () => JSON.parse(request.responseText)
      });
      request.onerror = () => reject(new Error(`Netzwerkfehler bei ${url}`));
      request.send(options.body || null);
    });
  };
  const cartJson = () => window.toaCartState.read();
  const updateCart = async updates => {
    const response = await http('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({updates})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/update.js');
    const cart = await response.json();
    updateCartIndicators(cart);
    return cart;
  };
  const mergeProperties = item => Object.entries(item?.properties || {})
    .filter(([name, value]) => name !== '_EAN' && value != null && String(value).trim() !== '')
    .sort(([left], [right]) => left.localeCompare(right))
    .map(([name, value]) => `${name}=${String(value).trim()}`)
    .join('|');
  const canMerge = item => !isGift(item) && !isPfand(item) && !item?.selling_plan_allocation;
  const cartLineSignature = cart => (cart?.items || [])
    .map(item => `${item.key}:${Number(item.quantity || 0)}`)
    .sort()
    .join('|');
  const matchingLogicalLines = (cart, variantId, lineClass) => (cart?.items || [])
    .map((item, index) => ({item, line:index + 1}))
    .filter(entry => canMerge(entry.item) &&
      String(entry.item.variant_id) === String(variantId) &&
      (isPaidGiftExtra(entry.item) ? 'paid-gift-extra' : 'merchandise') === lineClass
    );
  const addLogicalQuantity = async (variantId, lineClass, quantity) => {
    if (quantity < 1) return cartJson();
    if (lineClass === 'paid-gift-extra') {
      await addPaidGiftExtra(variantId, quantity);
      return cartJson();
    }
    const response = await http('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({items:[{id:Number(variantId), quantity:Number(quantity)}]})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/add.js');
    return cartJson();
  };
  const setLogicalGroupQuantity = async (cart, variantId, lineClass, quantity) => {
    let working = cart;
    const target = Math.max(0, Math.floor(Number(quantity || 0)));
    let group = matchingLogicalLines(working, variantId, lineClass);
    let current = group.reduce((sum, entry) => sum + Number(entry.item.quantity || 0), 0);
    if (target === current) return working;

    // Shopify deliberately splits ordinary merchandise at an automatic-discount
    // boundary. Never fight that split by merging line keys: it immediately
    // recreates the rows and makes the drawer jump. Increases are added as a
    // delta; decreases are distributed over the existing technical rows.
    if (target > current) return addLogicalQuantity(variantId, lineClass, target - current);
    let remove = current - target;
    for (let guard = 0; remove > 0 && guard < 20; guard += 1) {
      group = matchingLogicalLines(working, variantId, lineClass);
      if (!group.length) break;
      const entry = group[group.length - 1];
      const present = Number(entry.item.quantity || 0);
      const next = Math.max(0, present - remove);
      remove -= present - next;
      working = await changeLine(entry.item.key, next);
      working = await cartJson();
    }
    return working;
  };
  // Shopify may keep multiple technical rows for one product. They stay intact
  // server-side; the customer sees and edits one logical position.
  const mergeDuplicateItems = async cart => cart;
  const logicalLineClass = item => isPaidGiftExtra(item) ? 'paid-gift-extra' : 'merchandise';
  const logicalLineGroup = (cart, item) => (cart?.items || []).filter(candidate =>
    canMerge(candidate) && String(candidate.variant_id) === String(item.variant_id) &&
    logicalLineClass(candidate) === logicalLineClass(item)
  );
  const setLogicalQuantity = async (cart, item, quantity) => {
    return setLogicalGroupQuantity(
      cart,
      item.variant_id,
      logicalLineClass(item),
      quantity
    );
  };
  const renderedLineKey = (row, cart) => {
    const input = row?.querySelector?.('input[name^="updates["]');
    const match = String(input?.getAttribute('name') || '').match(/^updates\[(.+)\]$/);
    const candidates = [
      row?.getAttribute?.('data-line-item-key'), row?.getAttribute?.('data-key'),
      input?.getAttribute?.('data-line-item-key'), match?.[1]
    ].map(value => String(value || '')).filter(Boolean);
    const exact = candidates.find(candidate =>
      (cart?.items || []).some(item => String(item.key) === candidate)
    );
    if (exact) return exact;
    // Never translate a rendered line number to cart.items here. Immediately
    // after an Ajax mutation Shopify already returns the new cart order while
    // the theme still displays the old DOM order. Mapping those two orders is
    // what made unrelated products inherit the gift or another product's
    // quantity. Variant/title fallback below is stable across that redraw.
    return '';
  };
  const normalizedLineText = value => String(value || '').toLocaleLowerCase('de-DE')
    .replace(/\s+/g, ' ').trim();
  const renderedVariantId = row => {
    const input = row?.querySelector?.(
      '[data-toa-logical-variant], [data-variant-id], [data-product-id], [data-line-item-id]'
    );
    const values = [
      row?.dataset?.toaLogicalVariant, row?.dataset?.variantId, row?.dataset?.productId,
      row?.dataset?.lineItemId, input?.dataset?.toaLogicalVariant, input?.dataset?.variantId,
      input?.dataset?.productId, input?.dataset?.lineItemId
    ];
    for (const value of values) {
      const match = String(value || '').match(/\d{8,}/);
      if (match) return match[0];
    }
    const variantLink = row?.querySelector?.('a[href*="variant="]')?.getAttribute('href') || '';
    return String(variantLink.match(/[?&]variant=(\d+)/)?.[1] || '');
  };
  const quantityInputSelector = [
    '.qty-adjuster input', '.quantity input', 'input[name^="updates["]',
    'input[data-line]', 'input[data-line-item-key]', 'input[type="number"]'
  ].join(',');
  const renderedQuantityInput = row => row?.querySelector?.(quantityInputSelector) || null;
  const isolateRenderedControls = row => {
    const bindLogicalControl = control => {
      if (!control || logicalBoundControls.has(control)) return;
      logicalBoundControls.add(control);
      control.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const remove = control.matches('[data-toa-logical-remove="true"]');
        window.dispatchEvent(new CustomEvent(
          remove ? 'toa:logical-remove' : 'toa:logical-step',
          {detail: remove ? {removeButton: control} : {step: control}}
        ));
      }, true);
    };
    const neutralButton = (control, dataName, ariaLabel) => {
      if (!control) return null;
      if (control.tagName === 'BUTTON' && control.dataset[dataName] === marker) return control;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = control.className || '';
      button.innerHTML = control.innerHTML;
      button.setAttribute('aria-label', control.getAttribute('aria-label') || ariaLabel);
      button.dataset[dataName] = marker;
      control.replaceWith(button);
      return button;
    };
    if (!row) return;
    const input = renderedQuantityInput(row);
    if (input) {
      input.dataset.toaLogicalQuantity = marker;
      input.removeAttribute('name');
    }
    // The marker attributes survive some theme re-renders while DOM event
    // properties do not. Include the markers so every reconciliation binds
    // the controls again instead of leaving visually intact but dead buttons.
    let down = row.querySelector('[data-toa-logical-minus="true"], .qty-adjuster__down, [data-quantity-minus], button[name="minus"]');
    let up = row.querySelector('[data-toa-logical-plus="true"], .qty-adjuster__up, [data-quantity-plus], button[name="plus"]');
    down = neutralButton(down, 'toaLogicalMinus', 'Minus');
    up = neutralButton(up, 'toaLogicalPlus', 'Plus');
    if (down) {
      down.dataset.toaLogicalMinus = marker;
      down.classList.add('qty-adjuster__down');
      down.removeAttribute('data-quantity-minus');
      down.removeAttribute('name');
      if (down.matches('a')) down.setAttribute('href', '#');
      down.removeAttribute('onclick');
      bindLogicalControl(down);
    }
    if (up) {
      up.dataset.toaLogicalPlus = marker;
      up.classList.add('qty-adjuster__up');
      up.removeAttribute('data-quantity-plus');
      up.removeAttribute('name');
      if (up.matches('a')) up.setAttribute('href', '#');
      up.removeAttribute('onclick');
      bindLogicalControl(up);
    }
    let remove = row.querySelector('[data-toa-logical-remove="true"], cart-remove-button a, .qty-adjuster__remove, .cart-item__remove, .cart-summary-item__remove, [data-remove], [data-cart-remove]');
    remove = neutralButton(remove, 'toaLogicalRemove', 'Entfernen');
    if (remove) {
      remove.dataset.toaLogicalRemove = marker;
      remove.classList.remove('cart-item__remove', 'cart-summary-item__remove');
      remove.removeAttribute('data-remove');
      remove.removeAttribute('data-cart-remove');
      if (remove.matches('a')) remove.setAttribute('href', '#');
      remove.removeAttribute('onclick');
      bindLogicalControl(remove);
    }
  };
  // One stable delegated handler survives every Shopify theme redraw. The
  // controls themselves carry no competing click logic.
  document.addEventListener('click', event => {
    const control = event.target?.closest?.(
      '[data-toa-logical-plus="true"], [data-toa-logical-minus="true"], [data-toa-logical-remove="true"]'
    );
    if (!control) return;
    window.__toaClickSeen = Date.now();
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    window.dispatchEvent(new CustomEvent(
      control.matches('[data-toa-logical-remove="true"]') ? 'toa:logical-remove' : 'toa:logical-step',
      {detail: control.matches('[data-toa-logical-remove="true"]') ? {removeButton: control} : {step: control}}
    ));
  }, true);
  const resolveRenderedItem = (row, cart, includeGift = true) => {
    const key = renderedLineKey(row, cart);
    const exact = (cart?.items || []).find(item => String(item.key) === String(key));
    if (exact && (includeGift || !isGift(exact))) return exact;
    const variantId = String(row?.dataset?.toaLogicalVariant || renderedVariantId(row) || '');
    const lineClass = String(row?.dataset?.toaLogicalClass || 'merchandise');
    return (cart?.items || []).find(item =>
      (includeGift || !isGift(item)) && String(item.variant_id) === variantId &&
      (isGift(item) ? 'gift' : logicalLineClass(item)) ===
        (String(row?.dataset?.toaFreeGift || '') === marker ? 'gift' : lineClass)
    ) || null;
  };
  const renderedRows = () => {
    const selectors = [
      '.cart-summary-item-container', 'li.cart-item', '[data-cart-item]',
      '.ajaxcart__product', '.cart-summary-item'
    ];
    const candidates = Array.from(document.querySelectorAll(selectors.join(',')));
    return candidates.filter((row, index) => {
      if (candidates.indexOf(row) !== index) return false;
      return !candidates.some(other => other !== row && other.contains(row));
    });
  };
  const consolidateRenderedCartLines = cart => {
    if (!cart?.items) return;
    // The gift selector must never take ownership of ordinary Shopify cart
    // controls. It only hides the technical free-gift line; quantity, remove
    // and merge behaviour for paid merchandise stays entirely with the theme.
    const giftKeys = new Set((cart.items || []).filter(isGift).map(item => String(item.key || '')));
    const giftVariants = new Set((cart.items || []).filter(isGift).map(item => String(item.variant_id || '')));
    const giftTitles = new Set((cart.items || []).filter(isGift).map(item =>
      normalizedLineText(item.product_title || item.title)
    ).filter(Boolean));
    renderedRows().forEach(row => {
      // The selector itself contains the word "Gratisgeschenk". Never remove
      // a cart container that currently hosts the selector UI.
      if (row.matches?.('[data-toa-free-gift-selector="true"]') ||
          row.querySelector?.('[data-toa-free-gift-selector="true"]')) return;
      const key = String(renderedLineKey(row, cart) || '');
      const variant = String(renderedVariantId(row) || '');
      const text = normalizedLineText(row.textContent);
      const serializedAttributes = Array.from(row.querySelectorAll('*')).concat(row).map(node =>
        Array.from(node.attributes || []).map(attribute => `${attribute.name}=${attribute.value}`).join(' ')
      ).join(' ');
      const containsGiftKey = Array.from(giftKeys).some(giftKey =>
        giftKey && serializedAttributes.includes(giftKey)
      );
      const markedAsGift = text.includes('gratisgeschenk') || text.includes('gratis geschenk');
      const zeroPricedGift = (text.includes('0,00') || text.includes('kostenlos')) &&
        Array.from(giftTitles).some(title => title && text.includes(title));
      if ((key && giftKeys.has(key)) || containsGiftKey || markedAsGift ||
          (variant && giftVariants.has(variant) && zeroPricedGift)) {
        row.remove();
      }
    });
    // Discount allocations can render without a quantity input. Discover every
    // top-level line and map it by key first, then by variant/title as fallback.
    const rows = renderedRows();
    // Shopify may render discount allocations as multiple rows with the same
    // line-item key. Preserve every row instead of letting Map overwrite all
    // but the last one; each technical cart item consumes one rendered row.
    const rowsByKey = new Map();
    rows.forEach(row => {
      delete row.dataset.toaFreeGift;
      const key = String(renderedLineKey(row, cart));
      if (!key) return;
      const keyedRows = rowsByKey.get(key) || [];
      keyedRows.push(row);
      rowsByKey.set(key, keyedRows);
    });
    const findGiftRows = item => {
      const exactRows = rowsByKey.get(String(item.key)) || [];
      if (exactRows.length) return exactRows;
      const variantId = String(item.variant_id || '');
      const title = normalizedLineText(item.product_title || item.title);
      return rows.filter(row => {
        const text = normalizedLineText(row.textContent);
        if (!text.includes('gratisgeschenk')) return false;
        const renderedVariant = renderedVariantId(row);
        return (variantId && renderedVariant === variantId) || (title && text.includes(title));
      });
    };
    // Keep the visible gift row tied to its real Shopify identity. A newly
    // returned cart and the still-old DOM can have different line positions,
    // so line numbers are deliberately not used.
    (cart.items || []).filter(isGift).forEach(item => {
      const giftRows = findGiftRows(item);
      giftRows.forEach(row => {
        row.dataset.toaFreeGift = marker;
        row.dataset.toaGiftVariant = String(item.variant_id || '');
        row.dataset.toaGiftKey = String(item.key || '');
        row.remove();
      });
    });
    // Gifts are inserted only during checkout. Native paid cart rows and their
    // quantity controls must remain untouched while the cart is edited.
    return;
    const takeRenderedRow = key => {
      const keyedRows = rowsByKey.get(String(key)) || [];
      const row = keyedRows.find(candidate => !usedRows.has(candidate)) || null;
      if (row) usedRows.add(row);
      return row;
    };
    const usedRows = new Set();
    const takeFallbackRow = item => {
      const variantId = String(item.variant_id || '');
      const title = normalizedLineText(item.product_title || item.title);
      const row = rows.find(candidate => {
        if (usedRows.has(candidate)) return false;
        const text = normalizedLineText(candidate.textContent);
        if (text.includes('gratisgeschenk')) return false;
        const renderedVariant = renderedVariantId(candidate);
        return (variantId && renderedVariant === variantId) ||
          (title && text.includes(title));
      }) || null;
      if (row) usedRows.add(row);
      return row;
    };
    const groups = new Map();
    const desiredHidden = new Set();
    (cart.items || []).forEach(item => {
      if (!canMerge(item)) return;
      const signature = `${item.variant_id}|${logicalLineClass(item)}`;
      const group = groups.get(signature) || [];
      group.push(item); groups.set(signature, group);
    });
    groups.forEach(group => {
      // A single Shopify line is already rendered and controlled correctly by
      // the theme. Only take over when the automatic gift discount has split
      // one paid product into two or more technical cart lines.
      if (group.length < 2) return;
      const rendered = group.map(item => {
        const exact = takeRenderedRow(item.key);
        return {item, row:exact || takeFallbackRow(item)};
      }).filter(entry => entry.row);
      if (!rendered.length) return;
      const canonical = rendered[0].row;
      const total = group.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const input = canonical.querySelector('input[name^="updates["], .qty-adjuster input, .quantity input');
      if (input) {
        // Never overwrite a quantity while the customer is typing. The cart
        // observer runs frequently and previously changed "30" back to "1"
        // before Enter could commit it.
        const customerIsEditing = document.activeElement === input || input.dataset.toaQuantityEditing === 'true';
        if (!customerIsEditing) input.value = String(total);
        input.readOnly = false;
        input.removeAttribute('readonly');
        input.removeAttribute('maxlength');
        input.setAttribute('max', '9999');
        input.dataset.toaLogicalVariant = String(group[0].variant_id);
        input.dataset.toaLogicalClass = logicalLineClass(group[0]);
      }
      canonical.dataset.toaLogicalVariant = String(group[0].variant_id);
      canonical.dataset.toaLogicalClass = logicalLineClass(group[0]);
      isolateRenderedControls(canonical);
      const logicalTotal = group.reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
      const totalNode = canonical.querySelector(
        '.cart-summary-item__price .theme-money, .cart-summary-item__price .amount, ' +
        '.cart-summary-item__final-price .theme-money, .cart-summary-item__final-price, ' +
        '.cart-summary-item__total .theme-money, .cart-item__total .cart-item__price-current, ' +
        '[data-line-total] .theme-money, [data-line-total]'
      );
      if (totalNode) totalNode.textContent = money(logicalTotal);
      rendered.slice(1).forEach(entry => {
        desiredHidden.add(entry.row);
      });
      // The drawer can retain a stale technical split row after Shopify merges
      // the server-side cart back to one item (for example after gift removal).
      // Hide every unconsumed row for this paid variant until the theme redraws.
      const variantId = String(group[0].variant_id || '');
      rows.forEach(row => {
        if (usedRows.has(row) || !variantId) return;
        if (renderedVariantId(row) !== variantId) return;
        if (normalizedLineText(row.textContent).includes('gratisgeschenk')) return;
        desiredHidden.add(row);
      });
    });
    rows.forEach(row => {
      const shouldHide = desiredHidden.has(row);
      const isHiddenDuplicate = row.classList.contains('toa-logical-duplicate');
      if (shouldHide && !isHiddenDuplicate) {
        row.hidden = true;
        row.classList.add('toa-logical-duplicate');
      } else if (!shouldHide && isHiddenDuplicate) {
        row.hidden = false;
        row.classList.remove('toa-logical-duplicate');
      }
    });
  };
  const changeLine = async (key, quantity) => {
    const response = await http('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({id:key, quantity})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/change.js');
    const cart = await response.json();
    updateCartIndicators(cart);
    return cart;
  };
  const changeLineNumber = async (line, quantity) => {
    const response = await http('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({line:Number(line), quantity:Number(quantity)})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/change.js');
    const cart = await response.json();
    updateCartIndicators(cart);
    return cart;
  };
  const addGift = async variantId => {
    const response = await http('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({items:[{id:Number(variantId), quantity:1, properties:{_toa_free_gift:marker, Gratisgeschenk:'Ja'}}]})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/add.js');
    return response.json();
  };
  const addPaidGiftExtra = async (variantId, quantity) => {
    if (quantity < 1) return;
    const response = await http('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({items:[{
        id:Number(variantId), quantity:Number(quantity),
        // A second, stable public property makes Shopify keep this purchase
        // line separate from the immutable free-gift line on every theme and
        // discount recalculation.
        properties:{
          _toa_paid_gift_extra:marker,
          Zusatzmenge:'Kostenpflichtig'
        }
      }]})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/add.js');
    return response.json();
  };
  const purchaseExtraFromGift = async giftItem => {
    const cart = await cartJson();
    const currentGift = (cart.items || []).find(item =>
      isGift(item) && String(item.variant_id) === String(giftItem.variant_id)
    );
    if (!currentGift) throw new Error('Gratisgeschenk ist nicht mehr im Warenkorb.');
    // The existing free line is immutable. Removing and recreating it made
    // Shopify redistribute the automatic discount and briefly turned the gift
    // into a paid item. Plus only adds to the separately marked paid line.
    const beforePaid = (cart.items || [])
      .filter(item => isPaidGiftExtra(item) && String(item.variant_id) === String(giftItem.variant_id))
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    await addPaidGiftExtra(giftItem.variant_id, 1);
    const after = await cartJson();
    const afterGift = (after.items || []).find(item =>
      isGift(item) && String(item.variant_id) === String(giftItem.variant_id)
    );
    const afterPaid = (after.items || [])
      .filter(item => isPaidGiftExtra(item) && String(item.variant_id) === String(giftItem.variant_id))
      .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    if (!afterGift || Number(afterGift.quantity || 0) !== 1) {
      throw new Error('Das Gratisgeschenk konnte nicht unveraendert erhalten werden.');
    }
    if (afterPaid !== beforePaid + 1) {
      throw new Error('Die kostenpflichtige Zusatzmenge wurde nicht eindeutig angelegt.');
    }
    return after;
  };

  const stabilizeGiftDiscountLine = async cart => {
    // Never delete and recreate cart lines to influence Shopify's discount
    // allocation. Line rebuilding caused unrelated quantities to split or be
    // overwritten. The discount setup owns the price; this code only preserves
    // the three independent line identities.
    return cart;
  };
  const setGifts = async (cart, variantIds) => {
    for (const item of (cart.items || []).filter(isGift)) await changeLine(item.key, 0);
    if (!variantIds.length) return;
    const response = await http('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify({items:variantIds.map(variantId => ({
        id:Number(variantId), quantity:1,
        properties:{_toa_free_gift:marker, Gratisgeschenk:'Ja'}
      }))})
    });
    if (!response.ok) throw await cartResponseError(response, 'cart/add.js');
  };
  const notifyCartChanged = () => {
    document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
    document.dispatchEvent(new CustomEvent('toa:refresh-cart-view', {bubbles:true}));
  };
  const refreshCartViewOnce = () => {
    window.toaCartState.replay();
    const drawer = document.querySelector('.cart-summary');
    const scroller = drawer?.querySelector('.cart-summary__inner') || drawer;
    const scrollTop = Number(scroller?.scrollTop || 0);
    if (window.theme && typeof window.theme.updateCartSummaries === 'function') {
      window.theme.updateCartSummaries(true, true, false);
    } else {
      notifyCartChanged();
    }
    [120, 260, 520].forEach(delay => setTimeout(() => {
      const currentDrawer = document.querySelector('.cart-summary');
      const currentScroller = currentDrawer?.querySelector('.cart-summary__inner') || currentDrawer;
      if (currentScroller && scrollTop > 0) currentScroller.scrollTop = scrollTop;
      consolidateRenderedCartLines(latestCart);
    }, delay));
  };
  const removeAllGifts = async cart => {
    for (const item of (cart.items || []).filter(isGift)) await changeLine(item.key, 0);
  };
  const normalizeGiftQuantities = async cart => {
    const oversized = (cart.items || []).filter(item => isGift(item) && Number(item.quantity || 0) > 1);
    if (!oversized.length) return cart;
    for (const item of oversized) {
      const paidQuantity = Number(item.quantity || 0) - 1;
      await changeLine(item.key, 1);
      await addPaidGiftExtra(item.variant_id, paidQuantity);
    }
    notifyCartChanged();
    return cartJson();
  };
  const enforce = async cart => {
    const subtotal = eligibleSubtotal(cart);
    const allowedGiftCount = giftCountForSubtotal(subtotal);
    const gifts = (cart.items || []).filter(isGift);
    if (gifts.length && !checkoutGiftBusy) {
      const remembered = gifts.filter(item => cfg.candidates.some(candidate =>
        String(candidate.variantId) === String(item.variant_id)
      )).map(item => String(item.variant_id)).slice(0, allowedGiftCount);
      if (remembered.length && allowedGiftCount > 0) rememberGiftVariants(remembered);
      await removeAllGifts(cart);
      notifyCartChanged();
      return cartJson();
    }
    const stored = rememberedGiftVariants();
    if (allowedGiftCount === 0) rememberGiftVariants([]);
    else if (stored.length > allowedGiftCount) rememberGiftVariants(stored.slice(0, allowedGiftCount));
    return cart;
  };

  const style = () => {
    if (document.getElementById('toa-free-gift-style')) return;
    const el = document.createElement('style');
    el.id = 'toa-free-gift-style';
    el.textContent = `
      .toa-free-gift{margin:18px 0;padding:24px;border:1px solid #e4cfa5;border-radius:18px;background:linear-gradient(135deg,#fffdf7 0%,#fbf8ed 100%);color:#0b3e25;box-shadow:0 12px 30px rgba(61,48,22,.07)}
      .toa-free-gift[hidden]{display:none!important}.toa-free-gift__head{display:grid;grid-template-columns:64px minmax(0,1fr) auto;gap:16px;align-items:center;margin-bottom:22px}
      .toa-free-gift__gift-icon{display:grid;place-items:center;width:64px;height:64px;border-radius:50%;background:#fff;color:#8b5d00;font-size:32px;line-height:1;border:1px solid #f0e4c8;box-shadow:0 6px 18px rgba(89,62,18,.12)}
      .toa-free-gift__title{display:flex;align-items:center;gap:8px}.toa-free-gift__head strong{font-size:25px;line-height:1.1;letter-spacing:0;color:#073b20}.toa-free-gift__sparkles{color:#e8ac27;font-size:20px}.toa-free-gift__subline{display:block;margin-top:6px;font-size:15px;color:#3e4b43}
      .toa-free-gift__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:14px}
      .toa-free-gift__card{position:relative;display:grid;grid-template-columns:96px minmax(0,1fr) 36px;gap:16px;align-items:center;width:100%;min-height:148px;padding:18px;border:1px solid #e2d2b2!important;border-radius:14px;background:#fff!important;color:#123c28!important;text-align:left;font:inherit;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none;appearance:none;-webkit-appearance:none;transform:none!important;filter:none!important;animation:none!important;transition:border-color .15s ease,box-shadow .15s ease!important;box-shadow:0 4px 14px rgba(58,47,25,.04)}
      .toa-free-gift__card>*{pointer-events:none}
      .toa-free-gift__card:hover,.toa-free-gift__card:focus,.toa-free-gift__card:active{background:#fff!important;color:#123c28!important;transform:none!important;filter:none!important;animation:none!important;box-shadow:0 0 0 3px rgba(20,107,58,.12)!important}
      .toa-free-gift__card::before,.toa-free-gift__card::after{display:none!important;content:none!important;animation:none!important;transition:none!important}
      .toa-free-gift__card.is-selected{border-color:#08652f;background:#f8fff9;box-shadow:inset 0 0 0 1px #08652f}.toa-free-gift__card img{width:96px;height:104px;object-fit:contain;background:transparent}
      .toa-free-gift__card.is-selected,.toa-free-gift__card.is-selected:hover,.toa-free-gift__card.is-selected:focus,.toa-free-gift__card.is-selected:active{background:#f8fff9!important;border-color:#08652f!important;box-shadow:inset 0 0 0 1px #08652f!important}
      .toa-free-gift__card.is-replaced,.toa-free-gift__card.is-replaced:hover{background:#fff1ef!important;border-color:#c93b32!important;box-shadow:inset 0 0 0 1px #c93b32!important;color:#7b211b!important}
      .toa-free-gift__card:disabled{cursor:not-allowed!important;opacity:.62;background:#fff!important;border-color:#e6ddc9!important;box-shadow:none!important}.toa-free-gift__card:disabled:hover,.toa-free-gift__card:disabled:focus,.toa-free-gift__card:disabled:active{background:#fff!important;box-shadow:none!important}
      .toa-free-gift__card b{display:block;font-size:17px;line-height:1.3}.toa-free-gift__card small{display:inline-flex;align-items:center;margin-top:12px;padding:7px 11px;border-radius:999px;background:#f2f7ed;color:#176532;font-size:13px}.toa-free-gift__state{display:grid;place-items:center;width:32px;height:32px;border:2px solid #508764;border-radius:50%;font-size:18px;font-weight:900;color:transparent}.toa-free-gift__card.is-selected .toa-free-gift__state{border-color:#08652f;background:#08652f;color:#fff}
      .toa-free-gift__road{position:relative;height:92px;margin:8px 0 10px;padding:0 8px;overflow:hidden}
      .toa-free-gift__road-track{position:absolute;left:12px;right:62px;top:48px;height:8px;border-radius:999px;background:#dce7df}
      .toa-free-gift__road-fill{display:block;height:100%;border-radius:inherit;background:#19734c;transition:width .25s ease}
      .toa-free-gift__road-marker{position:absolute;top:39px;width:26px;height:26px;border:3px solid #fff;border-radius:50%;background:#19734c;box-shadow:0 1px 5px rgba(23,61,41,.3);transform:translateX(-50%);transition:left .25s ease}
      .toa-free-gift__road-start,.toa-free-gift__road-finish{position:absolute;top:66px;font-size:11px;font-weight:800;color:#52645a}
      .toa-free-gift__road-start{left:8px}.toa-free-gift__road-finish{right:4px;color:#176341}
      .toa-free-gift__road-gifts{position:absolute;right:2px;top:1px;display:flex;align-items:flex-end}
      .toa-free-gift__road-gifts img{width:46px;height:46px;object-fit:contain;border:1px solid #d8e2da;border-radius:7px;background:#fff;box-shadow:0 2px 5px rgba(23,61,41,.12)}
      .toa-free-gift__road-gifts img+img{margin-left:-9px}.toa-free-gift__road-label{position:absolute;left:8px;top:4px;font-size:12px;font-weight:700;color:#52645a}
      .toa-free-gift__teaser{display:flex;align-items:center;gap:10px}.toa-free-gift__teaser-images{display:flex}.toa-free-gift__teaser-images img{width:42px;height:42px;object-fit:contain;border:1px solid #d8e2da;border-radius:6px;background:#fff}.toa-free-gift__teaser-images img+img{margin-left:-7px}.toa-free-gift__teaser p{margin:0;font-size:12px;color:#52645a;line-height:1.35}
      .toa-free-gift__badge{display:inline-flex;align-items:center;gap:7px;justify-self:end;padding:9px 14px;border:1px solid #bed3b2;border-radius:999px;background:#eaf3e2;color:#155d2c;font-size:13px;font-weight:800;white-space:nowrap}.toa-free-gift__badge::before{content:'\\2713';display:grid;place-items:center;width:21px;height:21px;border-radius:50%;background:#09632d;color:#fff;font-size:13px}.toa-free-gift.is-unlocked{border-color:#d9bd84;background:linear-gradient(135deg,#fffdf7 0%,#f9f8ed 100%);animation:toaGiftReadyPulse .55s ease-in-out 2}
      @keyframes toaGiftReadyPulse{0%,100%{box-shadow:0 0 0 0 rgba(25,115,76,0)}50%{box-shadow:0 0 0 6px rgba(25,115,76,.28);border-color:#19734c}}
      @media(prefers-reduced-motion:reduce){.toa-free-gift.is-unlocked{animation:none}}
      .toa-free-gift__status{position:relative;margin:18px 0 0;padding-left:29px;font-size:14px;color:#37453e}.toa-free-gift__status::before{content:'\\1F381';position:absolute;left:0;top:-3px;font-size:20px}.toa-free-gift__error{color:#b42318}.toa-free-gift.is-busy{pointer-events:none}.toa-free-gift__card.is-pending{border-color:#19734c;box-shadow:inset 0 0 0 1px #19734c}.toa-free-gift__card.is-pending .toa-free-gift__state{border-color:#19734c;color:#19734c}
      .cart-summary .toa-free-gift{position:relative;z-index:3;flex:0 0 auto;margin:14px 16px}
      @media(max-width:768px){.toa-free-gift{width:auto;max-width:none;margin:10px 10px 14px!important;padding:16px;box-sizing:border-box;border-radius:14px;overflow:visible}.toa-free-gift__head{grid-template-columns:46px minmax(0,1fr);gap:11px;margin-bottom:16px}.toa-free-gift__gift-icon{width:46px;height:46px;font-size:24px}.toa-free-gift__head strong{font-size:20px}.toa-free-gift__sparkles{font-size:15px}.toa-free-gift__subline{font-size:13px;line-height:1.35}.toa-free-gift__badge{grid-column:1/-1;justify-self:start;margin-left:57px;padding:7px 11px}.toa-free-gift__grid{grid-template-columns:1fr;gap:10px}.toa-free-gift__card{min-height:112px;padding:12px;grid-template-columns:78px minmax(0,1fr) 30px;gap:11px}.toa-free-gift__card img{width:78px;height:84px}.toa-free-gift__card b{font-size:15px}.toa-free-gift__card small{font-size:12px;margin-top:8px;padding:5px 8px}.toa-free-gift__state{width:28px;height:28px}.toa-free-gift__status{font-size:13px;line-height:1.4}.cart-summary .toa-free-gift{position:relative;z-index:20;flex:none;width:calc(100% - 20px);max-width:calc(100% - 20px)}}
    `;
    document.head.appendChild(el);
  };
  const visible = element => !!element && (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length);
  const host = () => {
    const drawer = document.querySelector('.cart-summary');
    // The live theme uses more than one open-state class depending on how the
    // cart was opened. Visibility is the reliable source of truth.
    const drawerOpen = !!drawer && visible(drawer);
    if (drawerOpen) return drawer.querySelector('.cart-summary__inner') || drawer;
    const panels = Array.from(document.querySelectorAll('[data-toa-cart-panel]')).filter(visible);
    if (panels[0]) return panels[0].parentElement;
    const subtotals = Array.from(document.querySelectorAll('.cart-summary__subtotal')).filter(visible);
    if (subtotals[0]) return subtotals[0].parentElement;
    // Never fall back to a product add-to-cart form. On collection pages that
    // would mount the gift selector inside the first product card.
    const cartPageForm = Array.from(document.querySelectorAll('form[action="/cart"],form[action$="/cart"]')).find(form =>
      visible(form) && !form.querySelector('[name="id"]')
    );
    return cartPageForm || null;
  };
  const ensurePanel = () => {
    // The selector and a real free-gift cart line are different entities.
    // Never reuse the cart-line marker here: doing so can turn a product row
    // into the selector after Shopify redraws or reorders the cart.
    let panel = document.querySelector('[data-toa-free-gift-selector="true"]');
    const target = host();
    // Shopify briefly removes/replaces the cart host while quantities change.
    // Keep the selector alive during that redraw instead of deleting it.
    if (panel && !target) return panel.isConnected ? panel : null;
    if (!panel && target) {
      panel = document.createElement('section');
      panel.className = 'toa-free-gift'; panel.dataset.toaFreeGiftSelector = 'true'; panel.hidden = true;
    }
    if (panel && target && panel.parentElement !== target) panel.remove();
    if (panel && target) {
      const shippingPanel = target.querySelector('.toa-cart-conversion-panel[data-toa-cart-panel]');
      const productList = target.querySelector('.toa-cart-products-list, .cart-items.plain');
      if (shippingPanel) {
        if (panel.parentElement !== shippingPanel.parentElement || shippingPanel.nextElementSibling !== panel) {
          shippingPanel.insertAdjacentElement('afterend', panel);
        }
      } else if (productList) {
        if (panel.parentElement !== productList.parentElement || productList.nextElementSibling !== panel) {
          productList.insertAdjacentElement('afterend', panel);
        }
      } else if (!panel.isConnected) {
        target.append(panel);
      }
    }
    return panel;
  };

  const toaGiftLockIcon = () => '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="3"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path><path d="M12 14v3"></path></svg>';

  const render = cart => {
    latestCart = cart;
    updateCartIndicators(cart);
    consolidateRenderedCartLines(cart);
    const panel = ensurePanel();
    if (!panel) return;
    const subtotal = eligibleSubtotal(cart);
    const requiredGiftCount = giftCountForSubtotal(subtotal);
    const premiumTier = requiredGiftCount === cfg.premiumTierGiftCount;
    lastRenderedCartToken = `${String(cart?.token || '')}|${subtotal}|${Number(cart?.item_count || 0)}`;
    const remembered = rememberedGiftVariants().slice(0, requiredGiftCount || cfg.maxGiftsPerOrder);
    const selected = new Set(remembered);
    // Keep the reward visible as an incentive from the first cart item. The
    // choices stay locked until the configured order-value threshold is met.
    panel.hidden = !cfg.enabled || !cfg.candidates.length;
    if (panel.hidden) return;
    const signature = `${subtotal}|${requiredGiftCount}|${Array.from(selected).sort().join(',')}`;
    if (panel.dataset.signature === signature && panel.children.length) return;
    panel.dataset.signature = signature;
    const unlocked = requiredGiftCount > 0;
    panel.classList.toggle('is-unlocked', unlocked);
    if (!unlocked) {
      const remaining = Math.max(0, cfg.firstGiftThresholdCents - subtotal);
      const progress = Math.max(0, Math.min(100, Math.round(subtotal / cfg.firstGiftThresholdCents * 100)));
      const heroGift = cfg.candidates[0];
      panel.innerHTML = `<div class="toa-free-gift__locked-head"><div><strong>Dein erstes Geschenk wartet</strong><span>Noch ${money(remaining)} bis zur Freischaltung</span></div><span class="toa-free-gift__lock" aria-label="Noch gesperrt">${toaGiftLockIcon()}</span></div><div class="toa-free-gift__locked-hero"><div class="toa-free-gift__locked-copy"><b>${heroGift.title}</b><em>Gratis ab ${money(cfg.firstGiftThresholdCents)}</em><span>Wertvolles Extra f&uuml;r deinen Einkauf</span><small>Ab ${money(cfg.firstGiftThresholdCents)} w&auml;hlst du 1 aus ${cfg.candidates.length}. Ab ${money(cfg.premiumGiftThresholdCents)} sogar ${cfg.premiumTierGiftCount} aus ${cfg.candidates.length}.</small></div><div class="toa-free-gift__locked-image"><img src="${heroGift.image}" alt="${heroGift.title}"><span class="toa-free-gift__image-lock" aria-hidden="true">${toaGiftLockIcon()}</span></div></div><div class="toa-free-gift__progress-labels"><span>${money(subtotal)}</span><span>${money(cfg.firstGiftThresholdCents)}</span></div><div class="toa-free-gift__progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}"><span style="width:${progress}%"></span></div><p class="toa-free-gift__locked-note">Dein erstes Geschenk wird bei ${money(cfg.firstGiftThresholdCents)} freigeschaltet.</p><div class="toa-free-gift__preview">${cfg.candidates.map(gift => `<img src="${gift.image}" alt="" title="${gift.title}">`).join('')}<span>Diese ${cfg.candidates.length} Geschenke stehen zur Auswahl.</span></div><a class="toa-free-gift__discover" href="/collections/all">Passende Produkte entdecken</a>`;
      return;
    }
    const nextTierRemaining = Math.max(0, cfg.premiumGiftThresholdCents - subtotal);
    const tierProgress = premiumTier ? 100 : Math.max(0, Math.min(100, Math.round(subtotal / cfg.premiumGiftThresholdCents * 100)));
    const tierTitle = premiumTier ? 'Wähle deine 3 Gratisgeschenke' : 'Wähle dein Gratisgeschenk';
    const remainingChoices = Math.max(0, requiredGiftCount - selected.size);
    const selectionStatus = remainingChoices === 0
      ? `${requiredGiftCount === 1 ? 'Dein Geschenk kommt' : 'Alle 3 Geschenke kommen'} kostenlos mit deiner Bestellung. Zum Tauschen erst ein Geschenk abwählen.`
      : `${remainingChoices === 1 ? 'Noch 1 Geschenk' : `Noch ${remainingChoices} Geschenke`} auswählen. Deine Auswahl kommt kostenlos mit deiner Bestellung.`;
    const selectedGifts = remembered.map(id => cfg.candidates.find(gift => String(gift.variantId) === String(id))).filter(Boolean);
    const slots = Array.from({length:requiredGiftCount}, (_, index) => {
      const gift = selectedGifts[index];
      return `<div class="toa-gift-slot${gift ? ' is-filled' : ''}">${gift ? `<img src="${gift.image}" alt="${gift.title}"><span>Ausgewählt ✓</span>` : `<b>${index + 1}</b><span>Noch wählen</span>`}</div>`;
    }).join('');
    panel.innerHTML = `<div class="toa-free-gift__head toa-free-gift__head--unlocked"><span class="toa-free-gift__gift-icon" aria-hidden="true">${requiredGiftCount}</span><div><div class="toa-free-gift__title"><strong>${tierTitle}</strong></div><span class="toa-free-gift__subline">${premiumTier ? 'Ab 100 € Warenwert: 3 Produkte gratis dazu.' : 'Ab 49 € Warenwert: 1 Produkt gratis dazu.'}</span></div></div><div class="toa-gift-slots" style="--gift-slots:${requiredGiftCount}" aria-label="${selected.size} von ${requiredGiftCount} Geschenken ausgewählt">${slots}</div><p class="toa-gift-choice-count" role="status" aria-live="polite">${selected.size} von ${requiredGiftCount} ausgewählt${remainingChoices ? ' – unten aussuchen' : ' – alles bereit ✓'}</p><div class="toa-free-gift__grid"></div><p class="toa-free-gift__status">${selectionStatus}</p>${premiumTier ? '' : `<p class="toa-gift-next-tier">Noch ${money(nextTierRemaining)} bis zu 3 Gratisgeschenken.</p>`}`;
    const grid = panel.querySelector('.toa-free-gift__grid');
    for (const gift of cfg.candidates) {
      const chosen = selected.has(String(gift.variantId));
      const card = document.createElement('button');
      card.type = 'button';
      card.dataset.giftVariant = String(gift.variantId);
      card.className = `toa-free-gift__card${chosen ? ' is-selected' : ''}`;
      card.setAttribute('aria-pressed', chosen ? 'true' : 'false');
      card.setAttribute('aria-label', `${gift.title}: ${chosen ? 'ausgewählt' : 'gratis auswählen'}`);
      card.innerHTML = `<img src="${gift.image}" alt=""><span><b>${gift.title}</b><small>${chosen ? 'Ausgew&auml;hlt &middot; 0,00 &euro;' : 'Gratis ausw&auml;hlen'}</small></span><span class="toa-free-gift__state" aria-hidden="true">&#10003;</span>`;
      card.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const variantId = String(gift.variantId);
        const next = rememberedGiftVariants();
        const existingIndex = next.indexOf(variantId);
        if (existingIndex >= 0) next.splice(existingIndex, 1);
        else {
          if (next.length >= requiredGiftCount) {
            const status = panel.querySelector('.toa-gift-choice-count');
            if (status) status.textContent = 'Zum Tauschen erst ein ausgewähltes Geschenk abwählen.';
            return;
          }
          next.push(variantId);
        }
        rememberGiftVariants(next);
        panel.dataset.signature = '';
        render(cart);
      });
      grid.appendChild(card);
    }
  };
  let refreshRunning = false;
  const refresh = async () => {
    if (refreshRunning || checkoutGiftBusy) return;
    if (busy) { schedule(180); return; }
    try {
      refreshRunning = true;
      let cart = await cartJson();
      if (checkoutGiftBusy) return;
      cart = await enforce(cart);
      render(cart);
    } catch (_) {} finally { refreshRunning = false; }
  };
  // The theme continuously mutates carousels and counters. Debouncing by
  // resetting the timer can therefore postpone the selector forever.
  // Throttle instead: the first signal always gets a guaranteed refresh.
  const schedule = delay => {
    if (refreshTimer) return;
    refreshTimer = setTimeout(() => { refreshTimer = null; refresh(); }, delay || 100);
  };
  // One real cart mutation gets one delayed refresh. Rebuilding the drawer
  // repeatedly makes quantity controls jump and can recursively trigger theme
  // cart events.
  const reconcileCart = async () => {
    if (checkoutGiftBusy) return;
    if (reconcileRunning) { reconcileRequested = true; return; }
    if (busy || giftQuantityMutation || duplicateMergeBusy) {
      scheduleAfterCartMutation(260);
      return;
    }
    reconcileRunning = true;
    duplicateMergeBusy = true;
    try {
      const before = await cartJson();
      const eligible = await enforce(before);
      const after = eligible;
      latestCart = after;
      updateCartIndicators(after);
      if (cartLineSignature(after) !== cartLineSignature(before)) refreshCartViewOnce();
      render(after);
    } catch (_) {
      schedule(180);
    } finally {
      duplicateMergeBusy = false;
      reconcileRunning = false;
      if (reconcileRequested) {
        reconcileRequested = false;
        scheduleAfterCartMutation(180);
      }
    }
  };
  const scheduleAfterCartMutation = delay => {
    if (trailingRefreshTimer) clearTimeout(trailingRefreshTimer);
    trailingRefreshTimer = setTimeout(() => {
      trailingRefreshTimer = null;
      reconcileCart();
    }, Number(delay || 320));
  };
  const checkoutTarget = target => target?.closest?.(
    'button[name="checkout"],input[name="checkout"],a[href="/checkout"],a[href^="/checkout?"],.cart-summary__checkout,[data-toa-checkout]'
  );
  const beginCheckout = async event => {
    const trigger = checkoutTarget(event.submitter || event.target);
    if (!trigger || checkoutGiftBusy) return;
    const selectedVariants = rememberedGiftVariants();
    const snapshotRequiredCount = giftCountForSubtotal(eligibleSubtotal(latestCart));
    if (!selectedVariants.length && snapshotRequiredCount === 0) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    checkoutGiftBusy = true;
    busy = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.disabled = true;
    try {
      let cart = await cartJson();
      const subtotal = eligibleSubtotal(cart);
      const requiredGiftCount = giftCountForSubtotal(subtotal);
      if (requiredGiftCount === 0) {
        rememberGiftVariants([]);
        if ((cart.items || []).some(isGift)) await removeAllGifts(cart);
        window.location.assign('/checkout');
        return;
      }
      const configuredVariants = new Set(cfg.candidates.map(item => String(item.variantId)));
      const validVariants = selectedVariants
        .filter(variantId => configuredVariants.has(String(variantId)))
        .slice(0, requiredGiftCount);
      if (validVariants.length !== selectedVariants.length) rememberGiftVariants(validVariants);
      if ((cart.items || []).some(isGift)) {
        await removeAllGifts(cart);
        cart = await cartJson();
      }
      await setGifts(cart, validVariants);
      window.location.assign('/checkout');
    } catch (error) {
      checkoutGiftBusy = false;
      busy = false;
      trigger.removeAttribute('aria-busy');
      trigger.disabled = false;
      showCartError(error);
      schedule(80);
    }
  };
  document.addEventListener('click', beginCheckout, true);
  document.addEventListener('submit', event => {
    if (event.submitter && checkoutTarget(event.submitter)) beginCheckout(event);
  }, true);
  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const url = String(args[0]?.url || args[0] || '');
      if (!giftQuantityMutation && !duplicateMergeBusy && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) {
        try {
          response.clone().json().then(cart => {
            if (cart && Array.isArray(cart.items)) updateCartIndicators(cart);
          }).catch(() => {});
        } catch (_) {}
        scheduleAfterCartMutation();
      }
      return response;
    };
  }
  // A few Shopify theme components still use XMLHttpRequest instead of fetch.
  // Observe those mutations as well; otherwise duplicate lines can survive
  // depending on which add-to-cart button was used.
  if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__toaCartMergeObserved) {
    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function(method, url, ...rest) {
      this.__toaCartMutation = /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(String(url || ''));
      return originalOpen.call(this, method, url, ...rest);
    };
    window.XMLHttpRequest.prototype.send = function(...args) {
      if (this.__toaCartMutation) this.addEventListener('loadend', () => {
        if (!giftQuantityMutation && !duplicateMergeBusy) {
          try {
            const cart = JSON.parse(this.responseText || '{}');
            if (cart && Array.isArray(cart.items)) updateCartIndicators(cart);
          } catch (_) {}
          scheduleAfterCartMutation();
        }
      }, {once:true});
      return originalSend.apply(this, args);
    };
    window.XMLHttpRequest.prototype.__toaCartMergeObserved = true;
  }
  document.addEventListener('cart:refresh', () => { if (!giftQuantityMutation) schedule(40); });
  document.addEventListener('cart:updated', () => { if (!giftQuantityMutation) schedule(80); });
  document.addEventListener('cart:change', () => { if (!giftQuantityMutation) schedule(40); });
  document.addEventListener('theme:cart:updated', () => { if (!giftQuantityMutation) schedule(40); });
  document.addEventListener('toa:cart-confirmed', event => {
    const cart = event?.detail?.cart;
    if (!cart || busy) return;
    const subtotal = eligibleSubtotal(cart);
    const token = `${String(cart?.token || '')}|${subtotal}|${Number(cart?.item_count || 0)}`;
    // Reapply after theme HTML replacement, even when quantities are unchanged.
    render(cart);
  });
  window.addEventListener('toa:logical-step', event => {
    const step = event.detail?.step;
    if (!step) return;
    window.__toaStepSeen = Date.now();
    step.setAttribute('data-toa-step-seen', String(Date.now()));
    // Prefer the explicitly marked inner gift row. Some theme layouts wrap it
    // in a second cart container; choosing that outer container loses the gift
    // identity and lets Shopify turn quantity 1 into a paid quantity 2.
    const giftLine = step.closest('[data-toa-free-gift="true"]');
    const line = giftLine || step.closest('.cart-summary-item-container, .cart-summary-item, li.cart-item, [data-cart-item], .ajaxcart__product');
    if (!line) return;
    const adjuster = step.closest('.qty-adjuster, .quantity, [data-quantity-wrapper]');
    const quantityInput = renderedQuantityInput(line);
    const rawVariantId = line.dataset.toaLogicalVariant || adjuster?.getAttribute('data-line-item-id') || line.getAttribute('data-product-id') || line.getAttribute('data-variant-id') || '';
    const rawLineKey = renderedLineKey(line, latestCart);
    const giftItems = (latestCart?.items || []).filter(isGift);
    const mutableItems = (latestCart?.items || []).filter(item => canMerge(item));
    const markedGiftKey = String(line.dataset.toaGiftKey || '');
    const exactItem = (latestCart?.items || []).find(item =>
      (!!markedGiftKey && String(item.key) === markedGiftKey) ||
      (!!rawLineKey && String(item.key) === String(rawLineKey))
    );
    const isMarkedGiftLine = String(line.dataset.toaFreeGift || '') === marker;
    const looksLikeGiftLine = isGift(exactItem) || isMarkedGiftLine;
    const markedGiftVariant = String(line.dataset.toaGiftVariant || '');
    const giftItem = looksLikeGiftLine ? (isGift(exactItem) ? exactItem : giftItems.find(item =>
      markedGiftKey ? String(item.key) === markedGiftKey : String(item.variant_id) === markedGiftVariant
    )) : null;
    const mutableItem = !looksLikeGiftLine
      ? (canMerge(exactItem) ? exactItem : mutableItems.find(item =>
          !!rawVariantId && String(item.variant_id) === String(rawVariantId) &&
          logicalLineClass(item) === String(line.dataset.toaLogicalClass || 'merchandise')
        ))
      : null;
    if ((!giftItem || !looksLikeGiftLine) && (!mutableItem || looksLikeGiftLine)) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const isIncrease = step.matches('[data-toa-logical-plus="true"]');
    const delta = isIncrease ? 1 : -1;
    if (cartControlBusy) {
      if (!looksLikeGiftLine && mutableItem) {
        const queueKey = `${String(mutableItem.variant_id)}|${logicalLineClass(mutableItem)}`;
        queuedPaidDeltas.set(queueKey, Number(queuedPaidDeltas.get(queueKey) || 0) + delta);
        if (quantityInput) quantityInput.value = String(Math.max(0, Number(quantityInput.value || mutableItem.quantity || 0) + delta));
      }
      return;
    }
    cartControlBusy = true;
    busy = true;
    updateCartCountOptimistically(Number(latestCart?.item_count || 0) + delta);
    giftQuantityMutation = true;
    suppressThemeQuantityUntil = Date.now() + 3000;
    line.classList.add('is-updating');
    const action = looksLikeGiftLine
      ? (isIncrease ? purchaseExtraFromGift(giftItem) : changeLine(giftItem.key, 0))
      : setLogicalQuantity(latestCart, mutableItem,
          logicalLineGroup(latestCart, mutableItem).reduce((sum, item) => sum + Number(item.quantity || 0), 0) + delta);
    if (!looksLikeGiftLine && quantityInput) {
      const total = logicalLineGroup(latestCart, mutableItem).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      quantityInput.value = String(Math.max(0, total + delta));
    }
    action
      .then(() => cartJson())
      .then(cart => stabilizeGiftDiscountLine(cart))
      .then(async cart => {
        latestCart = cart;
        while (queuedPaidDeltas.size) {
          const queued = Array.from(queuedPaidDeltas.entries());
          queuedPaidDeltas.clear();
          for (const [queueKey, queuedDelta] of queued) {
            const [variantId, lineClass] = String(queueKey).split('|');
            const current = (latestCart.items || []).find(item =>
              canMerge(item) && String(item.variant_id) === String(variantId) &&
              logicalLineClass(item) === String(lineClass || 'merchandise')
            );
            if (!current || !queuedDelta) continue;
            const total = logicalLineGroup(latestCart, current).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            await setLogicalQuantity(latestCart, current, Math.max(0, total + Number(queuedDelta)));
            latestCart = await stabilizeGiftDiscountLine(await cartJson());
          }
        }
        render(latestCart);
        window.toaCartState.replay();
        setTimeout(refreshCartViewOnce, 80);
      })
      .catch(error => {
        window.__toaLastActionError = String(error?.stack || error || 'Unbekannter Warenkorbfehler');
        showCartError(error);
        queuedPaidDeltas.clear();
        schedule(80);
      })
      .finally(() => {
        giftQuantityMutation = false;
        cartControlBusy = false;
        busy = false;
        line.classList.remove('is-updating');
      });
  }, true);
  window.addEventListener('toa:logical-remove', event => {
    const removeButton = event.detail?.removeButton;
    if (!removeButton) return;
    const giftLine = removeButton.closest('[data-toa-free-gift="true"]');
    const line = giftLine || removeButton.closest('.cart-summary-item-container, .cart-summary-item, li.cart-item, [data-cart-item], .ajaxcart__product');
    if (!line || cartControlBusy) return;
    const item = resolveRenderedItem(line, latestCart, true);
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    cartControlBusy = true;
    busy = true;
    const removedQuantity = isGift(item)
      ? Number(item.quantity || 1)
      : logicalLineGroup(latestCart, item).reduce((sum, entry) => sum + Number(entry.quantity || 0), 0);
    updateCartCountOptimistically(Number(latestCart?.item_count || 0) - removedQuantity);
    giftQuantityMutation = true;
    suppressThemeQuantityUntil = Date.now() + 3000;
    line.classList.add('is-updating');
    const action = isGift(item)
      ? changeLine(item.key, 0)
      : setLogicalQuantity(latestCart, item, 0);
    action
      .then(cart => stabilizeGiftDiscountLine(cart))
      .then(cart => { render(cart); window.toaCartState.replay(); setTimeout(refreshCartViewOnce, 80); })
      .catch(error => { showCartError(error); schedule(80); })
      .finally(() => {
        giftQuantityMutation = false;
        cartControlBusy = false;
        busy = false;
        line.classList.remove('is-updating');
      });
  }, true);
  window.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    const input = event.target?.closest?.('.cart-summary input, li.cart-item input');
    if (!input?.matches?.(quantityInputSelector)) return;
    const desired = Math.max(0, Math.floor(Number(String(input.value || '').replace(',', '.'))));
    if (!Number.isFinite(desired)) return;
    const line = input.closest('.cart-summary-item-container, .cart-summary-item, li.cart-item, [data-cart-item], .ajaxcart__product');
    if (!line || cartControlBusy) return;
    const item = resolveRenderedItem(line, latestCart, false);
    if (!item) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    cartControlBusy = true;
    busy = true;
    const previousQuantity = logicalLineGroup(latestCart, item).reduce((sum, entry) => sum + Number(entry.quantity || 0), 0);
    updateCartCountOptimistically(Number(latestCart?.item_count || 0) + desired - previousQuantity);
    giftQuantityMutation = true;
    suppressThemeQuantityUntil = Date.now() + 3000;
    line.classList.add('is-updating');
    input.value = String(desired);
    delete input.dataset.toaQuantityEditing;
    input.dataset.toaQuantityCommitted = String(desired);
    input.dataset.toaQuantityCommitUntil = String(Date.now() + 2500);
    setLogicalQuantity(latestCart, item, desired)
      .then(cart => stabilizeGiftDiscountLine(cart))
      .then(cart => { render(cart); window.toaCartState.replay(); setTimeout(refreshCartViewOnce, 80); })
      .catch(error => { showCartError(error); schedule(80); })
      .finally(() => {
        giftQuantityMutation = false;
        cartControlBusy = false;
        busy = false;
        line.classList.remove('is-updating');
      });
  }, true);
  document.addEventListener('focusin', event => {
    const input = event.target?.closest?.('.cart-summary input, li.cart-item input');
    if (!input?.matches?.(quantityInputSelector) || input.closest('[data-toa-free-gift="true"]')) return;
    input.dataset.toaQuantityEditing = 'true';
    input.readOnly = false;
    input.removeAttribute('readonly');
    input.removeAttribute('maxlength');
    input.setAttribute('max', '9999');
  }, true);
  document.addEventListener('focusout', event => {
    const input = event.target?.closest?.('.cart-summary input, li.cart-item input');
    if (!input?.matches?.(quantityInputSelector)) return;
    setTimeout(() => { delete input.dataset.toaQuantityEditing; }, 150);
  }, true);
  // Shopify themes often commit quantity inputs again on keyup/change. That
  // second line-based write is what turns a logical quantity such as 9 into
  // two rows such as 5+4. Swallow only the duplicate event that follows our
  // atomic Enter update; normal typing and later edits remain untouched.
  const suppressCommittedQuantityEvent = event => {
    const input = event.target?.closest?.('.cart-summary input, li.cart-item input');
    if (!input?.matches?.(quantityInputSelector)) return;
    const until = Math.max(Number(input.dataset.toaQuantityCommitUntil || 0), suppressThemeQuantityUntil);
    const committed = String(input.dataset.toaQuantityCommitted || '');
    if (Date.now() > until) return;
    if (committed && String(input.value || '') !== committed && event.type !== 'change') return;
    if (event.type === 'keyup' && event.key !== 'Enter') return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };
  window.addEventListener('keyup', suppressCommittedQuantityEvent, true);
  window.addEventListener('change', suppressCommittedQuantityEvent, true);
  window.addEventListener('input', event => {
    if (Date.now() <= suppressThemeQuantityUntil && event.target?.matches?.('.cart-summary input[name^="updates["], li.cart-item input[name^="updates["]')) {
      event.stopImmediatePropagation();
    }
  }, true);
  let renderedRowsTimer = null;
  new MutationObserver(records => {
    const cartRowSelector = '.cart-summary-item-container, li.cart-item, [data-cart-item], .ajaxcart__product, .cart-summary-item';
    const containsNewCartRow = records.some(record => Array.from(record.addedNodes || []).some(node =>
      node.nodeType === 1 && (node.matches?.(cartRowSelector) || node.querySelector?.(cartRowSelector))
    ));
    if (!containsNewCartRow) return;
    if (renderedRowsTimer) return;
    renderedRowsTimer = setTimeout(() => {
      renderedRowsTimer = null;
      consolidateRenderedCartLines(latestCart);
    }, 120);
  }).observe(document.documentElement, {childList:true, subtree:true});
  style();
  schedule(100);
  // Cart drawers are rebuilt by the theme without consistently emitting a
  // cart event. This small visibility check makes the selector deterministic
  // after every open/reopen while doing no network work when the cart is shut.
  let lastVisibleCartHost = null;
  setInterval(() => {
    const target = host();
    if (!target) { lastVisibleCartHost = null; return; }
    const panel = document.querySelector('[data-toa-free-gift-selector="true"]');
    if (!panel || !panel.isConnected || panel.parentElement !== target || lastVisibleCartHost !== target) {
      if (latestCart) render(latestCart);
    }
    lastVisibleCartHost = target;
  }, 600);
  // Mobile browsers can restore an already-open cart from the back-forward
  // cache. Refresh once on resume so the 100 EUR state and selection are not
  // left at the value from before checkout/navigation.
  window.addEventListener('pageshow', () => schedule(20));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule(20);
  });
  // Also reconcile a cart that Shopify already split before this script loaded
  // or during a full drawer/page rebuild.
  scheduleAfterCartMutation();
})();

/* TOA FREE GIFT SELECTOR END */

/* TOA CART GIFT VISUAL ORDER START */
(function () {
  if (document.getElementById('toa-cart-gift-visual-order-style')) return;
  var style = document.createElement('style');
  style.id = 'toa-cart-gift-visual-order-style';
  style.textContent = `
    .toa-cart-conversion-panel--after-products{order:0!important}
    .cart-summary.toa-cart-drawer-upgraded .cart-summary__inner{box-sizing:border-box!important;padding-top:72px!important;scroll-padding-top:72px!important}
    .cart-summary.toa-cart-drawer-upgraded .cart-summary__item-list{order:1!important}
    .cart-summary.toa-cart-drawer-upgraded .cart-summary__inner>.cart-form--checkout{order:2!important}
    .toa-free-gift{border-color:#dfbd78!important;border-radius:24px!important;background:linear-gradient(145deg,#fffdf7 0%,#fff8e9 100%)!important;box-shadow:0 16px 38px rgba(70,46,19,.10)!important}
    .toa-free-gift__locked-head{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin-bottom:18px}
    .toa-free-gift__locked-head>div{min-width:0}.toa-free-gift__locked-head strong{display:block;color:#103c28;font-family:Georgia,serif;font-size:clamp(25px,4vw,38px);line-height:1.08}
    .toa-free-gift__locked-head span:not(.toa-free-gift__lock){display:block;margin-top:7px;color:#c21820;font-size:clamp(14px,2.4vw,18px);font-weight:800}
    .toa-free-gift__lock,.toa-free-gift__image-lock{display:grid;place-items:center;flex:0 0 auto;border:1px solid #d7ae58;border-radius:999px;background:#fffdf8;color:#b88322;box-shadow:0 8px 22px rgba(100,68,15,.13)}
    .toa-free-gift__lock{width:52px;height:52px}.toa-free-gift__lock svg{width:27px;height:27px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
    .toa-free-gift__locked-hero{display:grid;grid-template-columns:minmax(0,1fr) minmax(150px,42%);gap:18px;align-items:center;padding:4px 0 14px}
    .toa-free-gift__locked-copy b{display:block;color:#123f2a;font-size:clamp(17px,3vw,24px);line-height:1.22}.toa-free-gift__locked-copy em{display:block;margin-top:7px;color:#c21820;font-size:16px;font-style:normal;font-weight:900}.toa-free-gift__locked-copy>span{display:block;margin-top:4px;color:#9a671b;font-weight:750}.toa-free-gift__locked-copy small{display:block;margin-top:12px;color:#4f5f55;line-height:1.42}
    .toa-free-gift__locked-image{position:relative;display:grid;place-items:center;min-height:160px}.toa-free-gift__locked-image>img{width:100%;height:178px;object-fit:contain;filter:drop-shadow(0 14px 18px rgba(35,53,34,.16))}
    .toa-free-gift__image-lock{position:absolute;left:50%;top:50%;width:56px;height:56px;transform:translate(-50%,-50%)}.toa-free-gift__image-lock svg{width:29px;height:29px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
    .toa-free-gift__progress-labels{display:flex;justify-content:space-between;margin:0 2px 7px;color:#123f2a;font-size:14px;font-weight:900}.toa-free-gift__progress{height:14px;overflow:hidden;border-radius:999px;background:linear-gradient(90deg,#e7dfcd,#efcb75)}.toa-free-gift__progress>span{display:block;height:100%;border-radius:inherit;background:linear-gradient(90deg,#123f2a,#287047);transition:width .25s ease}.toa-free-gift__progress.is-complete{margin-top:18px;background:#e0eadf}
    .toa-free-gift__locked-note{margin:12px 0 0;text-align:center;color:#46564d;font-size:14px}.toa-free-gift__preview{display:flex;align-items:center;justify-content:center;gap:0;margin-top:14px;color:#56675d;font-size:12px}.toa-free-gift__preview img{width:38px;height:38px;margin-right:-7px;border:2px solid #fff;border-radius:999px;background:#fff;object-fit:contain;box-shadow:0 3px 8px rgba(30,56,39,.12)}.toa-free-gift__preview span{margin-left:17px}
    .toa-free-gift__discover{display:flex;align-items:center;justify-content:center;min-height:48px;margin-top:15px;border:1.5px solid #123f2a;border-radius:999px;color:#123f2a!important;background:#fffdf8;text-decoration:none!important;font-weight:850}.toa-free-gift__discover:hover,.toa-free-gift__discover:focus-visible{background:#eef5eb;color:#123f2a!important}
    .toa-free-gift__head--unlocked .toa-free-gift__gift-icon{background:#0f5b31!important;color:#fff!important;border-color:#0f5b31!important}
    .cart-summary .toa-free-gift__head--unlocked{display:grid!important;grid-template-columns:52px minmax(0,1fr)!important;column-gap:14px!important;row-gap:0!important;align-items:center!important;margin-bottom:20px!important}
    .cart-summary .toa-free-gift__head--unlocked .toa-free-gift__gift-icon{grid-column:1;grid-row:1 / span 2;width:52px!important;height:52px!important;font-size:25px!important}
    .cart-summary .toa-free-gift__head--unlocked>div{grid-column:2;grid-row:1;min-width:0}
    .cart-summary .toa-free-gift__head--unlocked .toa-free-gift__title{display:block!important}
    .cart-summary .toa-free-gift__head--unlocked strong{display:block;font-size:23px!important;line-height:1.08!important;overflow-wrap:normal!important;word-break:normal!important}
    .cart-summary .toa-free-gift__head--unlocked .toa-free-gift__sparkles{display:none!important}
    .cart-summary .toa-free-gift__head--unlocked .toa-free-gift__subline{font-size:14px!important;line-height:1.4!important}
    .cart-summary .toa-free-gift__head--unlocked .toa-free-gift__badge{grid-column:2;grid-row:2;justify-self:start;margin-top:9px;padding:7px 11px!important;white-space:nowrap;font-size:12px!important}
    .cart-summary .toa-free-gift__grid{grid-template-columns:minmax(0,1fr)!important;gap:10px!important}
    .cart-summary .toa-free-gift__card{grid-template-columns:82px minmax(0,1fr) 34px!important;gap:14px!important;min-height:108px!important;padding:12px 14px!important;border-radius:16px!important;overflow:hidden}
    .cart-summary .toa-free-gift__card img{width:82px!important;height:82px!important;padding:4px;object-fit:contain!important;border-radius:12px;background:#fffdf8!important}
    .cart-summary .toa-free-gift__card>span:nth-child(2){display:block;min-width:0}
    .cart-summary .toa-free-gift__card b{font-size:16px!important;line-height:1.24!important;overflow-wrap:normal!important;word-break:normal!important;hyphens:auto}
    .cart-summary .toa-free-gift__card small{margin-top:8px!important;padding:6px 10px!important;font-size:12px!important;line-height:1.25!important;white-space:normal}
    .cart-summary .toa-free-gift__state{width:32px!important;height:32px!important;align-self:center}
    .cart-summary .toa-free-gift__card.is-selected{background:#f5fbf4!important}
    .cart-summary .toa-free-gift__card.is-selected small{background:#e4f2df!important;color:#0d5b2e!important}
    .cart-summary .toa-free-gift__progress.is-complete{height:10px!important;margin-top:16px!important}
    .cart-summary .toa-free-gift__status{margin:13px 2px 0!important;font-size:13px!important;line-height:1.45!important}
    @media(max-width:768px){
      .toa-free-gift{margin:12px!important;padding:18px!important;border-radius:20px!important}
      .toa-free-gift__locked-head strong{font-size:27px}.toa-free-gift__locked-head{gap:12px}.toa-free-gift__lock{width:46px;height:46px}.toa-free-gift__locked-hero{grid-template-columns:minmax(0,1fr) 43%;gap:10px}.toa-free-gift__locked-image{min-height:130px}.toa-free-gift__locked-image>img{height:142px}.toa-free-gift__locked-copy small{font-size:12px}.toa-free-gift__preview span{font-size:11px}.cart-summary.toa-cart-drawer-upgraded .toa-cart-checkout-block{order:0!important}
      .cart-summary.toa-cart-is-empty .cart-summary__inner{padding:78px 10px 26px!important;scroll-padding-top:78px!important}
      .cart-summary.toa-cart-is-empty .toa-cart-drawer-brand{display:flex!important;gap:7px!important;padding:8px 12px 10px!important;margin:0!important}
      .cart-summary.toa-cart-is-empty .toa-cart-drawer-brand img{width:68px!important;height:68px!important}
      .cart-summary.toa-cart-is-empty .toa-cart-drawer-brand span{font-size:13px!important;line-height:1.25!important}
      .cart-summary.toa-cart-is-empty .cart-summary__empty{margin:0 10px 8px!important}
      .cart-summary.toa-cart-is-empty .cart-summary__empty .cart-summary__section{margin:0!important;padding:13px 15px!important;border:1px solid rgba(234,217,191,.95)!important;border-radius:16px!important;background:#fffdf8!important;text-align:center!important}
      .cart-summary.toa-cart-is-empty .cart-summary__empty p{margin:0!important;color:#123f2a!important;font-size:16px!important;font-weight:800!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift{margin:10px!important;padding:16px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-head{margin-bottom:12px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-head strong{font-size:22px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-head span:not(.toa-free-gift__lock){font-size:13px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__lock{width:42px!important;height:42px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-hero{grid-template-columns:minmax(0,1fr) 100px!important;gap:8px!important;padding-bottom:10px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-image{min-height:112px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-image>img{height:112px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-copy b{font-size:16px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-copy em{font-size:14px!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__locked-copy small{font-size:11px!important;line-height:1.35!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__preview{margin-top:11px!important;justify-content:flex-start!important}
      .cart-summary.toa-cart-is-empty .toa-free-gift__discover{min-height:44px!important;margin-top:12px!important;font-size:13px!important}
    }
  `;
  document.head.appendChild(style);
  var pending = false;
  function enforceDrawerOrder() {
    pending = false;
    document.querySelectorAll('.cart-summary, form.cart-form').forEach(function (drawer) {
      if (drawer.classList && drawer.classList.contains('cart-summary')) {
        var inner = drawer.querySelector('.cart-summary__inner');
        var itemList = inner && inner.querySelector(':scope > .cart-summary__item-list');
        var checkoutForm = inner && inner.querySelector(':scope > .cart-form--checkout');
        if (inner && itemList && checkoutForm && itemList.nextElementSibling !== checkoutForm) {
          inner.insertBefore(itemList, checkoutForm);
        }
      }
      var products = drawer.querySelector('.toa-cart-products-list');
      if (!products) products = drawer.querySelector('.cart-items.plain');
      var shipping = drawer.querySelector('.toa-cart-conversion-panel[data-toa-cart-panel]');
      var gift = drawer.querySelector('[data-toa-free-gift-selector="true"]:not([hidden])');
      var checkoutButton = drawer.querySelector("button[name='checkout'],input[name='checkout'],a[href*='/checkout']");
      var checkout = checkoutButton && (checkoutButton.closest('.toa-cart-checkout-block,.cart-form--checkout,.cart-summary__button-row,.cart-summary__buttons') || checkoutButton);
      if (products && shipping && products.parentElement === shipping.parentElement && products.nextElementSibling !== shipping) products.insertAdjacentElement('afterend', shipping);
      if (shipping && gift && shipping.nextElementSibling !== gift) shipping.insertAdjacentElement('afterend', gift);
      var anchor = gift || shipping;
      if (anchor && checkout && anchor.parentElement === checkout.parentElement && anchor.nextElementSibling !== checkout) anchor.insertAdjacentElement('afterend', checkout);
    });
  }
  function scheduleOrder() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(enforceDrawerOrder);
  }
  new MutationObserver(scheduleOrder).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('cart:refresh',scheduleOrder);
  document.addEventListener('cart:updated',scheduleOrder);
  document.addEventListener('cart:change',scheduleOrder);
  scheduleOrder();
})();
/* TOA CART GIFT VISUAL ORDER END */

(function () {
  "use strict";
  if (window.__toaMobileControlReliability20260901) return;
  window.__toaMobileControlReliability20260901 = true;

  var controlSelector = [
    ".template-collection .product-block button",
    ".template-search .product-block button",
    ".cart-summary button",
    ".cart-summary [role='button']",
    ".toa-mobile-quick-actions__item",
    ".cc-product-filter button",
    ".cc-product-filter [role='button']"
  ].join(",");
  var startControl = null;
  var startIdentifier = null;
  var startX = 0;
  var startY = 0;
  var moved = false;
  var fallbackTimer = 0;

  function closestControl(target) {
    return target && target.closest ? target.closest(controlSelector) : null;
  }

  function clearFallback() {
    window.clearTimeout(fallbackTimer);
    fallbackTimer = 0;
  }

  function resetTouch() {
    startControl = null;
    startIdentifier = null;
    moved = false;
  }

  function matchingTouch(list) {
    for (var index = 0; index < list.length; index += 1) {
      if (list[index].identifier === startIdentifier) return list[index];
    }
    return null;
  }

  window.addEventListener("touchstart", function (event) {
    clearFallback();
    var control = closestControl(event.target);
    var touch = event.changedTouches && event.changedTouches[0];
    if (!control || !touch || control.disabled || control.getAttribute("aria-disabled") === "true") {
      resetTouch();
      return;
    }
    startControl = control;
    startIdentifier = touch.identifier;
    startX = touch.clientX;
    startY = touch.clientY;
    moved = false;
  }, {capture:true, passive:true});

  window.addEventListener("touchmove", function (event) {
    if (!startControl) return;
    var touch = matchingTouch(event.changedTouches || []);
    if (!touch) return;
    if (Math.abs(touch.clientX - startX) > 12 || Math.abs(touch.clientY - startY) > 12) moved = true;
  }, {capture:true, passive:true});

  window.addEventListener("touchcancel", function () {
    clearFallback();
    resetTouch();
  }, {capture:true, passive:true});

  window.addEventListener("touchend", function (event) {
    if (!startControl) return;
    var control = startControl;
    var touch = matchingTouch(event.changedTouches || []);
    var validTap = !moved && touch && closestControl(event.target) === control;
    resetTouch();
    if (!validTap) return;
    fallbackTimer = window.setTimeout(function () {
      fallbackTimer = 0;
      if (!document.documentElement.contains(control) || control.disabled || control.getAttribute("aria-disabled") === "true") return;
      HTMLElement.prototype.click.call(control);
    }, 260);
  }, {capture:true, passive:true});

  window.addEventListener("click", function (event) {
    if (!fallbackTimer) return;
    var clicked = closestControl(event.target);
    if (clicked) clearFallback();
  }, true);

  function repairFilterOverlay() {
    if (window.innerWidth > 767) return;
    var veil = document.querySelector(".cc-product-filter__mob-veil");
    var panel = document.querySelector(".cc-product-filter");
    if (!veil || !panel) return;
    var veilStyle = window.getComputedStyle(veil);
    if (veilStyle.display === "none" || veilStyle.visibility === "hidden" || veilStyle.pointerEvents === "none") return;
    var rect = panel.getBoundingClientRect();
    if (rect.width > 0 && rect.right > 8 && rect.left < window.innerWidth - 8) return;
    var close = panel.querySelector(".cc-product-filter__close, [aria-label='Schließen'], [data-filter-close]");
    if (close) HTMLElement.prototype.click.call(close);
    else veil.style.pointerEvents = "none";
  }

  function scheduleOverlayRepair() {
    window.setTimeout(repairFilterOverlay, 1800);
  }

  var style = document.createElement("style");
  style.id = "toa-mobile-control-reliability-20260901";
  style.textContent = "@media(max-width:767px){.template-collection .product-block button,.template-search .product-block button,.cart-summary button,.cart-summary [role='button'],.toa-mobile-quick-actions__item,.cc-product-filter button,.cc-product-filter [role='button']{touch-action:manipulation;-webkit-tap-highlight-color:transparent}}";
  document.head.appendChild(style);

  window.addEventListener("pageshow", scheduleOverlayRepair);
  window.addEventListener("resize", scheduleOverlayRepair);
  window.addEventListener("orientationchange", scheduleOverlayRepair);
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) scheduleOverlayRepair();
  });
  scheduleOverlayRepair();
})();

(function () {
  if (document.getElementById('toa-mobile-checkout-priority-20260913')) return;
  var style = document.createElement('style');
  style.id = 'toa-mobile-checkout-priority-20260913';
  style.textContent = `
[data-toa-cart-countdown-line]{display:none!important}
#cart-summary .toa-checkout-button-total,#cart-summary .toa-checkout-button-separator{display:none!important}
@media(min-width:0px){
 #cart-summary.toa-cart-drawer-upgraded:has(button[name="checkout"]){overflow:clip!important;padding:0!important}
 #cart-summary.toa-cart-drawer-upgraded:has(button[name="checkout"]) .cart-summary__inner{position:static!important;display:block!important;height:100%!important;max-height:100%!important;overflow-x:hidden!important;overflow-y:auto!important;padding:64px 0 calc(260px + env(safe-area-inset-bottom))!important;box-sizing:border-box!important}
 #cart-summary.toa-cart-drawer-upgraded .cart-summary__item-list{height:auto!important;max-height:none!important;overflow:visible!important;flex:none!important}
 #cart-summary.toa-cart-drawer-upgraded .cart-form--checkout{position:static!important;top:auto!important;transform:none!important}
 #cart-summary.toa-cart-drawer-upgraded .cart-summary__buttons{position:fixed!important;inset:auto 0 0!important;width:auto!important;margin:0!important;padding:10px 14px calc(12px + env(safe-area-inset-bottom))!important;z-index:100!important;background:#fffaf2!important;border:0!important;border-top:1px solid #d7dfd3!important;border-radius:0!important;box-shadow:0 -5px 20px #163e2a18!important;box-sizing:border-box!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-shipping-estimate{margin:0 0 8px!important;padding:0!important;background:transparent!important;border:0!important;box-shadow:none!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-shipping-estimate__row{font-size:12px!important;line-height:1.3!important;gap:8px!important;padding:3px 0!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-shipping-estimate__row--total{font-size:15px!important;padding-top:5px!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-shipping-estimate__note{font-size:10px!important;line-height:1.25!important;margin:4px 0 0!important}
 #cart-summary.toa-cart-drawer-upgraded button[name="checkout"]{min-height:50px!important;margin:0!important;width:100%!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel__brand,#cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel__trust{display:none!important}
 #cart-summary.toa-cart-drawer-upgraded .toa-cart-conversion-panel{margin-top:12px!important}
}
`;
  document.head.appendChild(style);
})();

(function () {
  var style = document.createElement('style');
  style.id = 'toa-cro-gift-compact-20260913';
  style.textContent = `
#cart-summary .toa-free-gift-selector{padding:14px!important}
#cart-summary [data-toa-free-gift-selector="true"]{padding:14px!important;margin:12px 14px!important;width:auto!important}
#cart-summary .toa-free-gift__head--unlocked{grid-template-columns:32px minmax(0,1fr)!important;gap:8px!important;margin-bottom:12px!important}
#cart-summary .toa-free-gift__head--unlocked .toa-free-gift__gift-icon{width:32px!important;height:32px!important;font-size:18px!important}
#cart-summary .toa-free-gift__head--unlocked strong{font-size:18px!important;line-height:1.2!important}
#cart-summary .toa-free-gift__subline{font-size:13px!important}
#cart-summary .toa-free-gift__card{grid-template-columns:52px minmax(0,1fr) 26px!important;gap:8px!important;padding:10px!important;min-height:78px!important;text-align:left!important}
#cart-summary .toa-free-gift__card img{width:52px!important;height:52px!important;padding:0!important}
#cart-summary .toa-free-gift__card b{font-size:14px!important;line-height:1.25!important;word-break:normal!important;overflow-wrap:normal!important;hyphens:none!important}
#cart-summary .toa-free-gift__card small{font-size:11px!important;line-height:1.2!important;margin-top:5px!important;padding:4px 6px!important}
#cart-summary .toa-free-gift__state{width:26px!important;height:26px!important;font-size:15px!important}
#cart-summary .toa-free-gift__locked-hero,#cart-summary .toa-free-gift__preview,#cart-summary .toa-free-gift__discover,#cart-summary .toa-free-gift__locked-note{display:none!important}
#cart-summary .toa-free-gift__locked-head{margin-bottom:12px!important}
#cart-summary .toa-free-gift__locked-head strong{font-size:17px!important}
#cart-summary .toa-free-gift__locked-head span{font-size:13px!important}
#cart-summary .toa-free-gift__status{font-size:12px!important;line-height:1.4!important}
`;
  document.head.appendChild(style);
})();

(function(){
  function repairCartPage(){
    if(document.body && document.body.matches('.template-cart.show-cart-summary') && !document.querySelector('#cart-summary')){
      document.body.classList.remove('show-cart-summary','product-added-to-cart');
    }
  }
  function start(){
    repairCartPage();
    if(document.body && document.body.classList.contains('template-cart'))new MutationObserver(repairCartPage).observe(document.body,{attributes:true,attributeFilter:['class']});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

(function(){var s=document.createElement("style");s.id="toa-cro-product-20260913";s.textContent="\n\n@media(max-width:767px){\n [data-section-type=\"product-template\"] .product-gallery{margin-bottom:12px!important}\n [data-section-type=\"product-template\"] .product-gallery .main .product-media--image .rimage-wrapper{padding-top:0!important;height:190px!important}\n [data-section-type=\"product-template\"] .product-gallery .main .product-media--image img{object-fit:contain!important;height:190px!important;max-height:190px!important;width:100%!important}\n [data-section-type=\"product-template\"] .product-gallery .thumbnails{margin-top:8px!important;margin-bottom:4px!important}\n [data-section-type=\"product-template\"] .product-gallery .thumbnail{width:42px!important}\n [data-section-type=\"product-template\"] .product-title{font-size:25px!important;line-height:1.15!important;margin-bottom:8px!important}\n [data-section-type=\"product-template\"] .product-detail__gap-sm{margin-bottom:8px!important}\n [data-section-type=\"product-template\"] .product-details{padding-top:0!important}\n [data-section-type=\"product-template\"] .product-title{padding:0!important}\n [data-section-type=\"product-template\"] .manufacturer_box{margin:4px 0!important;height:24px!important;font-size:12px!important}\n [data-section-type=\"product-template\"] .manufacturer_box img{width:24px!important;height:24px!important;object-fit:contain!important}\n [data-section-type=\"product-template\"] .icon_text_wrapper{margin:4px 0 8px!important;font-size:12px!important}\n [data-section-type=\"product-template\"] .product-price{padding-top:0!important}\n [data-section-type=\"product-template\"] .unit-price{font-size:13px!important;line-height:20px!important;margin-top:4px!important;padding:0!important}\n [data-section-type=\"product-template\"] .product-policies{padding:0!important;font-size:12px!important}\n [data-section-type=\"product-template\"] .product-inventory-notices{margin-bottom:8px!important;font-size:12px!important}\n [data-section-type=\"product-template\"] .payment-and-quantity button[type=\"submit\"]{min-height:54px!important;height:auto!important;padding:10px 8px!important;font-size:16px!important;line-height:1.1!important}\n}\n@media(max-width:767px) and (max-height:760px){\n [data-section-type=\"product-template\"] .product-gallery .main .product-media--image .rimage-wrapper,[data-section-type=\"product-template\"] .product-gallery .main .product-media--image img{height:120px!important;max-height:120px!important}\n}\n@media(min-width:768px){\n [data-section-type=\"product-template\"] .product-title{padding:0!important;margin-bottom:12px!important}\n [data-section-type=\"product-template\"] .manufacturer_box{margin:4px 0 8px!important;height:28px!important}\n [data-section-type=\"product-template\"] .manufacturer_box img{width:28px!important;height:28px!important;object-fit:contain!important}\n [data-section-type=\"product-template\"] .icon_text_wrapper{margin:6px 0 10px!important}\n [data-section-type=\"product-template\"] .product-gallery .main .product-media--image .rimage-wrapper{padding-top:0!important;height:420px!important}\n [data-section-type=\"product-template\"] .product-gallery .main .product-media--image img{object-fit:contain!important;height:420px!important;max-height:420px!important;width:100%!important}\n}\n\n";document.head.appendChild(s);})();

(function(){
 function init(){
  var form=document.querySelector('[data-section-type="product-template"] form.product-form');
  if(!form || document.getElementById('toa-product-buy-shortcut'))return;
  var original=form.querySelector('button[type="submit"]'),price=form.querySelector('.current-price');
  if(!original || !price)return;
  var bar=document.createElement('div');bar.id='toa-product-buy-shortcut';bar.hidden=true;
  var info=document.createElement('div'),amount=document.createElement('strong'),button=document.createElement('button');
  button.type='button';info.appendChild(amount);
  var policies=form.querySelector('.product-policies');
  if(policies){var copy=policies.cloneNode(true);copy.removeAttribute('id');copy.className='toa-product-buy-shortcut__policies';info.appendChild(copy);}
  bar.append(info,button);document.body.appendChild(bar);
  var style=document.createElement('style');style.textContent=`
  #toa-product-buy-shortcut{display:none}
  @media(max-width:767px){
   #toa-product-buy-shortcut:not([hidden]){position:fixed;z-index:999;left:8px;right:8px;bottom:calc(84px + env(safe-area-inset-bottom));display:flex;gap:10px;align-items:center;justify-content:space-between;background:#fffdf7;border:1px solid #c2d0be;border-radius:10px;padding:10px;box-shadow:0 -3px 16px #173f2720}
   #toa-product-buy-shortcut strong{font-size:18px;color:#17482d}
   #toa-product-buy-shortcut button{flex:0 0 48%;min-height:46px;padding:8px;font-size:14px;line-height:1.2;border:0;border-radius:8px;background:#17482d;color:white;cursor:pointer}
   #toa-product-buy-shortcut button:disabled{opacity:.5;cursor:default}
   .toa-product-buy-shortcut__policies{font-size:10px;line-height:1.2;margin-top:3px}
   body.show-cart-summary #toa-product-buy-shortcut,body:has(dialog[open]) #toa-product-buy-shortcut{display:none!important}
  }`;
  document.head.appendChild(style);
  function update(){
   var r=original.getBoundingClientRect();
   bar.hidden=innerWidth>767 || (r.top>=104 && r.bottom<=innerHeight-90);
   amount.textContent=price.textContent.trim();
   button.textContent=original.innerText.trim();
   button.disabled=original.disabled;
  }
  var pending=false;
  function schedule(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;update();});}
  button.addEventListener('click',function(){
   if(original.disabled)return;
   var options=form.querySelector('.option-selectors');
   if(options && options.getBoundingClientRect().height>0){options.scrollIntoView({block:'center',behavior:'smooth'});var field=options.querySelector('select,input,button');if(field)field.focus({preventScroll:true});return;}
   original.click();
  });
  window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
  new MutationObserver(schedule).observe(original,{attributes:true,childList:true,subtree:true});
  new MutationObserver(schedule).observe(price,{childList:true,subtree:true,characterData:true});
  new ResizeObserver(schedule).observe(form);
  update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* TOA MOBILE CART VIEWPORT 20260913 START */
(function () {
  'use strict';
  if (document.getElementById('toa-mobile-cart-viewport-style')) return;
  var style = document.createElement('style');
  style.id = 'toa-mobile-cart-viewport-style';
  style.textContent = `
@media (max-width:749px) {
  #cart-summary.toa-cart-drawer-upgraded {
    top:var(--toa-cart-visible-top,0px)!important;
    bottom:auto!important;
    height:100svh!important;
    height:var(--toa-cart-visible-height,100dvh)!important;
    max-height:var(--toa-cart-visible-height,100dvh)!important;
    padding:0!important;
    overflow:hidden!important;
    box-sizing:border-box!important;
  }
  #cart-summary.toa-cart-drawer-upgraded > .toa-cart-drawer-topbar {
    position:relative!important;
    top:auto!important;
    background:#fffaf2!important;
  }
  #cart-summary.toa-cart-drawer-upgraded .cart-summary__inner {
    position:static!important;
    display:block!important;
    min-height:0!important;
    height:calc(100% - var(--toa-cart-head-height,74px) - var(--toa-cart-foot-height,0px))!important;
    max-height:calc(100% - var(--toa-cart-head-height,74px) - var(--toa-cart-foot-height,0px))!important;
    padding:0 0 16px!important;
    scroll-padding:16px!important;
    overflow-x:hidden!important;
    overflow-y:auto!important;
    overscroll-behavior:contain;
    -webkit-overflow-scrolling:touch;
    box-sizing:border-box!important;
  }
  #cart-summary.toa-cart-drawer-upgraded:has(button[name="checkout"]) .cart-summary__inner {
    height:calc(100% - var(--toa-cart-head-height,74px) - var(--toa-cart-foot-height,230px))!important;
    max-height:calc(100% - var(--toa-cart-head-height,74px) - var(--toa-cart-foot-height,230px))!important;
    padding:0 0 16px!important;
  }
  /* Footer is a direct drawer child, outside the scrolling/clipping subtree. */
  #cart-summary.toa-cart-drawer-upgraded > .cart-summary__buttons {
    position:absolute!important;
    inset:auto 0 0!important;
    max-height:calc(100% - var(--toa-cart-head-height,74px) - 60px)!important;
    overflow-y:auto!important;
    overscroll-behavior:contain;
  }
}
`;
  document.head.appendChild(style);
  var mobile = window.matchMedia('(max-width:749px)');
  var pending = false;
  var observed = [];
  var observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  function setValue(drawer, name, value) {
    if (drawer.style.getPropertyValue(name) !== value) drawer.style.setProperty(name, value);
  }
  var detachedFooter = null;
  var formCounter = 0;
  function restoreFooter() {
    if (!detachedFooter) return;
    var state = detachedFooter;
    if (state.anchor.isConnected) state.anchor.replaceWith(state.foot);
    else state.foot.remove();
    state.controls.forEach(function (entry) {
      if (entry.value === null) entry.node.removeAttribute('form');
      else entry.node.setAttribute('form', entry.value);
    });
    detachedFooter = null;
  }
  function placeFooter(drawer) {
    if (!mobile.matches) { restoreFooter(); return; }
    // Discard stale controls when Shopify replaces the checkout form.
    if (detachedFooter && (!detachedFooter.form.isConnected || !detachedFooter.anchor.isConnected || detachedFooter.foot.parentElement !== drawer)) {
      restoreFooter();
    }
    if (detachedFooter) return;
    var foot = drawer.querySelector('.cart-summary__inner .cart-summary__buttons');
    var form = foot && foot.closest('form');
    if (!foot || !form) return;
    if (!form.id) form.id = 'toa-mobile-checkout-form-' + (++formCounter);
    var anchor = document.createComment('TOA checkout footer original position');
    var controls = Array.from(foot.querySelectorAll('button,input,select,textarea')).map(function (node) {
      var value = node.getAttribute('form');
      node.setAttribute('form', form.id);
      return {node:node,value:value};
    });
    foot.before(anchor);
    drawer.appendChild(foot);
    detachedFooter = {foot:foot,form:form,anchor:anchor,controls:controls};
  }
  function measure() {
    pending = false;
    var drawer = document.querySelector('#cart-summary.toa-cart-drawer-upgraded');
    if (!drawer) { restoreFooter(); return; }
    placeFooter(drawer);
    if (!mobile.matches) return;
    var viewport = window.visualViewport;
    // Do not resize the layout while the customer deliberately pinch-zooms.
    if (!viewport || Math.abs(viewport.scale - 1) < 0.01) {
      setValue(drawer, '--toa-cart-visible-height', (viewport ? viewport.height : window.innerHeight) + 'px');
      setValue(drawer, '--toa-cart-visible-top', (viewport ? viewport.offsetTop : 0) + 'px');
    }
    var head = drawer.querySelector('.toa-cart-drawer-topbar');
    var foot = drawer.querySelector('.cart-summary__buttons');
    var next = [head, foot].filter(Boolean);
    if (observer && (next.length !== observed.length || next.some(function (el, i) { return el !== observed[i]; }))) {
      observer.disconnect();
      next.forEach(function (el) { observer.observe(el); });
      observed = next;
    }
    // Closed drawers may be display:none. Keep their last valid measurements.
    if (head && head.getBoundingClientRect().height > 0) {
      setValue(drawer, '--toa-cart-head-height', Math.ceil(head.getBoundingClientRect().height) + 'px');
    }
    if (!foot) setValue(drawer, '--toa-cart-foot-height', '0px');
    else if (foot.getBoundingClientRect().height > 0) {
      setValue(drawer, '--toa-cart-foot-height', Math.ceil(foot.getBoundingClientRect().height) + 'px');
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(measure);
  }
  // Shopify replaces drawer contents after quantity and gift changes.
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('click', schedule);
  mobile.addEventListener('change', schedule);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, {passive:true});
    window.visualViewport.addEventListener('scroll', schedule, {passive:true});
  }
  schedule();
})();
/* TOA MOBILE CART VIEWPORT 20260913 END */

// Gift selection: clear entitlement, visible slots, explicit selection feedback.
(function(){
  var style=document.createElement('style');style.id='toa-gift-clarity-20261005';
  style.textContent=`
  .toa-gift-jump{display:block;width:100%;box-sizing:border-box;margin:12px 0 0;padding:12px 14px;border:0;border-radius:12px;background:#184b32;color:#fff;font:inherit;font-size:14px;font-weight:750;cursor:pointer;white-space:normal}
  #cart-summary .toa-free-gift.is-unlocked{background:#fffdf6!important;border:1px solid #d5ba7f!important;animation:none!important}
  #cart-summary .toa-free-gift__head--unlocked{grid-template-columns:44px minmax(0,1fr)!important;gap:12px!important;scroll-margin-top:82px}
  #cart-summary .toa-free-gift__head--unlocked .toa-free-gift__gift-icon{width:44px!important;height:44px!important;background:#184b32!important;color:#fff!important;border:0;font-size:28px!important;font-weight:800}
  #cart-summary .toa-free-gift__head--unlocked strong{font-size:21px!important;line-height:1.18!important}
  #cart-summary .toa-free-gift__subline{font-size:12px!important;line-height:1.4!important}
  .toa-gift-slots{display:grid;grid-template-columns:repeat(var(--gift-slots),minmax(0,1fr));gap:8px;margin:14px 0 0}
  .toa-gift-slot{display:grid;place-items:center;gap:5px;min-width:0;min-height:82px;padding:8px;box-sizing:border-box;border:1px dashed #b69e66;border-radius:12px;background:#f7f2e4;color:#53634e}
  .toa-gift-slot b{display:grid;place-items:center;width:38px;height:38px;border-radius:50%;background:#e7debf;font-size:22px;color:#506044}
  .toa-gift-slot img{width:42px;height:42px;object-fit:contain}#cart-summary .toa-gift-slot span{font-size:11px!important;line-height:1.25!important;font-weight:700;text-align:center;white-space:nowrap}
  .toa-gift-slot.is-filled{border:1px solid #477556;background:#edf6e9;color:#19482d}
  .toa-gift-choice-count{margin:10px 0 12px;font-size:13px;line-height:1.4;font-weight:750;color:#184b32}
  .toa-gift-next-tier{margin:12px 0 0;font-size:12px;color:#53634e}
  #cart-summary .toa-free-gift__status{padding:10px 12px!important;border-radius:10px;background:#edf5e8;font-size:12px!important;line-height:1.45!important}
  #cart-summary .toa-free-gift__status::before{display:none}
  @media(max-width:360px){#cart-summary .toa-free-gift__head--unlocked strong{font-size:18px!important}.toa-gift-slot{padding:6px}.toa-gift-slot span{font-size:10px}}
  `;document.head.appendChild(style);
})();
